/* == AP-ZEHN-A-0111 (01.11.2026): Familienbild 5 bis 10 Fotos mit Aufpreis-Position ==
   Kunstwerk bleibt Variante "4 Motive" (Preis-Freeze, 33 % gilt). Ab AP_ZEHN.ab Fotos legt apBuy die Position "Aufpreis Familienbild ·
   mehr Personen" (Produkt aufpreis-familienbild, SKU AP-AUFPREIS-5-7 / AP-AUFPREIS-8-10) mit in den Warenkorb: gemeinsame Eigenschaft
   _ap_gruppe, Aufpreis zusaetzlich _ap_aufpreis = 1, beide sichtbar Fotos/Photos = Anzahl. Ohne das Produkt bleibt alles bei 4 Fotos.
   Regel 0.21 (alles in 1 Minute aenderbar): Betraege NUR im Shopify-Produkt, Grenzen NUR in den Theme-Einstellungen
   (Gruppe "Familienbild 5 bis 10 Fotos"), Texte NUR in locales arturell.zehn.* (Sprache bearbeiten). Alles kommt per Liquid
   als window.AP_AUFPREIS = {v, c, t} (sections/arturell-family-v1.liquid). Hier stehen nur Ersatzwerte, falls etwas fehlt. */
(function(){
  var Z = window.AP_AUFPREIS || {}, C = Z.c || {}, G = C.gr || {}, A = {}, ok = false;
  function zahl(x, d){ x = parseInt(x, 10); return x > 0 ? x : d; }
  var K = window.AP_ZEHN = { ab:zahl(C.ab, 5), s2:zahl(C.s2, 8), max:zahl(C.max, 10), pers:zahl(C.pers, 10), text:(C.text === 'B' ? 'B' : 'A'),
                             gr:{ s:zahl(G.s, 4), m:zahl(G.m, 7), l:zahl(G.l, 10), xl:zahl(G.xl, 10) } };
  try { var q = /[?&]auftext=([AB])/.exec(location.search); if (q && String(window.Shopify && Shopify.theme && Shopify.theme.id) === '192464027914') K.text = q[1]; } catch(e){}
  try { (Z.v || []).forEach(function(x){ var k = x[1] === 'AP-AUFPREIS-5-7' ? '5-7' : (x[1] === 'AP-AUFPREIS-8-10' ? '8-10' : ''); if (k && x[0] && x[2] > 0) A[k] = { id:String(x[0]), cent:x[2] }; }); ok = !!(A['5-7'] && A['8-10']); } catch(e){}
  window.AP_GR_KOEPFE = K.gr;
  window.apAufOk = function(){ return ok; };
  window.apAufStufe = function(n){ n = parseInt(n, 10) || 0; return !ok ? '' : (n >= K.s2 ? '8-10' : (n >= K.ab ? '5-7' : '')); };
  window.apAuf = function(n){ var k = window.apAufStufe(n); return k ? { st:k, id:A[k].id, betrag:A[k].cent / 100 } : null; };
  window.apAufBetrag = function(k){ return A[k] ? A[k].cent / 100 : 0; };
  /* Text aus locales arturell.zehn.<k>_a / _b (Fassung K.text) oder <k>, Platzhalter {name} */
  window.apAufTx = function(k, w){
    var t = Z.t || {}, v = t[k + '_' + K.text.toLowerCase()]; if (v == null) v = t[k]; v = String(v == null ? '' : v);
    var b = { ab:K.ab, b1:K.s2 - 1, s2:K.s2, max:K.max, gs:K.gr.s, gm:K.gr.m, gl:K.gr.l };
    if (w) for (var x in w) if (Object.prototype.hasOwnProperty.call(w, x)) b[x] = w[x];
    return v.replace(/\{(\w+)\}/g, function(m, n){ return b[n] != null ? String(b[n]) : m; });
  };
  window.apAufStufeText = function(k){ return window.apAufTx('stufe', k === '8-10' ? { von:K.s2, bis:K.max } : { von:K.ab, bis:K.s2 - 1 }); };
  /* eigene Helfer (fmt, apIsUS, apPreisTab liegen in einer Closure und sind von aussen nicht erreichbar) */
  window.apAufUS = function(){ try { return /^us\./i.test(location.hostname); } catch(e){ return false; } };
  window.apAufEN = function(){ try { return (window.Shopify && Shopify.locale || 'de').slice(0,2) === 'en'; } catch(e){ return false; } };
  window.apAufGeld = function(v){ v = +v || 0; return window.apAufUS() ? '$' + v.toFixed(2) : (window.apAufEN() ? '€' + v.toFixed(2) : v.toFixed(2).replace('.', ',') + ' €'); };
  window.apAufTab = function(){ var s = window.st || {}, T = window.apAufUS() ? window.FAM_PREISE_US : window.FAM_PREISE; if (!T) return null;
    var n = parseInt(s.familyMotive || 2, 10) || 2, t = T[String(n > 4 ? 4 : n)] || T['2']; return t[s.material] || t.canvas; };
})();
/* HEIC-Fix 15.10.2026: iPhone-HEIC/HEIF im Browser nach JPG wandeln, sonst leere Kachel (Chrome kann HEIC nicht). */
window.apHeicFix = window.apHeicFix || function(file){
  var isH = /heic|heif/i.test(file.type||'') || /\.(heic|heif)$/i.test(file.name||'');
  if(!isH) return Promise.resolve(file);
  function lib(){
    if(window.heic2any) return Promise.resolve();
    return new Promise(function(res,rej){ var s=document.createElement('script');
      s.src='https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js'; s.onload=res; s.onerror=rej; document.head.appendChild(s); });
  }
  return lib().then(function(){ return window.heic2any({blob:file, toType:'image/jpeg', quality:0.92}); })
    .then(function(b){ if(Array.isArray(b)) b=b[0];
      return new File([b], (file.name||'foto').replace(/\.(heic|heif)$/i,'')+'.jpg', {type:'image/jpeg'}); })
    .catch(function(){
      var en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
      alert(en?'This photo is in HEIC format and could not be converted. Please share it from your gallery as JPG.':'Dieses Foto ist im HEIC-Format und konnte nicht umgewandelt werden. Bitte aus der Galerie als JPG teilen.');
      return null; });
};
/* ══════════════════════════════════════════════════════════════
   ABTEIL 3 · JAVASCRIPT
   st-Hoist · Fehler-Handler · Stil-Kategorien · Galerie (localStorage)
   · Werke · Upload + Motiverkennung · Lade-Overlay (inkl. FAMILIEN-Etappen)
   · Merge-Flow (apfNext/familyMerge) · Personalisierung · Mockup
   FAMILIEN-CODE: apf*-Funktionen + st.familyMergedUrl-Weichen
   ══════════════════════════════════════════════════════════════ */
(function(){
/* ── st-HOIST (family-v1): st muss existieren, bevor apLoadWerke o.ae. beim Laden zugreift.
   Auf der Familienseite laeuft Init in anderer Reihenfolge als auf der Produktseite;
   ohne diese Zeile crasht apLoadWerke mit "st is not defined". Die spaetere var st={...}
   ueberschreibt dieses Objekt vollstaendig. ── */
var st = window.st = (window.st || {artHistory:[], genCount:0, familyFotos:[]});

/* ═══ GLOBALES CRASH-NETZ ═══
   Faengt jeden unerwarteten JS-Fehler ab, damit ein einzelner Fehler NIE
   die ganze Kundenseite lahmlegt. Rein additiv — aendert keine Logik. */
(function(){
  var _apErrShown=false;
  function apGlobalError(msg, src){
    try{ console.error('[Arturell Crash-Netz]', msg, src||''); }catch(_){}
    if(_apErrShown) return;
    if(src && src.indexOf('arturell')===-1 && src.indexOf('dein-foto')===-1 && src!=='') return;
    _apErrShown=true;
  }
  window.addEventListener('error', function(e){
    apGlobalError(e && e.message, e && e.filename);
  });
  window.addEventListener('unhandledrejection', function(e){
    apGlobalError(e && e.reason && (e.reason.message||e.reason), 'promise');
  });
})();

/* ═══ UMBAU: Zentrale Stil-Liste (16 Stile) ═══ */
var AP_PH='data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 3"><rect width="4" height="3" fill="%23EFEAE3"/></svg>';
var AP_T = {
  de: {
    groessenvergleich:'Größenvergleich',
    sofa:'So groß sind die Formate an deiner Wand. Das Sofa ist 2 m breit.',
    noch:'Noch ', kostenlose:' kostenlose ', vorschau:'Vorschau', vorschauen:'Vorschauen',
    waehle:'Wähle dein Lieblingswerk zum Bestellen',
    vieleVorschauen:'Du hast viele Vorschauen erstellt. Wähle dein Lieblingswerk zum Bestellen ✨',
    inStilA:'✨ In ', inStilB:' verwandeln', deinStil:'deinen Stil',
    duSparst:'Du sparst ', generiere:'Generiere…',
    keinFoto:'Noch kein Foto &middot; 2 bis '+((window.apAufOk&&apAufOk())?AP_ZEHN.max:4)+' Fotos hochladen',
    einFoto:'1 Foto &middot; mindestens 1 weiteres nötig',
    weiterStil:'Weiter zur Stilauswahl',
    weiterFotos:'Weiter mit 2 bis '+((window.apAufOk&&apAufOk())?AP_ZEHN.max:4)+' Fotos',
    merge:'Fotos werden zusammengeführt …',
    retry:'Erneut versuchen',
    stileFuer:'Stile f\u00fcr euer Familienbild',
    startHinweis:'Starte oben mit euren Familienfotos. Einzelbilder, Autos & mehr gestaltest du auf der Startseite.',
    fotoLbl:'Foto',
    personTier:'Menschen/Tiere',
    kleineAufl:'&#9888; Kleine Aufl&ouml;sung',
    fotosHochgeladen:'Fotos hochgeladen',
    auflOkay:'Aufl&ouml;sung okay. Mit Original-Fotos direkt aus der Galerie wird die &Auml;hnlichkeit noch besser.',
    hochformat2:'Hochformat, das passt bei zwei Fotos am besten.',
    hochformat3:'Hochformat, das passt bei drei Fotos am besten.',
    querformat:'Querformat',
    hochformat:'Hochformat'
  },
  en: {
    groessenvergleich:'Size comparison',
    sofa:'See how each size looks on your wall. The sofa is about 7 feet wide.',
    noch:'', kostenlose:' free ', vorschau:'preview left', vorschauen:'previews left',
    waehle:'Choose your favorite to order',
    vieleVorschauen:"You've created lots of previews. Choose your favorite to order \u2728",
    inStilA:'\u2728 Transform into ', inStilB:'', deinStil:'your style',
    duSparst:'You save ', generiere:'Generating\u2026',
    keinFoto:'No photo yet &middot; upload 2 to '+((window.apAufOk&&apAufOk())?AP_ZEHN.max:4)+' photos',
    einFoto:'1 photo &middot; at least 1 more needed',
    weiterStil:'Continue to style selection',
    weiterFotos:'Continue with 2 to '+((window.apAufOk&&apAufOk())?AP_ZEHN.max:4)+' photos',
    merge:'Merging your photos \u2026',
    retry:'Try again',
    stileFuer:'styles for your family portrait',
    startHinweis:'Start above with your family photos. For single portraits, cars & more, visit the home page.',
    fotoLbl:'Photo',
    personTier:'People/pets',
    kleineAufl:'&#9888; Low resolution',
    fotosHochgeladen:'photos uploaded',
    auflOkay:'Resolution is fine. Original photos straight from your gallery make the likeness even better.',
    hochformat2:'Portrait format works best for two photos.',
    hochformat3:'Portrait format works best for three photos.',
    querformat:'Landscape',
    hochformat:'Portrait'
  }
};
var AP_L=(window.Shopify&&Shopify.locale?Shopify.locale.slice(0,2):'de');
var T = AP_T[AP_L] || AP_T.de; try{window.AP_DEBUG={lang:AP_L, hatEN:!!AP_T.en, gen:T.generiere};}catch(e){}
window.AP_L=AP_L; window.T=T; /* global sichtbar fuer window.apf*-Funktionen (Scope-Fix) */
window.LADE_EN=(AP_L==='en');
window.T_mergeTitle = AP_L==='en'?'Reading your photos \u2026':'Eure Fotos werden gelesen \u2026';
window.T_mergeSub = AP_L==='en'?'This takes about a minute. Please keep the page open.':'Das dauert etwa eine Minute. Bitte lass die Seite ge\u00f6ffnet.';
window.T_mergeTxt = AP_L==='en'?['Reading your photos \u2026','Measuring every face \u2026','Bringing your loved ones together \u2026','Blending light and color \u2026','Checking every detail \u2026','The final touches \u2026']:['Eure Fotos werden gelesen \u2026','Jedes Gesicht wird genau vermessen \u2026','Eure Liebsten r\u00fccken zusammen \u2026','Licht und Farben werden vereint \u2026','Jedes Detail wird gepr\u00fcft \u2026','Der letzte Feinschliff \u2026'];


var AP_STILE_EN={'aquarell':'Watercolor','aquarell-splash':'Watercolor Splash','aquarell-hell':'Watercolor · Light','aquarell-hell-rand':'Watercolor · Border','aquarell-splash-rand':'Splash · Border','rustic-rand':'Rustic','gouache':'Gouache','oel-hell':'Oil · Light','oel-golden':'Oil · Golden','impressionismus':'Impressionism','van-gogh':'Van Gogh','klimt':'Klimt · Gold','emerald':'Emerald Muse','chromaflare':'Chromaflare','renaissance':'Renaissance','rembrandt':'Rembrandt','barock':'Baroque','royal':'King','koenigin':'Queen','ritter':'Knight','regenbogenbruecke':'Rainbow Bridge','sternenhimmel':'Starry Sky','engel':'Angel','gedenkkerze':'Memorial Candle','sonnenstrahlen':'Sunbeams','lineart':'Line Art','original':'Original · Photo Portrait'};
function apStilName(s){try{return (AP_L==='en'&&s&&AP_STILE_EN[s.id])?AP_STILE_EN[s.id]:(s?s.name:'');}catch(e){return s?s.name:'';}}
function apFamU(u){try{var l=((window.Shopify&&Shopify.locale)||'de').slice(0,2),g='de';if(l==='en')g=(location.host.indexOf('us.')>-1)?'us':'en';return String(u).replace(/\{L\}/g,g);}catch(e){return String(u).replace(/\{L\}/g,'de');}}   /* 27.10.: v27 je Sprache */
var AP_STILE = [
  {id:'original', name:'Original · Fotoporträt', img:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/fam26-original.jpg?width=1080', cimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/fam26-original.jpg?width=640'},
  {id:'aquarell',          name:'Aquarell',          img:apFamU('https://cdn.arturell.com/galerie/v28/common/kachel-fg-zweikatzen--aquarell.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/kachel-fg-zweikatzen--aquarell.webp')},
  {id:'oel-hell',          name:'Öl · Hell',         img:apFamU('https://cdn.arturell.com/galerie/v28/common/m-mt2-drei-kinder--oel-hell.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/m-mt2-drei-kinder--oel-hell.webp')},
  {id:'oel-golden',        name:'Öl · Golden',       img:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-inf3-geschwister--oel-golden.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-inf3-geschwister--oel-golden.webp')},
  {id:'impressionismus',   name:'Impressionismus',   img:apFamU('https://cdn.arturell.com/galerie/v28/{L}/t-vogelkatze--impressionismus--familie--{L}.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/{L}/t-vogelkatze--impressionismus--familie--{L}.webp')},
  {id:'regenbogenbruecke', name:'Regenbogenbrücke', img:apFamU('https://cdn.arturell.com/galerie/v28/common/ads-golden-gedenk-2--regenbogenbruecke.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/ads-golden-gedenk-2--regenbogenbruecke.webp')},
  {id:'sternenhimmel', name:'Sternenhimmel', img:apFamU('https://cdn.arturell.com/galerie/v28/common/m-gedenk-frau--sternenhimmel.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/m-gedenk-frau--sternenhimmel.webp')},
  {id:'emerald', name:'Emerald Muse', img:apFamU('https://cdn.arturell.com/galerie/v28/common/mix4--emerald.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/mix4--emerald.webp')},
  {id:'chromaflare', name:'Chromaflare', img:apFamU('https://cdn.arturell.com/galerie/v28/common/pferd2--chromaflare.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/pferd2--chromaflare.webp')},
  {id:'aquarell-splash', name:'Aquarell-Splash', img:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-14-zwei-hunde-katze--aquarell-splash.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-14-zwei-hunde-katze--aquarell-splash.webp')},
  {id:'aquarell-hell-rand', name:'Aquarell · Rand', img:apFamU('https://cdn.arturell.com/galerie/v28/common/kachel-fg-freunde--aquarell-hell-rand.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/kachel-fg-freunde--aquarell-hell-rand.webp')},   /* 18.10. neu */
  {id:'aquarell-splash-rand', name:'Splash · Rand', img:apFamU('https://cdn.arturell.com/galerie/v28/{L}/web-kind-hund--aquarell-splash-rand--hund--{L}.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/{L}/web-kind-hund--aquarell-splash-rand--hund--{L}.webp')},   /* 18.10. neu */
  {id:'rustic-rand', name:'Rustic', img:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-13-paar-kater--rustic-rand.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-13-paar-kater--rustic-rand.webp')},   /* 18.10. neu */
  {id:'gouache', name:'Gouache', img:apFamU('https://cdn.arturell.com/galerie/v28/common/m-mt-zwei-kinder--gouache.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/m-mt-zwei-kinder--gouache.webp')},   /* 18.10. neu */
  {id:'van-gogh', name:'Van Gogh', img:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-02-vater-sohn--van-gogh.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-02-vater-sohn--van-gogh.webp')},
  {id:'klimt', name:'Klimt · Gold', img:apFamU('https://cdn.arturell.com/galerie/v28/{L}/t-hasehund--klimt--familie--{L}.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/{L}/t-hasehund--klimt--familie--{L}.webp')},
  {id:'engel', name:'Engel', img:apFamU('https://cdn.arturell.com/galerie/v28/common/ads-golden-gedenk-1--engel.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/ads-golden-gedenk-1--engel.webp')},
  {id:'gedenkkerze', name:'Gedenkkerze', img:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-inf3-hund-katze--gedenkkerze.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-inf3-hund-katze--gedenkkerze.webp')},
  {id:'sonnenstrahlen', name:'Sonnenstrahlen', img:apFamU('https://cdn.arturell.com/galerie/v28/{L}/m-gedenk-mann--sonnenstrahlen--gedenken--{L}.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/{L}/m-gedenk-mann--sonnenstrahlen--gedenken--{L}.webp')},
  {id:'lineart', name:'Line Art', img:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-inf3-eltern-baby--lineart.webp'), cimg:apFamU('https://cdn.arturell.com/galerie/v28/common/clip-inf3-eltern-baby--lineart.webp')},
];

/* ── STIL-KATEGORIEN (Filter-Chips) ── */
var AP_CAT = {
  'regenbogenbruecke':'andenken','sternenhimmel':'andenken','engel':'andenken','gedenkkerze':'andenken','sonnenstrahlen':'andenken',
  'royal':'royal','koenigin':'royal','prinz':'royal','prinzessin':'royal','ritter':'royal','admiral':'royal','herzog':'royal','viktorianisch':'royal','elisabethanisch':'royal',
  'aquarell':'kunst','aquarell-portrait':'kunst','oel-hell':'kunst','oel-golden':'kunst','impressionismus':'kunst','bleistift':'kunst','kohle':'kunst','pastell':'kunst','renaissance':'royal','barock':'royal','dark-academia':'kunst','emerald':'kunst','chromaflare':'kunst','aquarell-splash':'kunst','aquarell-hell':'kunst','aquarell-hell-rand':'kunst','aquarell-splash-rand':'kunst','rustic-rand':'kunst','gouache':'kunst','van-gogh':'kunst','klimt':'kunst','hokusai':'kunst','rembrandt':'kunst','lineart':'kunst',
  'ceo':'berufe','astronaut':'berufe','feuerwehr':'berufe','pilot':'berufe','koch':'berufe','boxer':'berufe','cowboy':'berufe','general':'berufe','gentleman':'berufe','superheld':'berufe',
  'rockstar':'berufe','musiker':'berufe','dj':'berufe','gamer':'berufe','fitness':'berufe','spa':'berufe','buecherwurm':'berufe','faulenzer':'berufe',
  'cartoon':'modern','anime':'modern','3d-animation':'modern','urban-comic':'modern','vintage-poster':'modern','kawaii':'modern','synthwave':'modern','comic-cover':'modern','strickfigur':'modern','action-figure':'modern',
  'weihnachten':'szenen','halloween':'szenen','ostern':'szenen','geburtstag':'szenen','berge':'szenen','strand':'szenen','blumenwiese':'szenen','herbstwald':'szenen','sonnenuntergang':'szenen','wiesn':'szenen'
};
var apActiveCat='alle';
/* ── DEEPLINK Schritt-2-Wizard: ?thema= zeigt nur passende Kategorie-Gruppe ── */
window.apFilterStep2ByThema=function(){
  try{
    var qs=new URLSearchParams(window.location.search);
    var p=(qs.get('thema')||qs.get('kategorie')||'').toLowerCase().trim();
    if(!p)return;
    var ALIAS={'koeniglich':'royal','koenig':'royal','royal':'royal','adel':'royal','fun':'berufe',
      'kostueme':'berufe','kostuem':'berufe','rollen':'berufe','berufe':'berufe','helden':'berufe',
      'charakter':'berufe','hobby':'berufe',
      'kuenstlerisch':'kunst','kunst':'kunst','aquarell':'kunst','oel':'kunst','malerei':'kunst','gemaelde':'kunst',
      'andenken':'andenken','gedenken':'andenken','memorial':'andenken',
      'szenen':'szenen','anlaesse':'szenen','weihnachten':'szenen','modern':'modern','tiere':'','alle':'',
      'fahrzeuge':'kunst','fahrzeug':'kunst','auto':'kunst','autos':'kunst'};/* Fahrzeuge = Kunst-Stile (16.07.: Autos laufen durch bestehende Stile, kein eigener Block) */
    var target=ALIAS.hasOwnProperty(p)?ALIAS[p]:p;
    if(!target)return;
    var heads=document.querySelectorAll('#ap .ap-stil-cat-head');
    var firstShown=true;
    heads.forEach(function(h){
      var cg=h.getAttribute('data-cg');
      var grid=h.nextElementSibling;
      var show=(cg===target);
      h.style.display=show?'':'none';
      if(grid&&grid.classList.contains('ap-stile-grid'))grid.style.display=show?'':'none';
      if(show&&firstShown){h.style.marginTop='0';firstShown=false;}
    });
    /* Zusätzlich: passenden Farb-Chip auf der Bearbeitungsseite aktivieren */
    var CHIP={'royal':'royal','berufe':'berufe','kunst':'kunst','andenken':'andenken','szenen':'szenen','modern':'modern','fahrzeuge':'fahrzeuge'};
    var chipCat=CHIP[target];
    if(chipCat){
      var chip=document.querySelector('#ap .ap-cat-chip[data-cat="'+chipCat+'"]');
      if(chip&&typeof apSetCat==='function')apSetCat(chip);
    }
  }catch(e){}
};
window.apSetCat=function(btn){
  apActiveCat=(btn&&btn.getAttribute('data-cat'))||'alle';
  var chips=document.querySelectorAll('#ap .ap-cat-chip');
  for(var i=0;i<chips.length;i++){ chips[i].classList.toggle('on', chips[i]===btn); }
  if(typeof apRenderStilGalerie==='function')apRenderStilGalerie();
};

/* GENERIERUNGS-LIMIT: Zum TESTEN auf 999, für LAUNCH auf 3 */
var MAX_GEN = 5; /* Stilisierungen auf dem gemergten Bild */
/* ── GALERIE 7-TAGE-SPEICHER (localStorage) ── */
var AP_WERKE_KEY='arturell_familie_v1'; /* 19.07.: Familie strikt getrennt von Hauptseite (eigene Preise/Varianten) */
var AP_WERKE_TTL=14*24*60*60*1000;
function apSaveWerke(){
  var payload={ts:Date.now(),genCount:st.genCount,foto:st.fotoSmall||'',items:st.artHistory,familyMergedUrl:st.familyMergedUrl||'',familyMergedSafe:st.familyMergedSafe||'',familyMotive:st.familyMotive||0};
  try{
    localStorage.setItem(AP_WERKE_KEY, JSON.stringify(payload));
    console.log('[Galerie] gespeichert: '+st.artHistory.length+' Werke'+(payload.foto?' + Foto':''));
  }catch(e){
    /* evtl. Quota — ohne Foto erneut versuchen, damit wenigstens die Werke bleiben */
    try{ payload.foto=''; localStorage.setItem(AP_WERKE_KEY, JSON.stringify(payload)); console.warn('[Galerie] Foto zu groß für Speicher, nur Werke gespeichert'); }
    catch(e2){ console.error('[Galerie] Speichern FEHLER:', e2); }
  }
}
/* Data-URL → File (zum Wiederherstellen des Foto-Objekts nach Reload, damit Re-Generierung geht) */
function apDataUrlToFile(dataUrl,name){
  try{
    var arr=dataUrl.split(','),mime=(arr[0].match(/:(.*?);/)||[])[1]||'image/jpeg';
    var bstr=atob(arr[1]),n=bstr.length,u8=new Uint8Array(n);
    while(n--){u8[n]=bstr.charCodeAt(n);}
    return new File([u8],name||'foto.jpg',{type:mime});
  }catch(e){ return null; }
}
function apLoadWerke(){
  try{
    var raw=localStorage.getItem(AP_WERKE_KEY);
    console.log('[Galerie] Laden: '+(raw?('gefunden, '+raw.length+' Zeichen'):'NICHTS gespeichert'));
    if(!raw)return;
    var data=JSON.parse(raw);
    if(!data||!data.items||!data.items.length)return;
    if(Date.now()-(data.ts||0)>AP_WERKE_TTL){localStorage.removeItem(AP_WERKE_KEY);return;}
    st.artHistory=data.items;
    st.genCount=(typeof data.genCount==='number')?data.genCount:data.items.length;
    /* Foto wiederherstellen: Thumbnail + File-Objekt (sonst broken Thumbnail + keine Re-Generierung möglich) */
    if(data.foto){ st.fotoDataUrl=data.foto; st.fotoSmall=data.foto; var _rf=apDataUrlToFile(data.foto,'foto.jpg'); if(_rf)st.foto=_rf; }
    if(data.familyMergedUrl){ st.familyMergedUrl=data.familyMergedUrl; if(data.familyMergedSafe){ st.familyMergedSafe=data.familyMergedSafe; } if(data.familyMotive){ st.familyMotive=data.familyMotive; } try{ window.apUpdatePrices && window.apUpdatePrices(); }catch(e){} } /* Familien-Merge ueberlebt Reload: Stil-Klick geht direkt, Dialog bleibt zu */
    console.log('[Galerie] wiederhergestellt: '+data.items.length+' Werke');
    if(window._apHandoffPending){ return; } /* Handoff von Startseite: Daten geladen, aber Ansicht bleibt Schritt 2 (Stil wählen) */
    if(sessionStorage.getItem('apfNeuMerge')==='1'){ sessionStorage.removeItem('apfNeuMerge'); return; } /* Neue Zusammenführung: Werke geladen, Ansicht bleibt Upload */
    var ss=document.getElementById('apStileSection'); if(ss)ss.style.display='none';
    var hero=document.querySelector('#ap .ap-hero'); if(hero)hero.style.display='none';
    var rs=document.getElementById('apResultSection'); if(rs)rs.style.display='block';
    if(typeof apRenderWerke==='function'){try{apRenderWerke();}catch(e){console.error('[Galerie] Render FEHLER:',e);}}
    var last=data.items[data.items.length-1];
    /* AP-WERK-ZURUECK-2910 */ try{var _wq=new URLSearchParams(location.search).get('werk');if(_wq){for(var _wi=0;_wi<data.items.length;_wi++){if(data.items[_wi].url===_wq){last=data.items[_wi];break;}}}}catch(e){}
    try{ if(last&&last.format){var fb=document.querySelector('#ap .ap-fmt-btn[data-fmt="'+last.format+'"]');if(fb&&typeof apFmt==='function')apFmt(fb);} }catch(e){console.error('[Galerie] Format FEHLER:',e);}
    try{ if(last&&typeof apSelectWerk==='function')apSelectWerk(last.url,last.stilId,last.format); }catch(e){console.error('[Galerie] Select FEHLER:',e);}
    if(typeof apUpdateGenCounter==='function')apUpdateGenCounter();
    if(typeof aktualisierePreis==='function')aktualisierePreis();
  }catch(e){ console.error('[Galerie] Laden FEHLER:', e); }
}

/* Quer-Kategorie: Stile, die Fahrzeug-Motive koennen (Worker fahrzeug-Zweige) */
var AP_FAHRZEUG_STILE=['emerald','chromaflare','aquarell-splash','oel-hell','oel-golden','aquarell','impressionismus','van-gogh','klimt','lineart'];
/* Stil-Slider rendern */
function apRenderStilGalerie(){
  var g=document.getElementById('apStilGalerie');
  if(!g)return;
  g.innerHTML='';
  apUpdateFotoStrip();
  /* Cross-Verweis (19.07.) */
  try{
    var xb=document.getElementById('apCrossHint');
    if(!xb){
      xb=document.createElement('div');
      xb.id='apCrossHint';
      xb.style.cssText='display:flex;align-items:flex-start;gap:9px;max-width:680px;margin:18px auto 0;background:#FAF8F5;border:1px solid #E8DFD3;border-radius:12px;padding:12px 16px;font-size:13px;line-height:1.55;color:#6b625a';
      xb.innerHTML='<span style="display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#1A1714;color:#fff;font-family:Georgia,serif;font-size:12px;font-style:italic;font-weight:700;flex:none;margin-top:1px">i</span><span>'+((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Want single portraits, cars or other subjects? At <a href="'+((typeof apIsUS==='function'&&apIsUS())?'/products/your-artwork-canvas':(((location.pathname.match(/^\/en(?=\/|$)/i)||[''])[0])+'/products/dein-kunstwerk-leinwand'))+'" style="color:#1A1714;font-weight:700">arturell.com</a> you get the full range of 20+ styles.':'Du m&ouml;chtest Einzelbilder, Autos oder andere Motive gestalten? Auf <a href="/products/dein-kunstwerk-leinwand" style="color:#1A1714;font-weight:700">arturell.com</a> hast du die volle Auswahl mit über 20 Stilen.')+'</span>';
      var tb=document.getElementById('tabMaterial');var anch=tb?tb.parentElement:null;
      if(anch&&anch.parentNode){anch.parentNode.insertBefore(xb,anch.nextSibling);}else{g.parentNode.insertBefore(xb,g.nextSibling);}
    }
  }catch(e){}

  AP_STILE.forEach(function(s){
    if(apActiveCat==='fahrzeuge'){ if(AP_FAHRZEUG_STILE.indexOf(s.id)===-1)return; }
    else if(apActiveCat!=='alle' && (AP_CAT[s.id]||'')!==apActiveCat)return;
    var w=null;
    for(var i=st.artHistory.length-1;i>=0;i--){if(st.artHistory[i].stilId===s.id){w=st.artHistory[i];break;}}
    var isGen=!!w;
    var isOn=isGen&&w.url===st.artUrl;
    var card=document.createElement('div');
    card.className='ap-sg-tile'+(isOn?' on':'');
    card.setAttribute('data-stil',s.id);
    if(!isGen && typeof APF_STILE_OK!=='undefined' && !APF_STILE_OK[s.id]) return; /* Familie: nur freigegebene Stile anbieten */
    if(isGen){card.onclick=function(){apNeuesFotoStil(s.id);};} /* FLOW v10: Klick -> Foto waehlen -> generieren */
    else{card.onclick=function(){apNeuesFotoStil(s.id);};card.style.cursor='pointer';}
    if(isGen){
      card.innerHTML=
        '<div class="ap-sg-imgwrap"><img class="ap-sg-img" src="'+w.url+'" alt="'+s.name+'" loading="lazy"><span class="ap-sg-chk"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></span><span class="ap-sg-again" onclick="event.stopPropagation();if(window.apRegen)apRegen(\''+s.id+'\')" title="'+(AP_L==='en'?'Generate again':'Nochmal erzeugen')+'" style="position:absolute;right:6px;bottom:6px;width:32px;height:32px;border-radius:50%;background:#FFFFFF;color:#1A1714;border:1px solid rgba(26,23,20,.18);box-shadow:0 2px 8px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;font-size:18px;line-height:1;cursor:pointer;z-index:3">&#8635;</span></div>'+
        '<div class="ap-sg-name">'+apStilName(s)+'</div>';
    } else {
      card.innerHTML=
        '<div class="ap-sg-imgwrap"><img class="ap-sg-img" src="'+s.img+'" alt="'+s.name+'" loading="lazy"><span class="ap-sg-badge">Vorschau</span></div>'+
        '<div class="ap-sg-name">'+apStilName(s)+'</div>';
    }
    g.appendChild(card);
  });
}
function apRenderStilSlider(){apRenderStilGalerie();}
function apUpdateFotoStrip(){
  var th=document.getElementById('apFsThumb');
  var nm=document.getElementById('apFsStil');
  var src=st.fotoSmall||st.fotoDataUrl||'';
  if(th&&src){ th.onerror=function(){ if(st.fotoDataUrl&&th.src!==st.fotoDataUrl){th.onerror=null;th.src=st.fotoDataUrl;} }; th.src=src; }
  if(nm){nm.textContent=st.stilName||'';}
}
window.apToggleStile=function(){
  var w=document.getElementById('apWerkeWrap');
  var c=document.getElementById('apStileChevron');
  if(!w)return;
  var willShow=(w.style.display==='none');
  w.style.display=willShow?'block':'none';
  if(c)c.textContent=willShow?'▴':'▾';
};

/* Öffnet die 16-Stile-Galerie (statt Upload) und scrollt hin */
window.apOpenStile=function(){
  var w=document.getElementById('apWerkeWrap');
  var c=document.getElementById('apStileChevron');
  var t=document.getElementById('apStileToggle');
  if(w)w.style.display='block';
  if(c)c.textContent='▴';
  if(t&&t.scrollIntoView)t.scrollIntoView({behavior:'smooth',block:'start'});
};

/* Größenvergleich: zeigt die verfügbaren Größen maßstabsgetreu neben einer Person */
window.apSizeCompare=function(){
  var grid=document.querySelector('#ap .ap-size-grid');
  if(!grid)return;
  var btns=grid.querySelectorAll('.ap-size-btn'),S=[],i;
  for(i=0;i<btns.length;i++){
    var b=btns[i];
    if(b.offsetParent===null)continue;
    var cmEl=b.querySelector('.sz-cm'),lblEl=b.querySelector('.sz-label');
    if(!cmEl)continue;
    var roh=cmEl.textContent.trim();
    var mm=roh.match(/([\d.]+)\s*[×x]\s*([\d.]+)/);
    if(!mm)continue;
    var zoll=/[""\u201d]|\bin\b/.test(roh) && !/cm/.test(roh);
    var bw=parseFloat(mm[1]), bh=parseFloat(mm[2]);
    S.push({w:bw,h:bh,wc:zoll?bw*2.54:bw,hc:zoll?bh*2.54:bh,txt:roh,
            name:lblEl?lblEl.textContent.trim():'',sel:b.classList.contains('on')});
  }
  if(!S.length)return;
  window.apSizeCompareClose();
  var sel=0;
  for(i=0;i<S.length;i++){ if(S[i].sel) sel=i; }

  var ov=document.createElement('div');
  ov.id='apCmpOv';
  ov.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483000;background:rgba(20,17,14,.55);display:flex;align-items:center;justify-content:center;padding:16px';
  ov.onclick=function(e){ if(e.target===ov) window.apSizeCompareClose(); };

  var card=document.createElement('div');
  card.style.cssText='background:#fff;border-radius:16px;width:660px;max-width:100%;padding:18px 20px;position:relative;font-family:inherit;box-sizing:border-box';

  var x=document.createElement('button');
  x.type='button'; x.innerHTML='&times;';
  x.style.cssText='position:absolute;top:10px;right:10px;width:30px;height:30px;border:0;border-radius:50%;background:#F3F0EA;color:#1A1714;font-size:18px;line-height:1;cursor:pointer';
  x.onclick=function(){ window.apSizeCompareClose(); };

  var t=document.createElement('div');
  t.textContent=T.groessenvergleich;
  t.style.cssText='font-size:17px;font-weight:700;color:#1A1714;margin-bottom:2px';

  var u=document.createElement('div');
  u.textContent=T.sofa;
  u.style.cssText='font-size:12.5px;color:#8A857E;margin-bottom:12px;padding-right:26px';

  var stage=document.createElement('div');
  stage.style.cssText='background:#EFEAE3;border-radius:12px;overflow:hidden;line-height:0';

  var row=document.createElement('div');
  row.style.cssText='display:flex;gap:7px;margin-top:12px';

  card.appendChild(x); card.appendChild(t); card.appendChild(u);
  card.appendChild(stage); card.appendChild(row);
  ov.appendChild(card); document.body.appendChild(ov);

  function zeichne(){
    /* Raumfoto 2000x1152. Sofa-Aussenkanten x 385..1680 = 220 cm breit,
       Oberkante Rueckenlehne y 601.  ->  5.886 px je cm. */
    var IMG='https://cdn.arturell.com/galerie/raum-sofa.jpg';
    var SL=385, SR=1680, LEHNE_B=601, PXCM=(SR-SL)/220, MITTE=(SL+SR)/2, k;
    var maxHc=0; for(k=0;k<S.length;k++){ if(S[k].hc>maxHc) maxHc=S[k].hc; }
    /* Wand nach oben verlaengern, bis das groesste Format Platz hat */
    var noetig=(maxHc+18)*PXCM+46;
    var TOP=Math.max(0, Math.ceil(noetig-LEHNE_B));
    var VH=1152+TOP, LEHNE=LEHNE_B+TOP, UNTEN=LEHNE-18*PXCM;

    var g='<svg viewBox="0 0 2000 '+VH+'" style="display:block;width:100%;height:auto">';
    if(TOP>0){
      var F=(TOP+6)/90;
      g+='<defs><clipPath id="apCmpTop"><rect x="0" y="0" width="2000" height="'+(TOP+6)+'"/></clipPath></defs>';
      g+='<image href="'+IMG+'" x="0" y="'+(TOP-90*F)+'" width="2000" height="'+(1152*F)+'" preserveAspectRatio="none" clip-path="url(#apCmpTop)"/>';
    }
    g+='<image href="'+IMG+'" x="0" y="'+TOP+'" width="2000" height="1152"/>';

    /* gross nach klein, damit die kleinen vorne liegen */
    var idx=[]; for(k=0;k<S.length;k++) idx.push(k);
    idx.sort(function(a,b){ return (S[b].wc*S[b].hc)-(S[a].wc*S[a].hc); });
    for(k=0;k<idx.length;k++){
      var z=S[idx[k]], on=(idx[k]===sel);
      var w=z.wc*PXCM, h=z.hc*PXCM, px=MITTE-w/2, py=UNTEN-h;
      g+='<rect x="'+px+'" y="'+py+'" width="'+w+'" height="'+h+'" '+
         'fill="'+(on?'#A96153':'#FFFFFF')+'" fill-opacity="'+(on?0.90:0.30)+'" '+
         'stroke="'+(on?'#7E4237':'#1A1714')+'" stroke-width="'+(on?5:2.5)+'" stroke-opacity="0.8"/>';
      var innen=(w>190&&h>78);
      g+='<text x="'+MITTE+'" y="'+(innen?py+36:py-11)+'" text-anchor="middle" '+
         'font-size="'+(innen?28:24)+'" font-weight="600" '+
         'fill="'+(on?(innen?'#fff':'#7E4237'):'#1A1714')+'" fill-opacity="'+(on?1:0.7)+'" '+
         'font-family="-apple-system,Segoe UI,sans-serif">'+z.txt+'</text>';
    }
    g+='</svg>';
    stage.innerHTML=g;

    row.innerHTML='';
    for(k=0;k<S.length;k++){
      (function(j){
        var bt=document.createElement('button'), o=(j===sel), ROSE='#A96153';
        bt.type='button';
        bt.style.cssText='flex:1;padding:8px 2px;border-radius:10px;border:'+(o?'2px solid '+ROSE:'1px solid #E2DACE')+';background:'+(o?'#FBF3F0':'#fff')+';cursor:pointer;font-family:inherit;text-align:center';
        bt.innerHTML='<span style="display:block;font-size:13px;font-weight:700;color:'+(o?ROSE:'#1A1714')+'">'+S[j].name+'</span><span style="display:block;font-size:11px;color:'+(o?ROSE:'#8A857E')+'">'+S[j].txt+'</span>';
        bt.onclick=function(){ sel=j; zeichne(); };
        row.appendChild(bt);
      })(k);
    }
  }
  zeichne();
};

/* ── FOTO-GUIDE (16.08.) ─────────────────────────────────────────
   Gute und schlechte Beispielfotos. Bilder liegen auf R2. */
window.apFotoGuide=function(){
  window.apFotoGuideClose();
  var EN=(AP_L==='en');
  var B='https://cdn.arturell.com/galerie/fg-';
  var GUT=[['gut-portrait',EN?'Close up, face sharp':'Nah dran, Gesicht scharf'],
           ['gut-hund',EN?'Calm background':'Ruhiger Hintergrund'],
           ['gut-paar',EN?'Soft daylight':'Weiches Tageslicht']];
  var SCHLECHT=[['schlecht-weit',EN?'Too far away':'Zu weit weg'],
                ['schlecht-unscharf',EN?'Blurry or dark':'Verwackelt oder dunkel'],
                ['schlecht-gruppe',EN?'Faces too small':'Gesichter zu klein']];

  var ov=document.createElement('div');
  ov.id='apFgOv';
  ov.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483000;background:rgba(20,17,14,.55);display:flex;align-items:center;justify-content:center;padding:16px;overflow-y:auto';
  ov.onclick=function(e){ if(e.target===ov) window.apFotoGuideClose(); };

  function reihe(liste,farbe,titel,text){
    var h='<div style="margin-bottom:16px"><div style="display:flex;align-items:center;gap:8px;margin-bottom:7px">'+
      '<span style="display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:'+farbe+';color:#fff;font-size:13px;font-weight:700;flex:none">'+(farbe==='#2E7D5B'?'\u2713':'\u2715')+'</span>'+
      '<span style="font-size:14.5px;font-weight:700;color:#1A1714">'+titel+'</span></div>'+
      '<div style="font-size:12.5px;color:#8A857E;margin-bottom:9px;line-height:1.55">'+text+'</div>'+
      '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px">';
    liste.forEach(function(x){
      h+='<div><img src="'+B+x[0]+'.png?width=320" alt="'+x[1]+'" loading="lazy" '+
         'style="width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:9px;display:block;background:#F1EFEA">'+
         '<div style="font-size:11.5px;color:#6b625a;text-align:center;margin-top:5px">'+x[1]+'</div></div>';
    });
    return h+'</div></div>';
  }

  var card=document.createElement('div');
  card.style.cssText='background:#fff;border-radius:16px;width:620px;max-width:100%;padding:20px 22px;position:relative;font-family:inherit;box-sizing:border-box;margin:auto';
  card.innerHTML=
    '<button type="button" onclick="window.apFotoGuideClose()" style="position:absolute;top:11px;right:11px;width:30px;height:30px;border:0;border-radius:50%;background:#F3F0EA;color:#1A1714;font-size:18px;line-height:1;cursor:pointer">&times;</button>'+
    '<div style="font-size:17px;font-weight:700;color:#1A1714;margin-bottom:3px">'+(EN?'Photo guide':'Foto-Guide')+'</div>'+
    '<div style="font-size:12.5px;color:#8A857E;margin-bottom:15px;padding-right:26px">'+
      (EN?'The better the photo, the better your artwork.':'Je besser das Foto, desto besser dein Kunstwerk.')+'</div>'+
    reihe(GUT,'#2E7D5B',EN?'Works well':'Gut so',
      EN?'Close up, faces sharp and well lit. Calm background. Group photos welcome when every face is easy to see.'
        :'Nah dran, Gesichter scharf und gut ausgeleuchtet. Ruhiger Hintergrund. Gruppenfotos gern, wenn jedes Gesicht gut zu sehen ist.')+
    reihe(SCHLECHT,'#B4453A',EN?'Better avoid':'Lieber nicht',
      EN?'Taken from far away, blurry or dark. Tiny faces or sunglasses. Scans and photos of photos.'
        :'Zu weit weg, verwackelt oder dunkel. Winzige Gesichter oder Sonnenbrillen. Scans und abfotografierte Bilder.');

  ov.appendChild(card); document.body.appendChild(ov);
};
window.apFotoGuideClose=function(){
  var o=document.getElementById('apFgOv'); if(o&&o.parentNode) o.parentNode.removeChild(o);
};

window.apSizeCompareClose=function(){
  var o=document.getElementById('apCmpOv'); if(o&&o.parentNode) o.parentNode.removeChild(o);
  var m=document.getElementById('apSizeModal'); if(m) m.style.display='none';
};

/* Klick auf Stil im Slider → vorhandenes Werk anzeigen ODER neu generieren */
window.apStilSliderClick=function(stilId){
  /* 21.07.: "original" ist kein Modell-Stil — direkt das gemergte Foto zeigen, keine Generierung */
  if(stilId==='original'){ if(window.apOriginalWaehlen) window.apOriginalWaehlen(); return; }
  if(st.busy)return;
  var existing=null;
  for(var i=0;i<st.artHistory.length;i++){
    if(st.artHistory[i].stilId===stilId){existing=st.artHistory[i];break;}
  }
  if(existing){apSelectWerk(existing.url,stilId,existing.format);return;}
  if(st.genCount>=MAX_GEN){apShowLimitHint();return;}
  var s=null;
  for(var j=0;j<AP_STILE.length;j++){if(AP_STILE[j].id===stilId){s=AP_STILE[j];break;}}
  if(!s)return;
  st.stil=s.id;st.stilName=apStilName(s);
  apRenderStilSlider();
  apGen();
};

/* Bereits generierten Stil NOCHMAL generieren (Variante) — überspringt die Auswahl-Logik */
window.apRegen=function(stilId){
  if(st.busy)return;
  if(st.genCount>=MAX_GEN){apShowLimitHint();return;}
  var s=null;
  for(var j=0;j<AP_STILE.length;j++){if(AP_STILE[j].id===stilId){s=AP_STILE[j];break;}}
  if(!s)return;
  st.stil=s.id;st.stilName=apStilName(s);
  apGen();
};

/* Neues Foto aus der Ergebnis-Galerie: merkt sich den Stil, oeffnet den Datei-Dialog.
   Nach Foto-Wahl + Format-Erkennung wird DIREKT generiert (kein Zurueckwerfen zur Upload-Ansicht). */
window.apNeuesFotoStil=function(stilId){
  /* FAMILIEN-MODUS: gemergtes Bild direkt neu stilisieren — kein Datei-Dialog (Foto würde eh ignoriert) */
  if(window.st && st.familyMergedUrl){
    if(typeof apRegen==='function') apRegen(stilId);
    return;
  }
  /* Familienseite: kein Einzelbild-Upload ueber Stil-Klick — Hinweis statt Dialog */
  var msg=(AP_L==='en'?'Start above with your family photos. For single portraits, cars & more, visit the home page.':'Starte oben mit euren Familienfotos. Einzelbilder, Autos & mehr gestaltest du auf der Startseite.');
  if(typeof apfToast==='function'){ apfToast(msg); } else { alert(msg); }
};

/* Counter aktualisieren */
function apUpdateGenCounter(){
  var el=document.getElementById('apGenCounter');
  if(!el)return;
  var rest=MAX_GEN-st.genCount;
  if(rest>0){
    el.textContent=T.noch+rest+T.kostenlose+(rest===1?T.vorschau:T.vorschauen);
    el.classList.remove('is-bestellen');
  } else {
    el.textContent=T.waehle;
    el.classList.add('is-bestellen');
  }
}
function apShowLimitHint(){
  var t=document.getElementById('apLimitToast');
  if(!t){
    t=document.createElement('div');
    t.id='apLimitToast';
    t.style.cssText='position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#1A1714;color:#fff;padding:13px 22px;border-radius:12px;font-size:13px;font-weight:600;z-index:99999;box-shadow:0 8px 32px rgba(0,0,0,.25);opacity:0;transition:opacity .3s;pointer-events:none;max-width:88vw;text-align:center;line-height:1.3';
    document.body.appendChild(t);
  }
  t.textContent=T.vieleVorschauen;
  requestAnimationFrame(function(){t.style.opacity='1';});
  clearTimeout(t._ht);
  t._ht=setTimeout(function(){t.style.opacity='0';},3500);
}

/* Deine Werke Galerie rendern */
function apRenderWerke(){apRenderStilGalerie();apRenderDeineWerke();}

/* ── DEINE WERKE: alle Generierungen des Kunden (neueste zuerst), 14 Tage ── */
function apRenderDeineWerke(){
  var wrap=document.getElementById('apDeineWerke');
  var row=document.getElementById('apDwRow');
  var cnt=document.getElementById('apDwCount');
  var strip=document.getElementById('apFotostrip');
  if(!wrap||!row)return;
  if(!st.artHistory)st.artHistory=[];
  if(strip)strip.style.display='none';
  wrap.style.display='block';
  if(cnt)cnt.textContent=st.artHistory.length?('('+st.artHistory.length+')'):'';
  if(!st.artHistory.length){row.innerHTML='';return;}
  var html='';
  for(var i=st.artHistory.length-1;i>=0;i--){
    var w=st.artHistory[i];
    var on=(w.url===st.artUrl)?' on':'';
    html+='<div class="ap-dw-item'+on+'" onclick="apSelectWerk(\''+w.url+'\',\''+w.stilId+'\',\''+(w.format||'')+'\',\''+(w.famM||'')+'\')">'+
          '<div class="ap-dw-imgwrap"><img class="ap-dw-img" crossorigin="anonymous" src="'+w.url+'" alt="'+(AP_L==="en"&&AP_STILE_EN[w.stilId]?AP_STILE_EN[w.stilId]:(w.stil||""))+'" loading="lazy"></div>'+
          '<div class="ap-dw-name">'+(AP_L==="en"&&AP_STILE_EN[w.stilId]?AP_STILE_EN[w.stilId]:(w.stil||""))+'</div>'+
          '</div>';
  }
  row.innerHTML=html;
}

/* Werk aus Galerie auswählen → anzeigen, KEIN Versuch */
window.apSelectWerk=function(url,stilId,format,famM){ if(famM){ st.familyMotive=parseInt(famM,10)||st.familyMotive; } try{ window.apUpdatePrices && window.apUpdatePrices(); }catch(e){}
  st.artUrl=url;
  for(var i=0;i<AP_STILE.length;i++){
    if(AP_STILE[i].id===stilId){st.stil=AP_STILE[i].id;st.stilName=apStilName(AP_STILE[i]);break;}
  }
  /* FIX 11.07: Format des ausgewaehlten Werks uebernehmen — sonst bleibt "An der Wand"
     auf dem zuletzt genutzten Format haengen (z.B. quer vom Fahrzeug-Test), egal welches
     Werk als naechstes angeklickt wird. */
  if(format && st.format!==format){
    var fb=document.querySelector('#ap .ap-fmt-btn[data-fmt="'+format+'"]');
    /* PIPE v3: Format-Sync OHNE Tab-Sprung — der Auto-Sprung in apFmt ist nur fuer den manuellen Toggle gedacht */
    window._apSelecting=true;
    try{ if(fb && typeof apFmt==='function')apFmt(fb); }catch(e){}
    window._apSelecting=false;
  }
  var badge=document.getElementById('apStilBadge');
  if(badge)badge.textContent=st.stilName;
  var img=document.getElementById('apResultImg');
  img.crossOrigin='anonymous';
  function _apArtReadyClean(){
    st.artImg=img;
    _bgCache=null;_bgCacheKey='';_roomCache=null;_roomCacheKey='';
    renderCanvas();apDrawRoom();
    /* PIPE v2: Wand-Tab aktiv -> Mockup fuers frisch geladene Werk anfordern */
    var _pm=document.getElementById('paneMaterial');
    if(_pm&&_pm.classList.contains('on')&&typeof window.apDrawMockup==='function')window.apDrawMockup();
  }
  img.onload=_apArtReadyClean;
  img.onerror=function(){ st.artImg=img; };
  img.src=url;
  /* Cache-Fix (Mobile): Bild schon geladen -> onload feuert nicht -> st.artImg direkt setzen, OHNE Tab zu wechseln */
  if(img.complete && img.naturalWidth>0){
    st.artImg=img;
    _bgCache=null;_bgCacheKey='';_roomCache=null;_roomCacheKey='';
    if(typeof renderCanvas==='function')renderCanvas();
  }
  /* PIPE v1: EIN zentraler Refresh nach dem Layout-Umbau (Format/ap-quer ist gesetzt):
     Vorschau neu einpassen + falls Wand-Tab aktiv, Mockup fuers NEUE Werk anfordern.
     Behebt: (a) Erst-Klick rendert mit altem Layout, (b) Wand zeigt Vorgaenger-Werk. */
  try{
    requestAnimationFrame(function(){
      if(st.artImg&&typeof renderCanvas==='function')renderCanvas();
      var _pm=document.getElementById('paneMaterial');
      if(_pm&&_pm.classList.contains('on')&&typeof window.apDrawMockup==='function')window.apDrawMockup();
    });
  }catch(e){}
  apRenderStilSlider();
  apRenderWerke();
};
/* ═══ ENDE UMBAU JS-Logik ═══ */

var st=window.st={
  foto:null,fotoDataUrl:null,
  stil:'aquarell',stilName:(AP_L==='en'?'Watercolor':'Aquarell'),
  size:'m',price:74.95,was:119.95,
  format:'hoch',
  material:'canvas',farbe:'black',
  artUrl:null,artImg:null,
  busy:false,
  pers:{line1:'',line2:'',font:'',vorlage:'',pos:'auto',nameAn:false,datumAn:false,calc:null},
  persOpen:false,
  roomOrientation:'hoch',
  genCount:0,          /* Zählt generierte Kunstwerke */
  artHistory:[],       /* Speichert alle generierten URLs + Stil */
  fotoRatio:null       /* Seitenverhältnis des hochgeladenen Fotos */
};

/* ── PERFORMANCE CACHE ──
   Bild+Wasserzeichen werden EINMAL gerendert und gecacht.
   Beim Tippen wird nur der Cache kopiert + Text neu gezeichnet. */
var _bgCache=null;       /* Offscreen-Canvas: Bild+Wasserzeichen (Vorschau) */
var _bgCacheKey='';      /* Key: erkennt ob Neu-Render nötig (Bild/Größe geändert) */
var _roomCache=null;     /* Offscreen-Canvas: Room-Bild+Kunstwerk */
var _roomCacheKey='';
var _overlayCache=null;  /* Offscreen: Wand-Overlay-Bild (Glas/Rahmen-Schatten) */
var _overlayCacheUrl='';
var _rafPending=false;   /* requestAnimationFrame Throttle */

/* ── FONTS ── */
var FM={
  playfair:'"Playfair Display",Georgia,serif',
  dancing:'"Dancing Script",cursive',
  inter:'"Inter",sans-serif',
  cormorant:'"Cormorant Garamond",Georgia,serif',
  josefin:'"Josefin Sans",sans-serif',
  pacifico:'Pacifico,cursive',
  playwrite:'"Playwrite US Trad",cursive'
};

/* ── UPLOAD ── */
var fi=document.getElementById('apFileInput');
var uploadBox=document.getElementById('apUploadBox');

fi.addEventListener('change',function(e){
  var f=e.target.files[0];if(!f)return;
  st.foto=f;
  var r=new FileReader();
  r.onload=function(ev){
    /* ── apCropHook: erst Ausschnitt waehlen, dann normaler Flow ── */
    var _origResult = ev.target.result;
    var _preImg = new Image();
    _preImg.onload = function(){
      var _ratio = _preImg.width/_preImg.height;
      var _fmt = (_ratio >= 1.0) ? 'quer' : 'hoch';  /* Foto entscheidet: breiter-als-hoch -> quer */
      if (typeof window.apOpenCrop === 'function') {
        window.apOpenCrop(_origResult, _fmt, function(cropped){
          ev.target.result = cropped;
          /* Ausschnitt in ALLE Bildquellen -> Gemini bekommt den Crop, nicht das Original */
          st.fotoDataUrl = cropped;
          st.fotoSmall = cropped;
          try { var _cf = apDataUrlToFile(cropped, 'foto.jpg'); if(_cf) st.foto = _cf; } catch(e){}
          _apUploadProceed(ev);
        });
      } else {
        _apUploadProceed(ev);
      }
    };
    _preImg.src = _origResult;
  };
  function _apUploadProceed(ev){
  // Room-Bild sofort preloaden (verhindert 1-Sek Delay nach Generation)
  (function(){
    try{
      var rooms=[
        'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/canvas_hoch_livingroom3.jpg',
        'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/canvas_quer_livingroom8.jpg'
      ];
      rooms.forEach(function(url){var i=new Image();i.src=url;});
    }catch(e){}
  })();
    st.fotoDataUrl=ev.target.result;
    /* Foto-Seitenverhältnis erkennen */
    var tmpImg=new Image();
    tmpImg.onload=function(){
      st.fotoRatio=tmpImg.width/tmpImg.height;
      /* kompaktes Foto (max 800px) für localStorage-Persistenz — Thumbnail + Re-Generierung nach Reload */
      try{
        var _M=800,_w=tmpImg.width,_h=tmpImg.height;
        if(_w>_M||_h>_M){ if(_w>_h){_h=Math.round(_h*_M/_w);_w=_M;} else {_w=Math.round(_w*_M/_h);_h=_M;} }
        var _sc=document.createElement('canvas');_sc.width=_w;_sc.height=_h;
        _sc.getContext('2d').drawImage(tmpImg,0,0,_w,_h);
        st.fotoSmall=_sc.toDataURL('image/jpeg',0.82);
      }catch(e){ st.fotoSmall=null; }
      /* ── FORMAT: DAS FOTO ENTSCHEIDET (kein Umschalten, wie Wettbewerb) ── */
      var btnHoch=document.querySelector('#ap .ap-fmt-btn[data-fmt="hoch"]');
      var btnQuer=document.querySelector('#ap .ap-fmt-btn[data-fmt="quer"]');
      if(btnHoch&&btnQuer){
        var fotoFmt = (st.fotoRatio>=1.0) ? 'quer' : 'hoch';  /* breiter-als-hoch -> quer */
        var fotoBtn = (fotoFmt==='quer') ? btnQuer : btnHoch;
        /* Anzeige: nur das passende Format sichtbar, das andere ausblenden */
        btnHoch.style.display=(fotoFmt==='hoch')?'':'none';
        btnQuer.style.display=(fotoFmt==='quer')?'':'none';
        if(st.format!==fotoFmt && typeof apFmt==='function') apFmt(fotoBtn);
      }
      /* Neues Foto aus Galerie im gewaehlten Stil → sofort generieren (Format ist jetzt gesetzt) */
      if(st.pendingStil){
        var _pid=st.pendingStil; st.pendingStil=null;
        setTimeout(function(){ if(typeof apRegen==='function') apRegen(_pid); }, 30);
      }
    };
    tmpImg.src=ev.target.result;

    /* ── MOTIV-ERKENNUNG beim Upload → Stile ausgrauen ── */
    (function(){
      try {
        var dataUrl = ev.target.result;
        fetch('https://arturell-preview.arturell.workers.dev', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({image: dataUrl, stil: 'aquarell', format: 'hoch', motivOnly: true})
        })
        .then(function(r){return r.json();})
        .then(function(data){
          var motiv = data.motiv || 'person';
          st.motiv = motiv;
          /* ── MEHRTIER-FORMAT (v2): Zwang entfernt. Foto-Ausrichtung entscheidet.
             Beide Formate bleiben waehlbar; hochkant Foto -> hoch, quer Foto -> quer.
             Kunde kann jederzeit manuell wechseln. ── */
          /* (bewusst kein Format-Zwang mehr bei mehreren Tieren) */
          /* Inkompatible Stile pro Motiv */
          var NUR_LEBEWESEN = ['aquarell-portrait','royal','dark-academia','action-figure','ceo','strickfigur','regenbogenbruecke','feuerwehr','pilot','koch','rockstar','boxer','wiesn','cowboy','general','gentleman'];
          var inkompatibel = {
            'tier':     [],
            'person':   ['regenbogenbruecke'],
            'paar':     ['regenbogenbruecke'],
            'gruppe':   ['regenbogenbruecke','action-figure'],
            'baby':     ['regenbogenbruecke'],
            'fahrzeug': NUR_LEBEWESEN.concat(['berge','strand','blumenwiese','weihnachten','sternenhimmel']),
            'ort':      NUR_LEBEWESEN.concat(['berge','strand','blumenwiese','weihnachten','sternenhimmel']),
            'gebaeude': NUR_LEBEWESEN.concat(['berge','strand','blumenwiese','weihnachten','sternenhimmel'])
          };
          var sperren = inkompatibel[motiv] || [];
          /* FAMILIE 19.07.: Regenbogenbruecke fuer Familienbilder freigegeben (Niklas) */
          sperren = sperren.filter(function(x){ return x!=='regenbogenbruecke'; });
          document.querySelectorAll('#ap .ap-stil-btn').forEach(function(btn){
            var stil = btn.getAttribute('data-stil');
            if(sperren.indexOf(stil) > -1){
              btn.classList.add('ap-stil-disabled');
              btn.style.opacity='0.35';
              btn.style.pointerEvents='none';
              btn.title='Nicht für dieses Motiv geeignet';
              /* Falls aktiv → auf Aquarell wechseln */
              if(btn.classList.contains('on')){
                btn.classList.remove('on');
                document.querySelector('#ap .ap-stil-btn[data-stil="aquarell"]').classList.add('on');
                st.stil='aquarell';
              }
            } else {
              btn.classList.remove('ap-stil-disabled');
              btn.style.opacity='';
              btn.style.pointerEvents='';
              btn.title='';
            }
          });
          /* Motiv-Badge anzeigen */
          var motivLabels = {
            'tier':'🐾 Tier erkannt','person':'👤 Person erkannt','paar':'👫 Paar erkannt',
            'baby':'👶 Baby erkannt','gruppe':'👥 Gruppe erkannt','fahrzeug':'🚗 Fahrzeug erkannt',
            'ort':((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'🏙 Location detected':'🏙 Ort erkannt'),'gebaeude':((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'🏠 Building detected':'🏠 Gebäude erkannt')
          };
          var badge = document.getElementById('apMotivBadge');
          if(badge) { badge.textContent = motivLabels[motiv]||''; badge.style.display='block'; }
        })
        .catch(function(){});
      } catch(e){}
    })();

    var prev=document.getElementById('apUploadPreview');
    prev.src=ev.target.result;
    prev.style.display='block';
    document.getElementById('apUploadPH').style.display='none';
    document.getElementById('apUploadChange').style.display='block';
    uploadBox.classList.add('has-file');
    /* FAMILIEN-GUARD: auf /pages/familie NICHT automatisch zur Stilauswahl —
       das macht ausschliesslich apfNext() NACH erfolgreichem Merge. */
    if(!st.pendingStil && !document.getElementById('apfSlots')){
      var ss=document.getElementById('apStileSection');
      ss.style.display='block';
      if(window.apFilterStep2ByThema)apFilterStep2ByThema();
      setTimeout(function(){ss.scrollIntoView({behavior:'smooth',block:'start'});},200);
    }
  };
  window.apHeicFix(f).then(function(f2){ if(!f2) return; f=f2; r.readAsDataURL(f2); });
});

uploadBox.addEventListener('dragover',function(e){e.preventDefault();uploadBox.style.borderColor='var(--blush)'});
uploadBox.addEventListener('dragleave',function(){uploadBox.style.borderColor=''});
uploadBox.addEventListener('drop',function(e){
  e.preventDefault();
  var f=e.dataTransfer.files[0];
  if(f&&f.type.startsWith('image/')){
    fi.files=e.dataTransfer.files;
    fi.dispatchEvent(new Event('change'));
  }
});

/* ── LADE-OVERLAY ── */
var _loadTimer=null;
var _loadStep=0;
var _loadSteps=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?[
    {emoji:'🎬',msg:'Your artwork is coming to life ...',pct:4},
    {emoji:'📸',msg:'Analyzing your photo ...',pct:8},
    {emoji:'🎨',msg:'Choosing the perfect style ...',pct:18},
    {emoji:'✏️',msg:'First brushstrokes ...',pct:30},
    {emoji:'🖌️',msg:'Working out the details ...',pct:44},
    {emoji:'✨',msg:'Optimizing colors and contrast ...',pct:58},
    {emoji:'🖼️',msg:'Finalizing your artwork ...',pct:72},
    {emoji:'🔍',msg:'Running quality checks ...',pct:84},
    {emoji:'⏳',msg:'Almost done, one more moment ...',pct:92},
    {emoji:'🎉',msg:'Nearly there …',pct:97}
  ]:[
    {emoji:'🎬',msg:'Dein Werk entsteht …',pct:4},
    {emoji:'📸',msg:'Foto wird analysiert ...',pct:8},
    {emoji:'🎨',msg:'KI wählt den perfekten Stil ...',pct:18},
    {emoji:'✏️',msg:'Erste Pinselstriche ...',pct:30},
    {emoji:'🖌️',msg:'Details werden ausgearbeitet ...',pct:44},
    {emoji:'✨',msg:'Farben und Kontraste optimieren ...',pct:58},
    {emoji:'🖼️',msg:'Kunstwerk wird finalisiert ...',pct:72},
    {emoji:'🔍',msg:'Qualitätsprüfung läuft ...',pct:84},
    {emoji:'⏳',msg:'Fast fertig, noch einen Moment ...',pct:92},
    {emoji:'🎉',msg:'Gleich fertig …',pct:97}
  ];
var _loadSub=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?['Museum quality · lightfast & vivid','One of a kind · made just for you','Free preview · no sign-up','Ready to hang in '+(location.hostname.indexOf('us.')===0?'4 to 8':'4 to 7')+' business days','Many styles · one signature']:['Museumsqualität · lichtecht & brillant','Ein Unikat · entsteht gerade nur für dich','Kostenlose Vorschau · keine Anmeldung','Fertig zum Aufhängen in 4 bis 7 Werktagen','Viele Stile · eine Handschrift'];
var _loadSubStep=0,_loadSubTimer=null;
function apLadeSubStep(){
  var el=document.getElementById('apLoadSub'); if(!el)return;
  el.style.opacity='0';
  setTimeout(function(){ var _sub=_loadSubAktiv||_loadSub; _loadSubStep=(_loadSubStep+1)%_sub.length; el.textContent=_sub[_loadSubStep]; el.style.opacity='1'; },500);
}
/* AP_MEMORIAL_LOAD: ruhige Lade-Variante fuer Andenken-Stile (Weiche nur Anzeige, keine Logik-AEnderung) */
var _memLoadSteps=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?[
    {emoji:'',msg:'Your picture is taking shape. We\u2019re taking our time.',pct:10},
    {emoji:'',msg:'Composition, light and brushwork are coming together.',pct:40},
    {emoji:'',msg:'The final details are emerging.',pct:75},
    {emoji:'',msg:'Almost done.',pct:94}
  ]:[
    {emoji:'',msg:'Dein Bild entsteht, wir nehmen uns einen Moment Zeit.',pct:10},
    {emoji:'',msg:'Komposition, Licht und Pinselstruktur werden aufgebaut.',pct:40},
    {emoji:'',msg:'Die letzten Details entstehen.',pct:75},
    {emoji:'',msg:'Fast fertig.',pct:94}
  ];
var _memLoadSub=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?['An image that lasts.','Free preview \u00b7 decide at your own pace']:['Ein Bild, das bleibt.','Kostenlose Vorschau \u00b7 du entscheidest in Ruhe'];
var _familyLoadSteps=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?[
    {emoji:'',msg:'Preparing the canvas \u2026',pct:8},
    {emoji:'',msg:'Each face is carefully transferred \u2026',pct:22},
    {emoji:'',msg:'Brushstroke by brushstroke, your picture comes to life \u2026',pct:40},
    {emoji:'',msg:'Light and depth are building up \u2026',pct:58},
    {emoji:'',msg:'Colors are finely balanced \u2026',pct:72},
    {emoji:'',msg:'Every detail is checked \u2026',pct:85},
    {emoji:'',msg:'The final touches \u2026',pct:94}
  ]:[
    {emoji:'',msg:'Die Leinwand wird vorbereitet \u2026',pct:8},
    {emoji:'',msg:'Jedes Gesicht wird sorgf\u00e4ltig \u00fcbertragen \u2026',pct:22},
    {emoji:'',msg:'Pinselstrich f\u00fcr Pinselstrich entsteht euer Bild \u2026',pct:40},
    {emoji:'',msg:'Licht und Tiefe werden aufgebaut \u2026',pct:58},
    {emoji:'',msg:'Farben werden fein aufeinander abgestimmt \u2026',pct:72},
    {emoji:'',msg:'Jedes Detail wird gepr\u00fcft \u2026',pct:85},
    {emoji:'',msg:'Der letzte Feinschliff \u2026',pct:94}
  ];
var _familyLoadSub=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?['Your artwork is created with care. Good art takes about two minutes','Family merge \u00b7 up to '+((window.apAufOk&&apAufOk())?AP_ZEHN.max:4)+' photos in one picture','No quick filter, but a freshly composed artwork','One shared picture that lasts \u00b7 please keep the page open','Free preview \u00b7 decide at your own pace']:['Euer Kunstwerk entsteht in Ruhe. Gute Kunst braucht etwa zwei Minuten','Familien-Zusammenf\u00fchrung \u00b7 bis zu '+((window.apAufOk&&apAufOk())?AP_ZEHN.max:4)+' Fotos in einem Bild','Kein Schnell-Filter, sondern ein neu komponiertes Kunstwerk','Ein gemeinsames Bild, das bleibt \u00b7 bitte lasst die Seite ge\u00f6ffnet','Kostenlose Vorschau \u00b7 ihr entscheidet in Ruhe'];
function apIstAndenken(){ try{ return (AP_CAT[st.stil]||'')==='andenken'; }catch(e){ return false; } }
function apLadeVideoWahl(){
  var v=document.getElementById('apLoadVideo'), src=document.getElementById('apLoadVideoSrc');
  if(!v||!src) return;
  var _fam=false; try{ _fam=!!(window.st&&st.familyMergedUrl); }catch(e){}
  var soll=(_fam||apIstAndenken())? v.getAttribute('data-memorial') : v.getAttribute('data-default');
  if(src.getAttribute('src')!==soll){ src.setAttribute('src',soll); try{v.load();v.play().catch(function(){});}catch(e){} }
}
/* ── 25.10.2026 STUFE 1: Hinweis im Ladefenster + Zaehlstellen start/weg ──
   Bis der App-Wechsel-Fix (Job-Abholung) live ist, bricht ein App-Wechsel am
   Handy die Generierung ab. Darum klar sagen: Seite offen lassen.
   AP_LADE_DAUER nach der Stoppuhr-Messung anpassen. */
var AP_LADE_DAUER=(AP_L==='en')?'about a minute':'etwa eine Minute';   /* AP-LADEBALKEN-V2-2910: gemessen 29.10. 56,5 bis 59,4 s */
var AP_LADE_SEK=60;
function apLadeErwartet(){ try{ if(window.st&&st.familyMergedUrl) return 110; }catch(e){} return AP_LADE_SEK; }
function apLadeBalken(){ var bar=document.getElementById('apLoadBar'); if(!bar||!window.__apLadeT0) return; var t=(Date.now()-window.__apLadeT0)/1000, E=apLadeErwartet(), p=(t<E)? 92*t/E : 92+6*(1-Math.exp(-(t-E)/30)); bar.style.width=p.toFixed(1)+'%'; var pe=document.getElementById('apLbPct'); if(pe) pe.textContent=Math.floor(p); var ze=document.getElementById('apLbZeit'); if(ze){ var r=Math.ceil(E-t); ze.textContent=(r>3)? ((AP_L==='en')?'about '+r+' seconds left':'noch etwa '+r+' Sekunden') : ((AP_L==='en')?'Almost done, final details':'Gleich fertig, letzte Details'); } }
function apLadeHinweis(){
  try{
    var ov=document.getElementById('apLoadOverlay'); if(!ov) return;
    var h=document.getElementById('apLoadHinweis');
    if(!h){
      h=document.createElement('div'); h.id='apLoadHinweis';
      h.setAttribute('style','margin:16px auto 0;max-width:340px;font:600 14px/1.5 Inter,system-ui,sans-serif;color:#FAF7F2;text-align:center;text-shadow:0 1px 6px rgba(0,0,0,.55);background:rgba(0,0,0,.30);padding:10px 16px;border-radius:12px');
      (ov.querySelector('.ap-load-inner')||ov).appendChild(h);
    }
  var _d=AP_LADE_DAUER; try{ if(window.st&&st.familyMergedUrl) _d=(AP_L==='en')?'about two minutes':'etwa zwei Minuten'; }catch(e){}
    h.setAttribute('data-dauer', _d);
    h.textContent=(AP_L==='en')
      ? 'Your artwork is being created. This takes '+_d+'. Please stay on this page until it\u2019s ready.'
      : 'Dein Kunstwerk entsteht. Das dauert '+_d+'. Bitte bleib so lange auf dieser Seite.';
    if(window.apZaehl && !window.__apOhneStart) window.apZaehl('start');
  }catch(e){}
}
if(!window.__apWegZaehler){ window.__apWegZaehler=true;
  document.addEventListener('visibilitychange', function(){
    try{
      if(document.visibilityState!=='hidden') return;
      var ov=document.getElementById('apLoadOverlay'), mo=document.getElementById('apfMergeOv');
      if((ov&&ov.classList.contains('on'))||(mo&&mo.style.display!=='none')){ if(window.apZaehl) window.apZaehl('weg'); }
    }catch(e){}
  });
}
function apLadeStart(){
  if(_loadTimer){clearInterval(_loadTimer);_loadTimer=null;}
  _loadStep=0;
  var _fam=false; try{ _fam=!!(window.st&&st.familyMergedUrl); }catch(e){}
  var _mem=apIstAndenken();
  _loadStepsAktiv=_fam? _familyLoadSteps : (_mem? _memLoadSteps : _loadSteps);
  _loadSubAktiv=_fam? _familyLoadSub : (_mem? _memLoadSub : _loadSub);
  apLadeVideoWahl();
  var _lt=document.querySelector('#apLoadOverlay .ap-load-title');
  if(_lt){ _lt.textContent=_fam?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Soon you’ll be together again':'Bald seid ihr wieder vereint'):(_mem?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Your picture is coming to life':'Dein Bild entsteht'):((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Your masterpiece is coming to life':'Dein Meisterwerk entsteht')); _lt.classList.toggle('ap-load-title--fam', !!_fam); }
  document.getElementById('apLoadOverlay').classList.add('on');
  apLadeHinweis();
  apLadeStep();
  window.__apLadeT0=Date.now(); if(window.__apBarT) clearInterval(window.__apBarT); window.__apBarT=setInterval(apLadeBalken,300); apLadeBalken();
  _loadTimer=setInterval(apLadeStep, Math.max(1800, Math.round(apLadeErwartet()*1000/((_loadStepsAktiv||_loadSteps).length))));
  _loadSubStep=0;
  if(_loadSubTimer){clearInterval(_loadSubTimer);}
  _loadSubTimer=setInterval(apLadeSubStep, 2600);
}
var _loadStepsAktiv=null,_loadSubAktiv=null;
function apLadeStep(){
  var _ls=_loadStepsAktiv||_loadSteps;
  var s=_ls[Math.min(_loadStep,_ls.length-1)];
  var msg=document.getElementById('apLoadMsg');
  var bar=document.getElementById('apLoadBar');
  var emoji=document.getElementById('apLoadEmoji');
  msg.style.opacity='0';
  setTimeout(function(){
    if(emoji)emoji.textContent=s.emoji;
    msg.textContent=s.msg;
    msg.style.opacity='1';
  },200);
  /* AP-LADEBALKEN-V2-2910: Balkenbreite kommt aus apLadeBalken (Zeit) */
  _loadStep++;
}
function apLadeStop(){
  if(window.__apBarT){clearInterval(window.__apBarT);window.__apBarT=null;} window.__apLadeT0=0; try{ var _pe=document.getElementById('apLbPct'); if(_pe) _pe.textContent='100'; }catch(e){}
  if(_loadTimer){clearInterval(_loadTimer);_loadTimer=null;}
  if(_loadSubTimer){clearInterval(_loadSubTimer);_loadSubTimer=null;}
  var bar=document.getElementById('apLoadBar');
  // Transition entfernen → sofort 100%
  if(bar){bar.style.transition='none';bar.style.width='100%';}
  setTimeout(function(){
    document.getElementById('apLoadOverlay').classList.remove('on');
    if(bar){bar.style.width='0%';bar.style.transition='';}
    _loadStep=0;
  },350);
}
window.apSyncGenBtn=function(){
  var t=document.getElementById('apGenTxt');
  if(t) t.textContent=T.inStilA+(st.stilName||T.deinStil)+T.inStilB;
};
window.apStil=function(btn){
  document.querySelectorAll('#ap .ap-stil-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  apStilSliderClick(btn.dataset.stil);
};

/* ── BUNDLE POPUP ── */
/* Die zwei NEUESTEN echten Kunstwerke — ohne das unstilisierte Original-Fotoportraet */
window.apBundlePick=function(){
  var a=((typeof st!=='undefined'&&st.artHistory)||[]).filter(function(w){ return w && w.stilId!=='original'; });
  return a.slice(-2).reverse();
};
function apBundleShow(){
  var h=apBundlePick();
  if(h.length<2)return;
  if(typeof apIsUS==='function' && apIsUS()) return; /* 23.10.: 2er-Rabatt gilt nicht fuer US-Produkte -> kein Popup auf us. */
  /* Preise berechnen: 2 Bilder gleiche Größe = 10% Rabatt (24.10.2026, vorher 20%) */
  var _abtn=document.querySelector('#ap .ap-size-btn.on');
  var _akt=_abtn?parseFloat(_abtn.dataset.price):NaN;
  var einzelPreis=isNaN(_akt)?(h[0].price+h[1].price):(_akt*2);
  var bundlePreis=Math.round(einzelPreis*0.90*100)/100;
  var ersparnis=Math.round((einzelPreis-bundlePreis)*100)/100;
  var bWas=document.getElementById('apBundleWas');if(bWas)bWas.textContent=einzelPreis.toFixed(2).replace('.',',')+'€';
  var bNow=document.getElementById('apBundleNow');if(bNow)bNow.textContent=bundlePreis.toFixed(2).replace('.',',')+'€';
  var bSave=document.getElementById('apBundleSave');if(bSave)bSave.textContent=T.duSparst+ersparnis.toFixed(2).replace('.',',')+'€';
  /* Vorschau-Bilder */
  var prev=document.getElementById('apBundlePreviews');
  prev.innerHTML='';
  h.slice(0,2).forEach(function(item){
    var img=document.createElement('img');
    img.crossOrigin='anonymous';
    img.src=item.url;
    img.className='ap-bundle-thumb';
    img.alt=item.stil;
    var wrap=document.createElement('div');
    wrap.style.cssText='text-align:center';
    var label=document.createElement('div');
    label.style.cssText='font-size:10px;color:var(--ink-soft);margin-top:4px;font-weight:600;letter-spacing:.05em;text-transform:uppercase';
    label.textContent=item.stil;
    wrap.appendChild(img);wrap.appendChild(label);
    prev.appendChild(wrap);
  });
  document.getElementById('apBundlePopup').classList.add('on');
  document.body.style.overflow='hidden';
}
window.apBundleClose=function(){
  document.getElementById('apBundlePopup').classList.remove('on');
  document.body.style.overflow='';
};
window.apBundleBuy=function(){
  apBundleClose();
  /* Beide in den Warenkorb — nacheinander */
  var h=apBundlePick();
  var _fmtVorher=st.format;
  var items=h.map(function(item,i){
    if(item.format) st.format=item.format;
    return {
      id:apVid(st.size),quantity:1,
      properties:{
        [(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Art style':'Kunststil']:item.stil,
        [(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Size':'Größe']:apSzName(st.size),
        '_artwork_url':item.url,
        '_bundle':(AP_L==='en'?'2-piece bundle':'2er Bundle')
      }
    };
  });
  st.format=_fmtVorher;
  fetch('/cart/add.js',{method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:items})})
  .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
  .then(function(){ window.location.href='/cart'; })
  .catch(function(){ alert('Die beiden Werke konnten nicht in den Warenkorb gelegt werden. Bitte versuche es noch einmal.'); });
};
var _miniPreviewTimer=null;
window.apUpdateMiniPreview=function(){
  if(window.innerWidth>680)return; /* Nur auf Mobile */
  var src=document.getElementById('apWmCanvas');
  if(!src||!src.width||!st.artImg)return;
  var preview=document.getElementById('apInlinePreview');
  var cv=document.getElementById('apInlineCanvas');
  if(!preview||!cv)return;
  preview.style.display='block';
  /* Debounce: max 1× pro 100ms */
  clearTimeout(_miniPreviewTimer);
  _miniPreviewTimer=setTimeout(function(){
    cv.width=src.width;
    cv.height=src.height;
    cv.getContext('2d').drawImage(src,0,0);
  },80);
};

/* ── ZOOM ── */
window.apZoomOpen=function(){
  var src=document.getElementById('apWmCanvas');
  if(!src||!src.width)return;
  var zimg=document.getElementById('apZoomImg');
  if(zimg)zimg.style.display='none';
  var overlay=document.getElementById('apZoomOverlay');
  var zc=document.getElementById('apZoomCanvas');
  zc.style.display='block';
  var scale=Math.min(window.innerWidth*0.95/src.width, window.innerHeight*0.9/src.height, 3);
  zc.width=src.width*scale;zc.height=src.height*scale;
  zc.getContext('2d').drawImage(src,0,0,zc.width,zc.height);
  overlay.classList.add('on');
  document.body.style.overflow='hidden';
};
/* Zoom für Stil-Vorschaubilder (und andere Bild-URLs) */
window.apZoomImage=function(url){
  var overlay=document.getElementById('apZoomOverlay');
  var zc=document.getElementById('apZoomCanvas');
  var zimg=document.getElementById('apZoomImg');
  if(zc)zc.style.display='none';
  zimg.crossOrigin='anonymous';
  zimg.src=url;
  zimg.style.display='block';
  overlay.classList.add('on');
  document.body.style.overflow='hidden';
};
window.apZoomClose=function(){
  document.getElementById('apZoomOverlay').classList.remove('on');
  document.body.style.overflow='';
};
/* Tap auf Hintergrund schließt Zoom */
document.getElementById('apZoomOverlay').addEventListener('click',function(e){
  if(e.target===this||e.target.classList.contains('ap-zoom-hint'))apZoomClose();
});

/* ── TOOLTIP (Desktop hover + Mobile ℹ tap) ── */
window.apTip=function(e,icon){
  e.stopPropagation();
  var btn=icon.closest('.ap-stil-btn');
  var tip=btn.querySelector('.ap-tip');
  if(!tip)return;
  var isOpen=tip.classList.contains('visible');
  document.querySelectorAll('#ap .ap-tip.visible').forEach(function(t){t.classList.remove('visible')});
  if(isOpen)return;
  tip.style.left='50%';tip.style.transform='translateX(-50%)';
  tip.classList.add('visible');
  requestAnimationFrame(function(){
    var r=tip.getBoundingClientRect();
    var pad=12;
    if(r.left<pad){tip.style.left='calc(50% + '+(pad-r.left)+'px)';}
    else if(r.right>window.innerWidth-pad){tip.style.left='calc(50% - '+(r.right-(window.innerWidth-pad))+'px)';}
  });
  setTimeout(function(){tip.classList.remove('visible');},4000);
};
document.addEventListener('click',function(e){
  if(!e.target.closest('.ap-stil-btn')){
    document.querySelectorAll('#ap .ap-tip.visible').forEach(function(t){t.classList.remove('visible')});
  }
});

/* ── FORMAT ── */
window.apFmt=function(btn){
  document.querySelectorAll('#ap .ap-fmt-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.format=btn.dataset.fmt;
  st.roomOrientation=btn.dataset.fmt;
  /* STAGE v7: Format-Klasse am Root — CSS kann hoch/quer getrennt dimensionieren */
  try{var _apRoot=document.getElementById('ap');if(_apRoot)_apRoot.classList.toggle('ap-quer',st.format==='quer');}catch(e){}
  /* Cache invalidieren damit Room Mockup neu gezeichnet wird */
  _roomCache=null;_roomCacheKey='';
  /* Maße in allen Größen-Buttons aktualisieren */
  var isQuer=st.format==='quer';
  var hint=document.getElementById('apFmtHint');
  if(hint)hint.textContent=isQuer?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Ideal for landscapes, cars & group photos':'Ideal für Landschaften, Autos & Gruppenfotos'):((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Ideal for portraits, pets & people':'Ideal für Porträts, Haustiere & Personen');
  document.querySelectorAll('#ap .ap-size-btn').forEach(function(b){
    var cm=b.querySelector('.sz-cm');
    if(!cm)return;
    if(typeof apIsUS==='function' && apIsUS()){
      var z=AP_ZOLL[b.dataset.size];
      if(z){ cm.textContent = isQuer ? z.quer : z.hoch; return; }
    }
    var hoch=b.dataset.fmtHoch;
    var quer=b.dataset.fmtQuer;
    if(isQuer&&quer)cm.textContent=quer+' cm';
    else if(hoch)cm.textContent=hoch+' cm';
  });
  /* PIPE v3: beim Werk-Wechsel KEIN Sprung/Doppel-Render — apSelectWerk refresht zentral.
     Sonst: Tab springt zur Wand, Wand rendert Vorgaenger, Vorschau rechnet mit Pane-Breite 0. */
  if(!window._apSelecting){
    /* Room Mockup neu zeichnen falls Tab aktiv */
    if(st.artImg)apDrawRoom();
    if(window.apDrawMockup && st.artImg)apDrawMockup();
    /* Format-Wechsel -> immer in "An der Wand" springen (wie Material) */
    if(st.artImg && typeof apWand==='function') apWand();
  }
};

/* ── GENERIEREN ── */
/* ── APP-WECHSEL-FIX 25.10.2026: Generierung als Hintergrund-Job ──
   Das Theme schickt eine Job-ID mit. Neuer Worker: antwortet sofort "laeuft", das
   Ergebnis wird per GET /job abgeholt — auch wenn der Kunde zwischendurch die App
   wechselt oder die Seite neu laedt. Alter Worker: antwortet wie bisher direkt mit
   dem Ergebnis (rueckwaertskompatibel). fertig(d) bekommt IMMER die Antwort im
   bisherigen Format; d===null heisst Netzfehler. Steht identisch in
   arturell-product.js und arturell-family.js (die erste geladene gewinnt). */
(function(){
  if (window.apJobSenden) return;
  var WK='https://arturell-preview.arturell.workers.dev';
  var KEY='apJob', HALTEN=60*60*1000;
  function neueId(){
    try{ var a=new Uint8Array(16); crypto.getRandomValues(a); var s=''; for(var i=0;i<a.length;i++){ s+=('0'+a[i].toString(16)).slice(-2); } return s; }
    catch(e){ return (Date.now().toString(36)+Math.random().toString(36).slice(2)+Math.random().toString(36).slice(2)).replace(/[^a-z0-9]/g,'').slice(0,32); }
  }
  function merke(o){ try{ if(o) localStorage.setItem(KEY, JSON.stringify(o)); else localStorage.removeItem(KEY); }catch(e){} }
  window.apJobGemerkt=function(){
    try{ var o=JSON.parse(localStorage.getItem(KEY)||'null'); if(o && o.job && Date.now()-(o.t||0) < HALTEN) return o; if(o) localStorage.removeItem(KEY); }catch(e){}
    return null;
  };
  window.apJobWarten=function(job, fertig, opt){
    opt=opt||{};
    var erledigt=false, timer=null, unbekannt=0, t0=Date.now(), warWeg=(document.visibilityState==='hidden');
    function ende(d){
      if(erledigt) return; erledigt=true;
      if(timer){ clearTimeout(timer); timer=null; }
      document.removeEventListener('visibilitychange', sicht);
      window.removeEventListener('pageshow', sicht);
      window.removeEventListener('online', sicht);
      merke(null);
      try{ if(d && (warWeg || opt.rueckkehr) && window.apZaehl) window.apZaehl('rueckkehr'); }catch(e){}
      fertig(d);
    }
    function plane(ms){ if(erledigt) return; if(timer) clearTimeout(timer); timer=setTimeout(frage, ms); }
    function frage(){
      if(erledigt) return;
      if(timer){ clearTimeout(timer); timer=null; }
      if(Date.now()-t0 > 15*60*1000){ ende(null); return; }
      fetch(WK+'/job?id='+job, {cache:'no-store'})
        .then(function(r){ return r.json(); })
        .then(function(s){
          if(s && (s.status==='fertig' || s.status==='fehler')){ ende(s.antwort||{}); return; }
          if(s && s.status==='laeuft'){ unbekannt=0; plane(2500); return; }
          unbekannt++;
          if(unbekannt >= (opt.maxUnbekannt||4)){ ende(null); return; }
          plane(2500);
        })
        .catch(function(){ plane(document.visibilityState==='hidden'?6000:1500); });
    }
    function sicht(){ if(document.visibilityState==='hidden'){ warWeg=true; } else { frage(); } }
    document.addEventListener('visibilitychange', sicht);
    window.addEventListener('pageshow', sicht);
    window.addEventListener('online', sicht);
    plane(opt.ersteMs||3000);
  };
  window.apJobSenden=function(body, art, fertig, extra){
    var job=neueId(); body.job=job;
    var m={job:job, art:art, t:Date.now()}; if(extra){ for(var k in extra){ m[k]=extra[k]; } }
    merke(m);
    /* AP-UPLOAD-STABIL-2910: bei abgelehntem Sicherheits-Token einmal mit frischem Token nachsenden */
    function _apSende(){
      return (window.apTsToken?window.apTsToken():Promise.resolve('')).then(function(tk){
        body.tsToken=tk;
        return fetch(WK, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)});
      }).then(function(r){ return r.json(); });
    }
    _apSende()
    .then(function(d){ if(d && d.error==='bot'){ return new Promise(function(w){ setTimeout(w,1500); }).then(_apSende); } return d; })
    .then(function(d){
      if(d && d.job===job && d.status==='laeuft'){
        try{ if(window.apLadeHinweis2) window.apLadeHinweis2(); }catch(e){}
        window.apJobWarten(job, fertig); return;
      }
      merke(null);
      if(d && d.job===job && d.antwort){ fertig(d.antwort); return; }
      fertig(d);   /* alter Worker oder sofortige Antwort (Limit, Bot-Pruefung, Fehler) */
    })
    .catch(function(){
      /* Antwort verloren (App-Wechsel waehrend des Hochladens, Funkloch): der Job kann
         trotzdem angekommen sein -> nachfragen; "unbekannt" = wirklich nicht angekommen */
      window.apJobWarten(job, fertig, {ersteMs:1500, maxUnbekannt:4});
    });
    return job;
  };
})();
/* Stufe 2 des Ladehinweises — wird erst gesetzt, wenn der Worker "laeuft" bestaetigt hat */
window.apLadeHinweis2=function(){
  try{
    var en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
    var h=document.getElementById('apLoadHinweis');
    if(h && h.textContent){
      var d=h.getAttribute('data-dauer')||'';
      h.textContent=en
        ? 'Your artwork is being created. This takes '+d+'. Feel free to do something else: when you come back, it’ll be waiting for you here.'
        : 'Dein Kunstwerk entsteht. Das dauert '+d+'. Erledige ruhig deine Sachen: Wenn du zurückkommst, wartet dein Bild hier auf dich.';
    }
    var ms=document.getElementById('apfMergeSub');
    if(ms) ms.textContent=en
      ? ('This takes about '+((window.st&&(st.familyFotos||[]).length>4)?'two to three minutes':'a minute')+'. Feel free to do something else: when you come back, your photo will be waiting here.')
      : ('Das dauert etwa '+((window.st&&(st.familyFotos||[]).length>4)?'zwei bis drei Minuten':'eine Minute')+'. Erledige ruhig deine Sachen: Wenn du zurückkommst, wartet dein Foto hier auf dich.');   /* AP-ZEHN-A-0111 */
  }catch(e){}
};
window.apGen=function(){
  /* 21.07.: "original" ist kein Modell-Stil — nie an den Worker schicken, egal ueber welchen Klickpfad */
  if(window.st && st.stil==='original'){ if(window.apOriginalWaehlen) window.apOriginalWaehlen(); return; }
  if(!st.foto && !st.familyMergedUrl){alert('Bitte zuerst ein Foto hochladen.');return;}
  if(st.busy)return;
  st.busy=true;
  var btn=document.getElementById('apGenBtn');
  btn.disabled=true;
  document.getElementById('apSpin').style.display='block';
  document.getElementById('apGenTxt').textContent=T.generiere;
  apLadeStart();

  /* Foto komprimieren (max 800px) dann als Base64 an Worker */
  function komprimieren(file, callback){
    var reader=new FileReader();
    reader.onload=function(e){
      var img=new Image();
      img.onload=function(){
        var MAX=800;
        var w=img.width, h=img.height;
        if(w>MAX||h>MAX){
          if(w>h){h=Math.round(h*MAX/w);w=MAX;}
          else{w=Math.round(w*MAX/h);h=MAX;}
        }
        var cv=document.createElement('canvas');
        cv.width=w;cv.height=h;
        cv.getContext('2d').drawImage(img,0,0,w,h);
        callback(cv.toDataURL('image/jpeg',0.85));
      };
      /* Ohne onerror haengt das Lade-Overlay bei nicht dekodierbaren Dateien
         fuer immer — st.busy wird nie zurueckgesetzt (Fund 21.08.). */
      img.onerror=function(){callback(null);};
      img.src=e.target.result;
    };
    reader.onerror=function(){callback(null);};
    reader.readAsDataURL(file);
  }

  function _apGenSend(base64){
    if(!base64){
      /* Foto nicht dekodierbar: frueher stummer Fake-Erfolg mit Rohfoto
         (Fund 21.08., wie im Einzel-Konfigurator). */
      st.busy=false;btn.disabled=false;
      apLadeStop();
      document.getElementById('apSpin').style.display='none';
      apSyncGenBtn();
      var _en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
      alert(_en?'This photo could not be read (e.g. HEIC). Please choose a JPG or PNG photo.':'Dieses Foto konnte nicht gelesen werden (z. B. HEIC). Bitte wähle ein Foto als JPG oder PNG.');
      return;
    }
    /* APP-WECHSEL-FIX 25.10.: Auftrag mit Job-ID, Ergebnis wird abgeholt (auch nach App-Wechsel) */
    window.apJobSenden(st.familyMergedUrl ? {
        image:st.familyMergedUrl,
        stil:st.stil,
        format:st.familyFormat||st.format||'hoch',
        forceMotiv:'gruppe',
        dev:window.apDevId?window.apDevId():'',
        grant:window.apGrant?window.apGrant():''
      } : {
        image:base64,
        stil:st.stil,
        format:st.format||'hoch',
        zeile1:st.pers.line1||'',
        dev:window.apDevId?window.apDevId():'',
        grant:window.apGrant?window.apGrant():''
      }, 'gen', function(d){
      if(d===null){ _apNetzfehler(); return; }
      function doStop(){
        st.busy=false;
        btn.disabled=false;
        apLadeStop();
        document.getElementById('apSpin').style.display='none';
        apSyncGenBtn();
      }
      console.log('Frontend d:', JSON.stringify({ok:d.ok, preview: d.preview ? d.preview.slice(0,80) : null}));
      if(d.ok&&d.preview){
        // Bild vollständig laden BEVOR Overlay verschwindet
        var pre=new Image();
        pre.crossOrigin='anonymous';
        pre.onload=function(){zeigResult(d.preview);doStop();};
        pre.onerror=function(){zeigResult(d.preview);doStop();};
        pre.src=d.preview;
      } else {
        /* 21.07.: Fehlschlag = KEIN Werk, KEINE Quota, ehrliche Meldung */
        doStop();
        if(window.apZaehl) window.apZaehl('fehler', (typeof d!=='undefined')?d:null);
        /* MAILGATE (12.08.): Geraete-Kontingent aufgebraucht -> E-Mail-Fenster oeffnen.
           Toter lokaler Grant (abgelaufen/rotiert) wird weggeworfen. */
        if(d && d.error==='limit' && d.grund==='mailgate'){
          try{ localStorage.removeItem('apMailGrant'); }catch(e){}
          if(window.apfNlOpen){ window.apfNlOpen('form'); return; }
        }
        var _grund = (d && (d.message || d.error)) ? String(d.message || d.error) : '';
        alert((AP_L==='en'?"We couldn't create your artwork this time":'Das Kunstwerk konnte diesmal nicht erstellt werden') + (_grund ? ':\n' + _grund : '.') + (AP_L==='en'?'\n\nNothing was charged. Please try again.':'\n\nEs wurde nichts angerechnet. Bitte versuche es noch einmal.'));
      }
    }, {stil:st.stil, stilName:st.stilName, format:(st.familyFormat&&st.familyMergedUrl)?st.familyFormat:(st.format||'hoch'), seite:'f'});
    function _apNetzfehler(){
      if(window.apZaehl) window.apZaehl('fehler', (typeof d!=='undefined')?d:null);
      /* Netzfehler/Nicht-JSON: NIE das (ggf. unstilisierte Merge-)Foto als
         Werk ausgeben — es truege den Stil-Badge, verbrennt einen der 5
         Familien-Slots und ginge als _artwork_url durch die Fulfillment-
         Whitelist in den DRUCK (Fund 21.08., adversarial bestaetigt). */
      st.busy=false;
      btn.disabled=false;
      apLadeStop();
      document.getElementById('apSpin').style.display='none';
      apSyncGenBtn();
      var _en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
      alert(_en?"We couldn't create your artwork this time.\n\nNothing was charged. Please try again.":'Das Kunstwerk konnte diesmal nicht erstellt werden.\n\nEs wurde nichts angerechnet. Bitte versuche es noch einmal.');
    }
  }
  if(st.familyMergedUrl){ _apGenSend('FAMILY'); }
  else { komprimieren(st.foto, _apGenSend); }
};

window.zeigResult = zeigResult;
window.zeigResult=zeigResult;
function zeigResult(url){
  st.artUrl=url;
  var _dup=false;
  for(var _i=0;_i<st.artHistory.length;_i++){ if(st.artHistory[_i].url===url){_dup=true;break;} }
  if(!_dup){
    if(st.stil!=='original')st.genCount++; /* Original ist gratis */
    st.artHistory.push({url:url,stil:st.stilName,stilId:st.stil,price:st.price,format:st.format,famM:(st.familyMotive||0)});
    apSaveWerke();
  }
  var img=document.getElementById('apResultImg');
  img.crossOrigin='anonymous';
  img.onload=function(){
    st.artImg=img;
    _bgCache=null;_bgCacheKey='';
    _roomCache=null;_roomCacheKey='';
    renderCanvas();
    apDrawRoom();
    if(typeof apDrawMockup==='function')apDrawMockup();
    apRenderStilSlider();
    apRenderWerke();
    apUpdateGenCounter();
    if(apBundlePick().length>=2 && !window._apBundleGezeigt){
      window._apBundleGezeigt=true;
      /* 24.10.2026: 2er-Popup ausgeschaltet (Trichter 23.-24.10.: 58 gezeigt, 0 Kaeufe); Rabattbox unter dem Preis bleibt */ void 0;
    }
  };
  img.src=url;
  document.getElementById('apStilBadge').textContent=st.stilName;
  document.getElementById('apResultSection').style.display='block';
  document.getElementById('apStileSection').style.display='none';
  /* Stil-Galerie einklappen — Kunde landet mit geschlossenen Stilen auf der Bearbeitung */
  var _ww=document.getElementById('apWerkeWrap');
  var _wc=document.getElementById('apStileChevron');
  if(_ww)_ww.style.display='none';
  if(_wc)_wc.textContent='▾';
  /* Dein-Foto-Thumbnail garantiert aktualisieren */
  var _fsth=document.getElementById('apFsThumb');
  if(_fsth&&(st.fotoSmall||st.fotoDataUrl))_fsth.src=(st.fotoSmall||st.fotoDataUrl);
  var hero=document.querySelector('#ap .ap-hero');
  if(hero)hero.style.display='none';
  setTimeout(function(){
    document.getElementById('apResultSection').scrollIntoView({behavior:'smooth',block:'start'});
  },200);
  aktualisierePreis();
}

/* ── CANVAS RENDERING ── */
function renderCanvas(){
  var img=document.getElementById('apResultImg');
  if(!img||!img.src)return;

  var cv=document.getElementById('apWmCanvas');
  if(!cv)return;

  function doRender(){
    if(!img.naturalWidth){setTimeout(doRender,100);return;}
    var IW=img.naturalWidth;
    var IH=img.naturalHeight;
    /* Container-Breite: mehrere Quellen prüfen */
    var container=cv.parentElement;
    var pane=document.getElementById('paneVorschau');
    var wrap=document.getElementById('apResultSection');
    var containerW=(pane&&pane.offsetWidth>10)?pane.offsetWidth:
                   (container&&container.offsetWidth>10)?container.offsetWidth:
                   (wrap&&wrap.offsetWidth>10)?Math.floor(wrap.offsetWidth*0.5):
                   Math.min(window.innerWidth-40,600);
    var dpr=Math.min(window.devicePixelRatio||1,2);
    var maxW=Math.min(containerW*dpr,IW,1200);
    var scale=maxW/IW;
    var W=Math.round(IW*scale);
    var H=Math.round(IH*scale);

    cv.width=W;cv.height=H;
    var ctx=cv.getContext('2d');

    /* CACHE-KEY: nur wenn Bild oder Größe sich ändert, Hintergrund neu bauen */
    var key=img.src+'|'+W+'x'+H;
    if(_bgCacheKey!==key||!_bgCache){
      _bgCache=document.createElement('canvas');
      _bgCache.width=W;_bgCache.height=H;
      var bctx=_bgCache.getContext('2d');
      /* BILD */
      bctx.drawImage(img,0,0,W,H);
      /* WASSERZEICHEN (teuer – nur hier, im Cache) */
      bctx.save();
      bctx.font='bold '+Math.round(W*0.045)+'px Inter,sans-serif';
      bctx.fillStyle='rgba(255,255,255,0.38)';
      bctx.textAlign='center';
      bctx.translate(W/2,H/2);
      bctx.rotate(-0.5);
      var step=W*0.44;
      for(var yy=-H;yy<H*2;yy+=step*0.65){
        for(var xx=-W;xx<W*2;xx+=step){
          // Kein Wasserzeichen-Text — niedrige Auflösung ist der Schutz
        }
      }
      bctx.restore();
      _bgCacheKey=key;
    }

    /* Schneller Pfad: gecachten Hintergrund kopieren + nur Text drüber */
    ctx.clearRect(0,0,W,H);
    ctx.drawImage(_bgCache,0,0);
    drawText(ctx,W,H);
    drawMini();
    /* STAGE v7.1: Contain-Fit sofort + verzoegert nachrechnen — Erst-Klick rendert sonst mit dem Layout des VORHERIGEN Werks (Buehne noch nicht umgebaut) */
    function _stageFit(){
      try{
        if(window.innerWidth>768){
          var _availW=(pane&&pane.offsetWidth>10)?pane.offsetWidth:containerW;
          var _availH=Math.max(window.innerHeight-290,240);
          var _fs=Math.min(_availW/IW,_availH/IH);
          cv.style.setProperty('width',Math.round(IW*_fs)+'px','important');
          cv.style.setProperty('height',Math.round(IH*_fs)+'px','important');
        }else{cv.style.removeProperty('width');cv.style.removeProperty('height');}
      }catch(e){}
    }
    _stageFit();
    try{requestAnimationFrame(_stageFit);setTimeout(_stageFit,250);setTimeout(_stageFit,600);}catch(e){}
    /* Canvas ist jetzt fertig → Material-Mockup neu zeichnen, falls sichtbar.
       Fix: erstes Kunstwerk erschien nicht im Rahmen (apDrawMockup lief vorher
       gegen einen noch leeren Canvas; nur Format-Toggle hat es repariert). */
    var _mp=document.getElementById('paneMaterial');
    if(_mp&&_mp.offsetParent!==null&&typeof window.apDrawMockup==='function')window.apDrawMockup();
  }

  if(img.complete&&img.naturalWidth){doRender();}
  else{img.onload=doRender;}
}

/* Schneller Text-Only Re-Render (für Tippen) – nutzt Cache, kein Wasserzeichen */
function renderTextOnly(){
  var cv=document.getElementById('apWmCanvas');
  if(!cv||!_bgCache||_bgCache.width!==cv.width){renderCanvas();return;}
  var ctx=cv.getContext('2d');
  ctx.clearRect(0,0,cv.width,cv.height);
  ctx.drawImage(_bgCache,0,0);
  drawText(ctx,cv.width,cv.height);
  drawMini();
}



/* ── SCHRIFTFELDER v2 (25.10.2026) ──
   Name + Datum je Anlass. Feste Vorlage (3 Schriften je Anlass), Datum immer Cormorant-Versalien.
   Position (ruhigste Zone), Farbe (hell/dunkel) und Lasur entscheidet der Browser und schickt das
   Ergebnis in _text_meta mit -> der Render-Dienst fuehrt nur aus (Vorschau = Druck).
   Masszahlen identisch zu scripts/schriftfeld_2510.py. */
var AP_SF_SIZES=[0.042,0.052,0.064,0.080,0.098];
var AP_SF_FONTS={
  greatvibes:{css:'"Great Vibes",cursive',k:1.40,w:'400',it:false,name:{de:'Schwungvoll',en:'Flowing'}},
  cormorantI:{css:'"Cormorant Garamond",Georgia,serif',k:1.18,w:'500',it:true,name:{de:'Schlicht',en:'Simple'}},
  playfair:{css:'"Playfair Display",Georgia,serif',k:0.98,w:'400',it:false,name:{de:'Klassisch',en:'Classic'}},
  caveat:{css:'Caveat,cursive',k:1.38,w:'500',it:false,name:{de:'Handschrift',en:'Handwritten'}},
  playwrite:{css:'"Playwrite US Trad",cursive',k:0.95,w:'400',it:false,name:{de:'Kinderschrift',en:'Playful'}}
};
var AP_SF_VORLAGEN={
  paar:{fonts:['greatvibes','cormorantI','playfair'],size:4},
  gedenken:{fonts:['cormorantI','playfair','greatvibes'],size:3},
  haustier:{fonts:['caveat','cormorantI','playfair'],size:4},
  familie:{fonts:['playfair','cormorantI','greatvibes'],size:3},
  kind:{fonts:['playwrite','caveat','cormorantI'],size:4}
};
var AP_SF_DATE={css:'"Cormorant Garamond",Georgia,serif',w:'600',scale:0.5,sp:0.26};
var AP_SF={bottom:0.08,top:0.065,side:0.08,gap:0.14,maxw:0.84};
var AP_SF_L=(window.Shopify&&Shopify.locale?Shopify.locale.slice(0,2):'de');
function apSfVorlageKey(){
  try{
    var q=new URLSearchParams(location.search);
    var a=(q.get('anlass')||'').toLowerCase().trim(), t=(q.get('thema')||q.get('kategorie')||'').toLowerCase().trim();
    var s=(st&&st.stil)||'';
    if(/^(regenbogenbruecke|sternenhimmel|engel|gedenkkerze|sonnenstrahlen)$/.test(s)||t==='andenken'||a==='gedenken'||a==='tier-gedenken')return 'gedenken';
    if(/^(hochzeit|jahrestag|paar|valentinstag)$/.test(a))return 'paar';
    if(/^(tier|tiere|hund|katze|haustier|pferd)$/.test(a))return 'haustier';
    if(/^(baby|kind|geburt|taufe)$/.test(a))return 'kind';
  }catch(e){}
  return 'familie';
}
function apSfVorlage(){var vk=apSfVorlageKey();if(!AP_SF_VORLAGEN[vk])vk='familie';if(st.pers.vorlage!==vk){st.pers.vorlage=vk;var V=AP_SF_VORLAGEN[vk];if(V.fonts.indexOf(st.pers.font)<0)st.pers.font=V.fonts[0];}return vk;}
function apSfRenderFonts(){
  var row=document.getElementById('apSfFontRow');if(!row)return;
  var vk=apSfVorlage();var V=AP_SF_VORLAGEN[vk];
  if(row.dataset.vk===vk&&row.dataset.f===st.pers.font)return;
  row.dataset.vk=vk;row.dataset.f=st.pers.font;
  var h='';
  for(var i=0;i<V.fonts.length;i++){var f=V.fonts[i],F=AP_SF_FONTS[f];
    h+='<button type="button" class="ap-font-btn'+(f===st.pers.font?' on':'')+'" data-font="'+f+'" onclick="apFont(this)" style="font-family:'+F.css.replace(/"/g,'&quot;')+';'+(F.it?'font-style:italic;':'')+'">'+F.name[AP_SF_L==='en'?'en':'de']+'</button>';}
  row.innerHTML=h;
}
function apSfPosLabel(){var b=document.getElementById('apSfPosBtn');if(!b)return;
  var L=AP_SF_L==='en'?{auto:'Position: automatic',um:'Position: centre',ul:'Position: left',ur:'Position: right'}:{auto:'Position: automatisch',um:'Position: mittig',ul:'Position: links',ur:'Position: rechts'};
  b.textContent=L[st.pers.pos]||L.auto;}
function apSfFieldVis(){var r1=document.getElementById('apSfNameRow'),r2=document.getElementById('apSfDatumRow');
  if(r1)r1.style.display=st.pers.nameAn?'':'none';if(r2)r2.style.display=st.pers.datumAn?'':'none';}
function apSfZone(ctx,x0,y0,w,h){
  try{
    var d=ctx.getImageData(Math.max(0,Math.round(x0)),Math.max(0,Math.round(y0)),Math.max(1,Math.round(w)),Math.max(1,Math.round(h))).data;
    var n=0,s=0,s2=0;
    for(var i=0;i<d.length;i+=16){var l=0.299*d[i]+0.587*d[i+1]+0.114*d[i+2];s+=l;s2+=l*l;n++;}
    var m=s/n;return {lum:m,sd:Math.sqrt(Math.max(0,s2/n-m*m))};
  }catch(e){return {lum:180,sd:0};}
}
function apSfTexte(){
  var p=st.pers;
  return {l1:(p.nameAn?(p.line1||'').trim().slice(0,30):''),l2:(p.datumAn?(p.line2||'').trim().slice(0,24).toUpperCase():'')};
}
function drawText(ctx,W,H){
  var p=st.pers, T=apSfTexte(), l1=T.l1, l2=T.l2;
  if(!l1&&!l2){p.calc=null;return;}
  var vk=apSfVorlage(), V=AP_SF_VORLAGEN[vk], F=AP_SF_FONTS[p.font]||AP_SF_FONTS[V.fonts[0]];
  var lvl=V.size, base=W*AP_SF_SIZES[lvl-1];
  var namePx=base*F.k, datePx=Math.max(10,base*AP_SF_DATE.scale);
  function nf(px){return (F.it?'italic ':'')+F.w+' '+px+'px '+F.css;}
  function df(px){return AP_SF_DATE.w+' '+px+'px '+AP_SF_DATE.css;}
  ctx.save();ctx.textAlign='left';ctx.textBaseline='alphabetic';ctx.shadowBlur=0;
  var nameW=0,nameAsc=0,nameDesc=0,mm;
  if(l1){ctx.font=nf(namePx);mm=ctx.measureText(l1);var g=0;
    while(mm.width>W*AP_SF.maxw&&namePx>12&&g<60){namePx*=0.94;ctx.font=nf(namePx);mm=ctx.measureText(l1);g++;}
    nameW=mm.width;nameAsc=mm.fontBoundingBoxAscent||namePx*0.9;nameDesc=mm.fontBoundingBoxDescent||namePx*0.25;}
  var sp=datePx*AP_SF_DATE.sp, dateW=0, dateAsc=0;
  if(l2){ctx.font=df(datePx);var dm=ctx.measureText(l2);dateAsc=dm.fontBoundingBoxAscent||datePx*0.9;
    for(var i=0;i<l2.length;i++)dateW+=ctx.measureText(l2[i]).width;dateW+=sp*Math.max(0,l2.length-1);}
  var gap=namePx*AP_SF.gap;
  var blockW=Math.max(nameW,dateW);
  var blockH=(l1?nameAsc+nameDesc:0)+(l2&&l1?gap+dateAsc:(l2?dateAsc:0));
  function box(pp){var y0=(pp==='om')?H*AP_SF.top:H*(1-AP_SF.bottom)-blockH;var x0=(pp==='ur')?W*(1-AP_SF.side)-blockW:(pp==='ul')?W*AP_SF.side:(W-blockW)/2;return {x0:x0,y0:y0,x1:x0+blockW,y1:y0+blockH};}
  var pos=p.pos||'auto', z;
  if(pos==='auto'){var best=null,cands=['um','ul','ur'];
    for(var c=0;c<cands.length;c++){var pp=cands[c];if(blockW>W*(1-2*AP_SF.side)&&pp!=='um')continue;
      var b=box(pp);var zz=apSfZone(ctx,b.x0,b.y0,blockW,blockH);
      var score=zz.sd+0.15*Math.abs(zz.lum-(zz.lum<120?40:215));
      if(best===null||score<best.score)best={score:score,pp:pp,z:zz};}
    pos=best.pp;z=best.z;}
  else{var bb=box(pos);z=apSfZone(ctx,bb.x0,bb.y0,blockW,blockH);}
  var hell=(z.lum<120)||(z.sd>35&&z.lum<150);
  var col=hell?'#FAF7F1':'#1A1714';
  var lasur=(z.sd>40)?Math.round(Math.min(1,(z.sd-40)/40)*140+40):0;
  var B=box(pos);
  if(lasur>0){var pad=namePx*0.6;ctx.save();
    try{ctx.filter='blur('+(pad*0.9)+'px)';}catch(e){}
    ctx.fillStyle=hell?'rgba(20,18,16,'+(lasur*0.8/255).toFixed(3)+')':'rgba(252,250,246,'+(lasur/255).toFixed(3)+')';
    ctx.beginPath();
    if(ctx.roundRect)ctx.roundRect(B.x0-pad,B.y0-pad*0.7,blockW+2*pad,blockH+1.4*pad,pad);else ctx.rect(B.x0-pad,B.y0-pad*0.7,blockW+2*pad,blockH+1.4*pad);
    ctx.fill();ctx.restore();}
  function xpos(wd){return (pos==='ur')?W*(1-AP_SF.side)-wd:(pos==='ul')?W*AP_SF.side:(W-wd)/2;}
  ctx.fillStyle=col;
  var nameBase=null,dateBase=null;
  if(l1){nameBase=B.y0+nameAsc;ctx.font=nf(namePx);ctx.fillText(l1,xpos(nameW),nameBase);dateBase=l2?nameBase+nameDesc+gap+dateAsc:null;}
  else{dateBase=B.y0+dateAsc;}
  if(l2){ctx.font=df(datePx);var cx=xpos(dateW);for(var k=0;k<l2.length;k++){ctx.fillText(l2[k],cx,dateBase);cx+=ctx.measureText(l2[k]).width+sp;}}
  ctx.restore();
  p.calc={v:2,vorlage:vk,font:p.font,size:lvl,pos:pos,farbe:hell?'hell':'dunkel',lasur:lasur,
          d1x:(xpos(nameW)+nameW/2)/W,d1y:nameBase!==null?nameBase/H:null,d2x:(xpos(dateW)+dateW/2)/W,d2y:dateBase!==null?dateBase/H:null};
}

window.apTextKuerzen=function(){
  var e1=document.getElementById('apPersLine1'),e2=document.getElementById('apPersLine2');
  if(e1){st.pers.line1=e1.value.slice(0,30);if(e1.value.length>30)e1.value=st.pers.line1;}
  if(e2){st.pers.line2=e2.value.slice(0,24);if(e2.value.length>24)e2.value=st.pers.line2;}
  var c=document.getElementById('apSfCount');if(c)c.textContent=(st.pers.line1||'').length+'/30';
};

/* ── MINI CANVAS (Mobile Sticky) ── */
function drawMini(){
  var mini=document.getElementById('apMiniCanvas');
  if(!mini)return;
  /* Source: entweder st.artImg oder den Haupt-Canvas */
  var src=st.artImg;
  if(!src)return;
  var iw=src.naturalWidth||400;
  var ih=src.naturalHeight||560;
  /* Proportional 64px hoch */
  var H=64;
  var W=Math.round(iw/ih*H);
  mini.width=W;mini.height=H;
  mini.style.width=W+'px';mini.style.height=H+'px';
  mini.style.borderRadius='8px';
  var ctx=mini.getContext('2d');
  ctx.clearRect(0,0,W,H);
  /* Hauptcanvas als Quelle nutzen (enthält bereits Bild + Wasserzeichen + Text) */
  var mainCv=document.getElementById('apWmCanvas');
  if(mainCv&&mainCv.width>0){
    ctx.drawImage(mainCv,0,0,W,H);
  } else {
    ctx.drawImage(src,0,0,W,H);
  }
}

/* ── PERSONALISIERUNG ── */
window.apUpdateText=function(){
  apTextKuerzen();
  /* Schneller Pfad: nur Text neu zeichnen, mit RAF-Throttle */
  if(st.artImg&&!_rafPending){
    _rafPending=true;
    requestAnimationFrame(function(){
      _rafPending=false;
      renderTextOnly();
      /* Wenn Raum-Tab aktiv: auch dort Text aktualisieren */
      var rp=document.getElementById('paneRaum');
      if(rp&&rp.offsetParent!==null)apDrawRoom();
      var mp=document.getElementById('paneMaterial');
      if(mp&&mp.offsetParent!==null&&typeof apDrawMockup==='function')apDrawMockup();
    });
  }
  /* Mobile sticky anzeigen wenn Bild nicht sichtbar */
  var sticky=document.getElementById('apMobileSticky');
  if(sticky&&window.innerWidth<=680&&st.artImg){
    sticky.classList.add('visible');
  }
};

window.apShowMiniSticky=function(show){
  var sticky=document.getElementById('apMobileSticky');
  if(!sticky)return;
  if(window.innerWidth>680){sticky.classList.remove('visible');return;}
  if(show&&st.artImg){
    sticky.classList.add('visible');
    drawMini();
  }
};

var _apSyncRaf=false;
function apSyncWandFromText(){
  if(_apSyncRaf)return; _apSyncRaf=true;
  requestAnimationFrame(function(){
    _apSyncRaf=false;
    var rp=document.getElementById('paneRaum');
    if(rp&&rp.offsetParent!==null&&typeof apDrawRoom==='function')apDrawRoom();
    var mp=document.getElementById('paneMaterial');
    if(mp&&mp.offsetParent!==null&&typeof apDrawMockup==='function')apDrawMockup();
  });
}
window.apFont=function(btn){
  document.querySelectorAll('#ap .ap-pers-font-row .ap-font-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.pers.font=btn.dataset.font;
  var row=document.getElementById('apSfFontRow');if(row)row.dataset.f=st.pers.font;
  if(st.artImg){renderCanvas();apUpdateMiniPreview();apSyncWandFromText();}
};
window.apSfNameAn=function(cb){st.pers.nameAn=!!cb.checked;apSfFieldVis();apSfRenderFonts();apUpdateText();
  if(st.pers.nameAn){var e=document.getElementById('apPersLine1');if(e&&!e.value)e.focus();}};
window.apSfDatumAn=function(cb){st.pers.datumAn=!!cb.checked;apSfFieldVis();apSfRenderFonts();apUpdateText();
  if(st.pers.datumAn){var e=document.getElementById('apPersLine2');if(e&&!e.value)e.focus();}};
window.apSfPosNext=function(){var o=['auto','um','ul','ur'];var i=o.indexOf(st.pers.pos);st.pers.pos=o[(i+1)%o.length];apSfPosLabel();
  if(st.artImg){renderCanvas();apUpdateMiniPreview();apSyncWandFromText();}};
try{apSfRenderFonts();apSfPosLabel();apSfFieldVis();}catch(e){}

/* Falls gerade "An der Wand" aktiv ist, auf Vorschau schalten
   (Text platzieren geht nur in der Vorschau) */
window.apEnsureVorschau=function(){
  var m=document.getElementById('paneMaterial');
  var r=document.getElementById('paneRaum');
  if(((m&&m.classList.contains('on'))||(r&&r.classList.contains('on')))&&typeof apTab==='function')apTab('vorschau');
};
window.apTogglePers=function(){
  st.persOpen=!st.persOpen;
  var f=document.getElementById('apPersFields');
  f.classList.toggle('open',st.persOpen);
  var _tb=document.getElementById('apPersToggleBox');if(_tb)_tb.textContent=st.persOpen?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'− Close':'− Schließen'):((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'＋ Add':'＋ Hinzufügen');
  if(st.persOpen)apEnsureVorschau();
};

/* ── BILD-SCHUTZ: kein Wegziehen / Rechtsklick-Speichern ── */
(function(){
  var ap=document.getElementById('ap');
  if(!ap)return;
  ap.addEventListener('dragstart',function(e){e.preventDefault();return false;});
  ap.addEventListener('contextmenu',function(e){var t=e.target&&e.target.tagName;if(t==='IMG'||t==='CANVAS')e.preventDefault();});
})();

/* ── DRAG TEXT: entfernt (v167) — Positionierung nur noch übers Positions-Pad ── */
/* ── ZOOM-LUPE auf dem Mockup ("An der Wand") — hochaufgeloester Server-Render ── */
(function(){
  var box=document.getElementById('apMockupBox');
  var pane=document.getElementById('paneMaterial');
  if(!box||!pane)return;
  if(getComputedStyle(pane).position==='static')pane.style.position='relative';
  var L=150, Z=2.4;
  var loupe=document.createElement('canvas');
  loupe.width=L; loupe.height=L; loupe.className='ap-loupe';
  loupe.style.cssText='position:absolute;width:'+L+'px;height:'+L+'px;border-radius:50%;border:3px solid rgba(255,255,255,.92);box-shadow:0 6px 26px rgba(0,0,0,.4);pointer-events:none;display:none;z-index:20;background:#f4f2ee';
  pane.appendChild(loupe);
  var lctx=loupe.getContext('2d');
  function curImg(){ var im=box.querySelector('img.ap-mock-img'); return (im&&im.complete&&im.naturalWidth)?im:null; }
  function ueberNav(x,y){
    var el=document.elementFromPoint(x,y);
    return !!(el&&el.closest&&el.closest('.ap-mock-nav'));
  }
  function draw(clientX,clientY,mobile){
    if(ueberNav(clientX,clientY)){loupe.style.display='none';return;}
    var im=curImg(); if(!im){loupe.style.display='none';return;}
    var r=box.getBoundingClientRect();
    var bw=r.width, bh=r.height, iw=im.naturalWidth, ih=im.naturalHeight;
    var s=Math.min(bw/iw, bh/ih);          /* object-fit:contain */
    var dw=iw*s, dh=ih*s, ox=(bw-dw)/2, oy=(bh-dh)/2;
    var cx=clientX-r.left, cy=clientY-r.top;
    var pxx=cx-ox, pyy=cy-oy;
    if(pxx<0||pyy<0||pxx>dw||pyy>dh){loupe.style.display='none';return;}
    var sx=pxx/s, sy=pyy/s, reg=(L/Z)/s;   /* Quell-Ausschnitt in Natur-Pixeln */
    lctx.clearRect(0,0,L,L); lctx.imageSmoothingEnabled=true;
    try{ lctx.drawImage(im, sx-reg/2, sy-reg/2, reg, reg, 0,0,L,L); }catch(e){loupe.style.display='none';return;}
    var lx=cx-L/2, ly=mobile?(cy-L-30):(cy-L/2);
    lx=Math.max(0,Math.min(bw-L,lx)); ly=Math.max(0,Math.min(bh-L,ly));
    loupe.style.left=(box.offsetLeft+lx)+'px'; loupe.style.top=(box.offsetTop+ly)+'px'; loupe.style.display='block';
  }
  box.addEventListener('mousemove',function(e){draw(e.clientX,e.clientY,false);});
  box.addEventListener('mouseleave',function(){loupe.style.display='none';});
  var holdT=null, curT=null;
  box.addEventListener('touchstart',function(e){ var t=e.touches[0]; if(!t)return; if(ueberNav(t.clientX,t.clientY))return; curT=t; holdT=setTimeout(function(){draw(curT.clientX,curT.clientY,true);},170); },{passive:true});
  box.addEventListener('touchmove',function(e){ var t=e.touches[0]; if(!t)return; curT=t; if(loupe.style.display==='block'){e.preventDefault();draw(t.clientX,t.clientY,true);} },{passive:false});
  function endTouch(){clearTimeout(holdT);loupe.style.display='none';}
  box.addEventListener('touchend',endTouch);
  box.addEventListener('touchcancel',endTouch);
})();

/* ── ROOM MOCKUP: entfernt (v152) — Server-Renders uebernehmen. Stub fuer Alt-Aufrufer: ── */
window.apDrawRoom=function(){};
function getRoomData(){return null;}

window.apRoom=function(btn,ori){
  document.querySelectorAll('#ap .ap-room-canvas-wrap + div .ap-font-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.roomOrientation=ori;
  apDrawRoom();
};

/* ── MATERIAL-MOCKUPS (PSD-basiert, matrix3d) ── */
/* ── SERVER-MOCKUPS (Hetzner via Preview-Worker /mockup) ── */
var AP_SRV = {
  framed_canvas: { black:{hoch:['framed_canvas_schwarz_wall_hoch_03','framed_canvas_schwarz_free_hoch'],quer:['framed_canvas_schwarz_wall_quer_03','framed_canvas_schwarz_free_quer']},
                   white:{hoch:['framed_canvas_weiss_wall_hoch_03','framed_canvas_weiss_free_hoch'],quer:['framed_canvas_weiss_wall_quer_03','framed_canvas_weiss_free_quer']},
                   wood:{hoch:['framed_canvas_eiche_wall_hoch_03','framed_canvas_eiche_free_hoch'],quer:['framed_canvas_eiche_wall_quer_03','framed_canvas_eiche_free_quer']},
                   dark:{hoch:['framed_canvas_schwarz_wall_hoch_03','framed_canvas_schwarz_free_hoch'],quer:['framed_canvas_schwarz_wall_quer_03','framed_canvas_schwarz_free_quer']} },
  canvas:        { _all:{hoch:['canvas_hoch_18_lw1410j'],quer:['canvas_quer_21_lw1410h']} }
};
/* ── TURNSTILE 19.07. (v2): ALLES an window — die Datei besteht aus vielen
   abgeschlossenen IIFEs, lokale Funktionen sind dort nicht sichtbar. ── */
window.AP_TS_SITEKEY='0x4AAAAAAD5KX_2BV20P_wpV';
window._apTsId=window._apTsId||null;window._apTsCb=window._apTsCb||null;
window.apTsLoad=window.apTsLoad||function(){
  return new Promise(function(res){
    if(window.turnstile&&window.turnstile.render){res(true);return;}
    if(!document.getElementById('apTsScript')){
      var sc=document.createElement('script');sc.id='apTsScript';
      sc.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      sc.async=true;sc.defer=true;document.head.appendChild(sc);
    }
    var t0=Date.now();
    var iv=setInterval(function(){
      if(window.turnstile&&window.turnstile.render){clearInterval(iv);res(true);}
      else if(Date.now()-t0>10000){clearInterval(iv);res(false);}
    },100);
  });
};
window.apTsToken=window.apTsToken||function(){
  try{
    return window.apTsLoad().then(function(ok){
      if(!ok){console.log('Turnstile: Script nicht geladen');return '';}
      return new Promise(function(res){
        var fertig=false;
        function liefere(t){ if(!fertig){fertig=true;window._apTsCb=null;res(t||'');} }
        window._apTsCb=liefere;
        try{
          if(window._apTsId===null){
            var box=document.getElementById('apTsBox');
            if(!box){box=document.createElement('div');box.id='apTsBox';
              box.style.cssText='position:fixed;bottom:10px;right:10px;z-index:99999';
              document.body.appendChild(box);}
            window._apTsId=window.turnstile.render(box,{
              sitekey:window.AP_TS_SITEKEY,appearance:'interaction-only',execution:'execute',
              callback:function(t){ if(window._apTsCb)window._apTsCb(t); },
              'error-callback':function(){ if(window._apTsCb)window._apTsCb(''); },
              'expired-callback':function(){ if(window._apTsCb)window._apTsCb(''); }
            });
          } else { window.turnstile.reset(window._apTsId); }
          window.turnstile.execute(window._apTsId);
        }catch(e){ console.log('Turnstile Fehler:',e.message); liefere(''); return; }
        setTimeout(function(){ liefere(''); },25000); /* AP-UPLOAD-STABIL-2910 */
      });
    });
  }catch(e){ console.log('Turnstile Aussenfehler:',e.message); return Promise.resolve(''); }
};
try{ window.apTsLoad(); }catch(e){}
var AP_SRV_URL='https://arturell-preview.arturell.workers.dev/mockup';
function apSrvGr(k){
  /* Groessendimension: nur Wand-Bundles haben Groessenvarianten. XL faellt auf L zurueck,
     solange merchOne keine 120x80-Vorlagen geliefert hat. */
  if(!k)return k;
  var gs={s:'s',m:'m',l:'l',xl:'l',xxl:'l'};
  var g=gs[st.size]||'m';
  return k.replace(/_wall_(hoch|quer)_03$/,'_wall_$1_'+g+'_03');
}
function apSrvKeys(){
  var m=AP_SRV[st.material]; if(!m)return [];
  var c=m._all||m[st.farbe]; if(!c)return [];
  var ks=c[st.format]||[];
  return ks.map(apSrvGr);
}
function apSrvKey(){
  var ks=apSrvKeys(); if(!ks.length)return null;
  if(typeof st.mockView!=='number')st.mockView=0;
  if(st.mockView>=ks.length)st.mockView=0;
  return ks[st.mockView];
}
function apSrvFname(){
  /* PIPE v2: das AKTUELL GEWAEHLTE Werk (st.artUrl) hat Vorrang — st.artImg.src
     zeigt beim Werk-Wechsel noch aufs Vorgaenger-Bild (async load). */
  var u=st.artUrl||(st.artImg&&st.artImg.src)||''; var f=u.split('/').pop().split('?')[0];
  return /^preview(safe)?_[0-9]+_[a-z0-9]+\.jpg$/i.test(f)?f:null;
}
window._apSrvSeq=0; window._apSrvWarm={};
function apSrvPrefetch(fname){
  /* MOCKUP-SMART-PREFETCH v1: nur 1 Mockup je Material (aktuelle Ausrichtung), sequenziell + gecacht */
  var fmt=st.format||'hoch';
  var wk=fname+'|'+fmt;
  if(window._apSrvWarm[wk])return; window._apSrvWarm[wk]=1;
  var jobs=[];
  Object.keys(AP_SRV).forEach(function(mat){
    var m=AP_SRV[mat];
    var c=m._all||m[st.farbe]||m[Object.keys(m)[0]];
    var ks=(c&&c[fmt])||[];
    ks.forEach(function(mk){jobs.push(apSrvGr(mk));});
  });
  window._apSrvCache=window._apSrvCache||{};
  (function next(){
    if(!jobs.length)return;
    var mk=jobs.shift(); var ck=mk+'|'+fname;
    if(window._apSrvCache[ck]){ setTimeout(next,150); return; }
    fetch(AP_SRV_URL+'?img='+encodeURIComponent(fname)+'&mockup='+mk+'&px=2000')
      .then(function(r){return r.json();})
      .then(function(d){ if(d&&d.ok){ window._apSrvCache[ck]=d.url; var pi=new Image(); pi.src=d.url; } setTimeout(next,300); })
      .catch(function(){ setTimeout(next,300); });
  })();
}
function apFitMockupBox(){
  var box=document.getElementById('apMockupBox'),pane=document.getElementById('paneMaterial');
  if(!box||!pane)return;
  /* FIX 11.07: Referenz ist die stabile Pane-BREITE + feste Viewport-Hoehe — NIE
     pane.clientHeight (das schrumpfte durch die eigene vorherige Verkleinerung ->
     Box wurde bei jedem An-der-Wand-Klick kleiner). Quadratische Box (1:1). */
  var pw=pane.clientWidth||box.clientWidth||0;
  if(!pw)return;
  var maxH=Math.max(window.innerHeight-250,240);   /* feste Obergrenze, unabhaengig von Box */
  var side=Math.min(pw,maxH);                        /* quadratisch, passt in Breite UND Hoehe */
  /* PIPE v1: Server-Mockups sind quadratische Szenen -> Box bleibt 1:1, aber im
     Quer-Modus nutzen wir die volle Pane-Breite bis zur Hoehen-Grenze (identisch),
     damit Vorschau- und Wand-Ansicht dieselbe Fussflaeche haben. */
  box.style.width=Math.round(side)+'px';
  box.style.height=Math.round(side)+'px';
  box.style.aspectRatio='auto';
}
window.addEventListener('resize',function(){apFitMockupBox();});
/* \u2500 MOCKUP-SWIPE v1: mehrere Ansichten (freistehend + Wand) \u2500 */
window.apMockGo=function(dir){
  var ks=apSrvKeys(); if(ks.length<2)return;
  if(typeof st.mockView!=='number')st.mockView=0;
  st.mockView=(st.mockView+dir+ks.length)%ks.length;
  window.apDrawMockup();
};
function apMockNav(box){
  var ks=apSrvKeys(); if(ks.length<2)return;
  var i=st.mockView||0;
  var nav=document.createElement('div');
  nav.className='ap-mock-nav';nav.style.cssText='position:absolute;inset:0;pointer-events:none;z-index:22';
  var dots='';
  for(var d=0;d<ks.length;d++){dots+='<span style="width:8px;height:8px;border-radius:50%;background:'+(d===i?'#3a2f2a':'rgba(58,47,42,.32)')+';display:inline-block;margin:0 3px"></span>';}
  nav.innerHTML=
    '<button type="button" onclick="apMockGo(-1)" ontouchstart="event.stopPropagation()" onmousedown="event.stopPropagation()" style="pointer-events:auto;position:absolute;left:8px;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%;border:none;background:rgba(255,255,255,.85);box-shadow:0 1px 6px rgba(0,0,0,.18);font-size:16px;cursor:pointer">&#8249;</button>'+
    '<button type="button" onclick="apMockGo(1)" ontouchstart="event.stopPropagation()" onmousedown="event.stopPropagation()" style="pointer-events:auto;position:absolute;right:8px;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%;border:none;background:rgba(255,255,255,.85);box-shadow:0 1px 6px rgba(0,0,0,.18);font-size:16px;cursor:pointer">&#8250;</button>'+
    '<div style="position:absolute;left:0;right:0;bottom:8px;text-align:center">'+dots+'</div>';
  box.appendChild(nav);
  if(!box._apSwipe){
    box._apSwipe=1;
    var sx=null;
    box.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
    box.addEventListener('touchend',function(e){
      if(sx===null)return;
      var dx=e.changedTouches[0].clientX-sx; sx=null;
      if(Math.abs(dx)>40)window.apMockGo(dx<0?1:-1);
    },{passive:true});
  }
}
window.apDrawMockup = function(){
  var box=document.getElementById('apMockupBox'), hint=document.getElementById('apMockupHint');
  if(!box)return;
  apFitMockupBox();
  /* PIPE v1: Werk-Token — jede Anzeige wird gegen das aktuell gewaehlte Werk geprueft */
  var myArt=st.artUrl||'';
  var fname=apSrvFname();
  if(!fname){ box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:12px;text-align:center;padding:20px">Lade zuerst dein Foto hoch und generiere ein Kunstwerk.</div>'; if(hint)hint.textContent=''; return; }
  var key=apSrvKey();
  if(!key){ box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:12px;text-align:center;padding:20px">Materialansicht für dieses Material folgt in Kürze.</div>'; if(hint)hint.textContent=''; return; }
  var ck=key+'|'+fname;
  window._apSrvCache=window._apSrvCache||{};
  function apShowSrv(u){
    if((st.artUrl||'')!==myArt)return; /* PIPE v1: inzwischen anderes Werk gewaehlt -> verwerfen */
    box.innerHTML='<img class="ap-mock-img" src="'+u+'" style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain">';
    apMockNav(box);
    if(hint)hint.textContent=(apSrvKeys().length>1?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'View '+((st.mockView||0)+1)+' of '+apSrvKeys().length+' · swipe to browse':'Ansicht '+((st.mockView||0)+1)+' von '+apSrvKeys().length+' · wischen zum Bl\u00e4ttern'):((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'This is how your artwork looks on the wall':'So sieht dein Kunstwerk an der Wand aus'));
  }
  if(window._apSrvCache[ck]){ apShowSrv(window._apSrvCache[ck]); return; }
  if(!document.getElementById('ap-mock-shim-css')){var _s=document.createElement('style');_s.id='ap-mock-shim-css';_s.textContent='@keyframes apMockBeat{0%,100%{transform:scale(1);opacity:.72}50%{transform:scale(1.18);opacity:1}}#ap .ap-mock-load{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:5}#ap .ap-mock-load svg{width:54px;height:54px;filter:drop-shadow(0 3px 12px rgba(0,0,0,.4));animation:apMockBeat 1s ease-in-out infinite}';document.head.appendChild(_s);}
  var hasImg = box.firstChild && box.firstChild.tagName==='IMG';
  if(!hasImg){
    var _asrc=(st.artImg&&st.artImg.src)||'';
    box.innerHTML='<img src="'+_asrc+'" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;filter:blur(7px) brightness(.55);transform:scale(1.08)"><div class="ap-mock-load"><svg viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg></div>';
  } else if(!box.querySelector('.ap-mock-reload')){
    /* Farbwechsel/Re-Render: aktuelles Mockup behalten, Herz drueberlegen -> nie "kaputt"-Gefuehl */
    var _ov=document.createElement('div');_ov.className='ap-mock-load ap-mock-reload';_ov.style.background='rgba(20,16,14,.34)';
    _ov.innerHTML='<svg viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
    box.appendChild(_ov);
  }
  var seq=++window._apSrvSeq;
  fetch(AP_SRV_URL+'?img='+encodeURIComponent(fname)+'&mockup='+key+'&px=2000')
    .then(function(r){return r.json();})
    .then(function(d){
      if(!d||!d.ok){ if(seq===window._apSrvSeq)box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:12px">'+(AP_L==='en'?'This view is currently unavailable.':'Ansicht derzeit nicht verfügbar.')+'</div>'; return; }
      var im=new Image();
      im.onload=function(){ window._apSrvCache[ck]=d.url; if(seq!==window._apSrvSeq)return; apShowSrv(d.url); };
      im.onerror=function(){ if(seq===window._apSrvSeq)box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:12px">'+(AP_L==='en'?'This view is currently unavailable.':'Ansicht derzeit nicht verfügbar.')+'</div>'; };
      im.src=d.url;
      apSrvPrefetch(fname);
    }).catch(function(){ if(seq===window._apSrvSeq)box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:12px">'+(AP_L==='en'?'This view is currently unavailable.':'Ansicht derzeit nicht verfügbar.')+'</div>'; });
};

/* ── TABS ── */
window.apTab=function(tab){
  ['Vorschau','Raum','Material'].forEach(function(t){
    var tabEl=document.getElementById('tab'+t);
    var paneEl=document.getElementById('pane'+t);
    if(tabEl)tabEl.classList.remove('on');
    if(paneEl)paneEl.classList.remove('on');
  });
  document.getElementById('tab'+tab.charAt(0).toUpperCase()+tab.slice(1)).classList.add('on');
  document.getElementById('pane'+tab.charAt(0).toUpperCase()+tab.slice(1)).classList.add('on');
  if(tab==='raum')apDrawRoom();
  if(tab==='material')apDrawMockup();
};

/* "An der Wand" zeigt je nach Material PSD-Mockup ODER Raumansicht */
/* Resize-Observer entfernt (v152): Server-Bild skaliert per CSS */

window.apWand=function(){
  /* Stil-Fenster schließen beim Wechsel in die Wand-Ansicht */
  var _ww=document.getElementById('apWerkeWrap');
  var _wc=document.getElementById('apStileChevron');
  if(_ww)_ww.style.display='none';
  if(_wc)_wc.textContent='▾';
  ['Vorschau','Raum','Material'].forEach(function(t){
    var te=document.getElementById('tab'+t), pe=document.getElementById('pane'+t);
    if(te)te.classList.remove('on'); if(pe)pe.classList.remove('on');
  });
  var tm=document.getElementById('tabMaterial'); if(tm)tm.classList.add('on');
  var hasPSD=true; /* v152: alle Materialien -> Server-Mockup-Pane */
  if(st.artImg && hasPSD){
    var pm=document.getElementById('paneMaterial'); if(pm)pm.classList.add('on');
    if(typeof apDrawMockup==='function')apDrawMockup();
  } else {
    var pr=document.getElementById('paneRaum'); if(pr)pr.classList.add('on');
    if(typeof apDrawRoom==='function')apDrawRoom();
  }
};

/* ── MOBILE STICKY ── */
(function(){
  if(!window.IntersectionObserver)return;
  /* Canvas beobachten statt verstecktes Bild */
  var target=document.getElementById('apWmCanvas')||document.getElementById('apResultSection');
  if(!target)return;
  var obs=new IntersectionObserver(function(entries){
    if(window.innerWidth>680)return;
    var sticky=document.getElementById('apMobileSticky');
    if(!sticky)return;
    if(!entries[0].isIntersecting&&st.artImg&&st.persOpen){
      sticky.classList.add('visible');
      drawMini();
    } else{
      sticky.classList.remove('visible');
    }
  },{threshold:0.1});
  obs.observe(target);
})();

/* ── GRÖSSE ── */
window.apSize=function(btn){
  document.querySelectorAll('#ap .ap-size-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.size=btn.dataset.size;
  st.price=parseFloat(btn.dataset.price);
  aktualisierePreis();
  /* Groessenwechsel muss das Wand-Mockup neu zeichnen — aber nur wenn es sichtbar ist */
  var _pm=document.getElementById('paneMaterial');
  if(st.artImg&&_pm&&_pm.classList.contains('on')&&typeof apDrawMockup==='function')apDrawMockup();
};

function apSzName(s){
  var isQuer=st.format==='quer';
  /* USA: Zoll statt Zentimeter. Fehlte hier komplett — im US-Checkout stand
     deshalb "Size: 20x30 cm" bei der Variante 8x12". */
  if (typeof apIsUS==='function' && apIsUS()) {
    var namesUS={
      s: isQuer?'12\u00d78"':'8\u00d712"',
      m: isQuer?'24\u00d716"':'16\u00d724"',
      l: isQuer?'30\u00d720"':'20\u00d730"',
      xl: isQuer?'36\u00d724"':'24\u00d736"',
      xxl: isQuer?'48\u00d736"':'36\u00d748"'
    };
    return namesUS[s]||s;
  }
  var names={
    s: isQuer?'30×20 cm':'20×30 cm',
    m: isQuer?'60×40 cm':'40×60 cm',
    l: isQuer?'90×60 cm':'60×90 cm',
    xl: isQuer?'120×80 cm':'80×120 cm',
    xxl: isQuer?'150×100 cm':'100×150 cm'
  };
  return names[s]||s;
}

function aktualisierePreis(){
  var pNow=document.getElementById('apPriceNow');if(pNow)pNow.textContent=fmt(st.price);
  var pBuy=document.getElementById('apBuyP');if(pBuy)pBuy.textContent=fmt(st.price);
  var pWas=document.getElementById('apPriceWas');if(pWas)pWas.style.display='none';
  var pSave=document.getElementById('apPriceSave');if(pSave)pSave.style.display='none';
}
function fmt(p){return apIsUS() ? ('$'+p.toFixed(2)) : ((AP_L==='en') ? ('€'+p.toFixed(2)) : (p.toFixed(2).replace('.',',')+' €'));}   /* 19.10.: /en = Euro */

function apFormatName(){
  return st.format==='quer'?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Landscape':'Querformat'):((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Portrait':'Hochformat');
}

/* ── POSITIONS-PAD ── */
/* ── RETRY ── */
window.apRetry=function(){
  /* NEUES Foto im AKTUELLEN Stil: nach Foto-Wahl direkt generieren (Ladebildschirm), kein Zurueckwerfen.
     Ein bereits generiertes Bild kommt nie zurueck in den Kreislauf (immer echte Datei). */
  st.pendingStil = st.stil || 'aquarell';
  var fi=document.getElementById('apFileInput');
  if(fi){ fi.value=''; fi.click(); }
};
/* apChangeStil entfernt — Stil-Slider im Bearbeitungsmodus ersetzt es */

/* 25.10.: Schriftfelder v2 — Text-Properties fuer Leinwand UND Download (apBuy + apBuyDL) */
function apSfProps(props){
  var _sfT=apSfTexte(), _sfC=st.pers.calc;
  if(_sfT.l1)props['Text Zeile 1']=_sfT.l1;
  if(_sfT.l2)props['Text Zeile 2']=_sfT.l2;
  if((_sfT.l1||_sfT.l2)&&_sfC)props['_text_meta']=JSON.stringify({
    v:2,vorlage:_sfC.vorlage,font:_sfC.font,l1:_sfT.l1,l2:_sfT.l2,size:_sfC.size,
    pos:_sfC.pos,farbe:_sfC.farbe,lasur:_sfC.lasur,
    color:(_sfC.farbe==='hell'?'#FAF7F1':'#1A1714'),weight:3,
    d1x:_sfC.d1x,d1y:_sfC.d1y,d2x:_sfC.d2x,d2y:_sfC.d2y
  });
  return props;
}
/* ── KAUFEN ── */
window.apBuy=function(_stay){
  /* Doppelklick-Guard (Fund 21.08.): zwei Taps = Menge 2 im Checkout. */
  if(st.kaufLaeuft) return;
  st.kaufLaeuft=true;
  var vid=apVid(st.size);
  var props={};props[(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Art style':'Kunststil']=st.stilName;props[(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Size':'Größe']=apSzName(st.size);
  apSfProps(props);
  if(st.artUrl)props['_artwork_url']=st.artUrl;
  /* AP-ZEHN-A-0111: Familie: Anzahl Fotos sichtbar; ab 5 Fotos Aufpreis-Position im selben Aufruf, gemeinsame _ap_gruppe */
  var _fn = (st.familyMergedUrl && st.familyMotive) ? (parseInt(st.familyMotive,10)||0) : 0, _au = _fn && window.apAuf ? apAuf(_fn) : null, _fk = ((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en')?'Photos':'Fotos';
  if(_fn) props[_fk]=String(_fn);
  function _aufPos(g){ var pp={_ap_gruppe:g,_ap_aufpreis:'1'}; pp[_fk]=String(_fn); return {id:_au.id,quantity:1,properties:pp}; }
  /* AP-KORB-DOPPELT-2910: gleiches Bild schon im Warenkorb -> nicht nochmal hinzufuegen (sonst Menge 2) */
  fetch('/cart.js').then(function(r){return r.json();}).catch(function(){return {items:[]};})
    .then(function(c){
      var drin=!!st.artUrl&&(c.items||[]).some(function(it){var p=it.properties||{};return String(it.variant_id)===String(vid)&&p._artwork_url===st.artUrl&&(p['Text Zeile 1']||'')===(props['Text Zeile 1']||'')&&(p['Text Zeile 2']||'')===(props['Text Zeile 2']||'');});
      var _alt=null; (c.items||[]).forEach(function(it){var p=it.properties||{}; if(String(it.variant_id)===String(vid)&&p._artwork_url===st.artUrl) _alt=it;});
      var _posten=[];
      if(drin){
        var _g0=_alt&&(_alt.properties||{})._ap_gruppe;
        if(!_au||!_g0||(c.items||[]).some(function(it){var p=it.properties||{};return p._ap_aufpreis&&p._ap_gruppe===_g0;})) return {_schonDrin:true};
        _posten.push(_aufPos(_g0));
      } else {
        var _gid=_au?('g'+Date.now().toString(36)+Math.random().toString(36).slice(2,7)):'';
        if(_au) props._ap_gruppe=_gid;
        if(_au) _posten.push(_aufPos(_gid)); _posten.push({id:vid,quantity:1,properties:props});   /* AP-ZEHN-A-0111-REIHE: Aufpreis ZUERST senden, Shopify zeigt die zuletzt gesendete Position oben (gemessen 01.11.): Kunstwerk oben, Aufpreis darunter */
      }
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:_posten})}).then(function(r){return r.json();});   /* AP-ZEHN-A-0111 */
    })
    .then(function(d){
      if(d.status===422||d.description){st.kaufLaeuft=false;alert('Cart Fehler: '+d.description);return;}
      if(_stay){ st.kaufLaeuft=false; if(window.apfCartBarOpen) window.apfCartBarOpen(); return; }
      window.location.href='/cart'; /* AP-ZURUECK-WARENKORB-3010: Kunde sieht sein Kunstwerk vor der Kasse */
    })
    .catch(function(e){st.kaufLaeuft=false;alert('Fehler: '+e);});
};
window.apfCartBarOpen=function(){
  var b=document.getElementById('apfCartBar'); if(!b)return;
  b.classList.add('on');
  try{ b.scrollIntoView({behavior:'smooth',block:'nearest'}); }catch(e){}
};
window.apfCartBarClose=function(){
  var b=document.getElementById('apfCartBar'); if(b) b.classList.remove('on');
};
window.apBuyDL=function(){
  if(st.kaufLaeuft) return;   /* gemeinsamer Guard mit apBuy — blockt auch Kreuz-Doppelkauf */
  st.kaufLaeuft=true;
  var props={};props[(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Art style':'Kunststil']=st.stilName;
  if(st.artUrl)props['_artwork_url']=st.artUrl;
  apSfProps(props);
  if(st.familyMergedUrl && st.familyMotive) props[((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en')?'Photos':'Fotos']=String(st.familyMotive);   /* AP-ZEHN-A-0111: Download ohne Aufpreis (offen: Niklas) */
  /* Warenkorb erst leeren → nur der digitale Download landet drin (keine Leinwand-Reste, keine Mengen-Summierung) */
  fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
    .then(function(){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:apDLVid(),quantity:1,properties:props})});
    })
    .then(function(r){return r.json();})
    .then(function(d){
      if(d.status===422||d.description){st.kaufLaeuft=false;alert('Konnte nicht in den Warenkorb gelegt werden: '+(d.description||'Unbekannter Fehler'));return;}
      window.location.href='/checkout';
    })
    .catch(function(e){st.kaufLaeuft=false;alert('Fehler: '+e);});
};

/* ── VARIANTEN IDs — alle 3 Materialien ── */
var AP_VIDS = {
  canvas: {
    hoch: {s:'53374626038026',m:'53374626070794',l:'53374626103562',xl:'53374626136330'},
    quer: {s:'53374626038026',m:'53374626070794',l:'53374626103562',xl:'53374626136330'}
  },
  framed: {
    hoch: {
      white: {s:'53261835141386',m:'53261835272458',l:'53261835403530',xl:'53261835534602',xxl:'53261835665674'},
      wood: {s:'53261835174154',m:'53261835305226',l:'53261835436298',xl:'53261835567370',xxl:'53261835698442'},
      dark: {s:'53261835206922',m:'53261835337994',l:'53261835469066',xl:'53261835600138',xxl:'53261835731210'},
      black: {s:'53261835239690',m:'53261835370762',l:'53261835501834',xl:'53261835632906',xxl:'53261835763978'}
    },
    quer: {
      white: {s:'53261835796746',m:'53261835927818',l:'53261836058890',xl:'53261836189962',xxl:'53261836321034'},
      wood: {s:'53261835829514',m:'53261835960586',l:'53261836091658',xl:'53261836222730',xxl:'53261836353802'},
      dark: {s:'53261835862282',m:'53261835993354',l:'53261836124426',xl:'53261836255498',xxl:'53261836386570'},
      black: {s:'53261835895050',m:'53261836026122',l:'53261836157194',xl:'53261836288266',xxl:'53261836419338'}
    }
  },
  acrylic: {
    hoch: {s:'53261702693130',m:'53261702725898',l:'53261702758666',xl:'53261702791434',xxl:'53261702824202'},
    quer: {s:'53261702856970',m:'53261702889738',l:'53261702922506',xl:'53261702955274',xxl:'53261702988042'}
  },
  framed_canvas: {
    hoch: {
      wood:  {s:'53375138562314',m:'53375138660618',l:'53375138758922',xl:'53375138857226'},
      white: {s:'53375138529546',m:'53375138627850',l:'53375138726154',xl:'53375138824458'},
      black: {s:'53375138496778',m:'53375138595082',l:'53375138693386',xl:'53375138791690'}
    },
    quer: {
      wood:  {s:'53375138562314',m:'53375138660618',l:'53375138758922',xl:'53375138857226'},
      white: {s:'53375138529546',m:'53375138627850',l:'53375138726154',xl:'53375138824458'},
      black: {s:'53375138496778',m:'53375138595082',l:'53375138693386',xl:'53375138791690'}
    }
  }
};

/* Preise pro Material */
var AP_PREISE = {
  canvas:        {s:'49,90',  m:'79,90',  l:'119,90', xl:'159,90', xxl:null},
  framed:        {s:'89,95',  m:'114,95', l:'149,95', xl:'189,95', xxl:'234,95'},
  acrylic:       {s:'84,95',  m:'109,95', l:'139,95', xl:'174,95', xxl:'214,95'},
  framed_canvas: {s:'79,90',  m:'119,90', l:null,     xl:'279,90', xxl:null}
};

/* Benefit-Texte */
var AP_BENEFITS = {
  canvas:        ['Premium Thick Canvas','4cm Keilrahmen','Aufhängefertig'],
  framed:        ['Schattenfugenrahmen','100 % recycelter Kunststoff · 3 Farben','Aufhängefertig'],
  acrylic:       ['Crystal-Clear Acrylglas','Hochglanz · Tiefenwirkung','Aufhängefertig'],
  framed_canvas: ['Leinwand + schwebender Rahmen','3 Rahmenfarben','Galerie-Look']
};

/* ── FAMILIEN-PRODUKT: Varianten + Preise (Produkt 10570784309514, +25 EUR/Motiv) ── */
var FAM_VIDS = {
  '2': {
    canvas:{s:'53388100075786',m:'53388100469002',l:'53388100862218',xl:'53388101255434'},
    framed_canvas:{
      black:{s:'53388100108554',m:'53388100501770',l:'53388100894986',xl:'53388101288202'},
      white:{s:'53388100141322',m:'53388100534538',l:'53388100927754',xl:'53388101320970'},
      wood: {s:'53388100174090',m:'53388100567306',l:'53388100960522',xl:'53388101353738'}
    }
  },
  '3': {
    canvas:{s:'53388100206858',m:'53388100600074',l:'53388100993290',xl:'53388101386506'},
    framed_canvas:{
      black:{s:'53388100239626',m:'53388100632842',l:'53388101026058',xl:'53388101419274'},
      white:{s:'53388100272394',m:'53388100665610',l:'53388101058826',xl:'53388101452042'},
      wood: {s:'53388100305162',m:'53388100698378',l:'53388101091594',xl:'53388101484810'}
    }
  },
  '4': {
    canvas:{s:'53388100337930',m:'53388100731146',l:'53388101124362',xl:'53388101517578'},
    framed_canvas:{
      black:{s:'53388100370698',m:'53388100763914',l:'53388101157130',xl:'53388101550346'},
      white:{s:'53388100403466',m:'53388100796682',l:'53388101189898',xl:'53388101583114'},
      wood: {s:'53388100436234',m:'53388100829450',l:'53388101222666',xl:'53388101615882'}
    }
  }
};
var FAM_PREISE = window.FAM_PREISE = {
  '2': { canvas:{s:'69,90',m:'99,90',l:'139,90',xl:'209,90',xxl:null},
         framed_canvas:{s:'99,90',m:'139,90',l:null,xl:'299,90',xxl:null} },
  '3': { canvas:{s:'84,90',m:'114,90',l:'154,90',xl:'224,90',xxl:null},
         framed_canvas:{s:'114,90',m:'154,90',l:null,xl:'314,90',xxl:null} },
  '4': { canvas:{s:'99,90',m:'129,90',l:'169,90',xl:'239,90',xxl:null},
         framed_canvas:{s:'129,90',m:'169,90',l:null,xl:'329,90',xxl:null} }
};
/* USA (11.08.): Preise in USD, netto - Sales Tax kommt beim Checkout dazu */
var AP_PREISE_US = {
  canvas:        {s:'69.90',  m:'119.90', l:'169.90', xl:'219.90', xxl:null},
  framed_canvas: {s:'109.90', m:'199.90', l:'259.90', xl:'319.90', xxl:null}
};
/* ── US-FAMILIENPRODUKT (13.08.): Family Artwork - Canvas, 10592277266698 ──
   48 Varianten = 4 Groessen x 3 Motive x 4 Ausfuehrungen. L gerahmt existiert
   in den USA (anders als in der EU). Die Motiv-Anzahl steckt NICHT in der SKU. */
var FAM_VIDS_US = {
  '2': {
    canvas:{s:'53514794041610',m:'53514794434826',l:'53514794860810',xl:'53514795254026'},
    framed_canvas:{
      black:{s:'53514794074378',m:'53514794467594',l:'53514794893578',xl:'53514795286794'},
      white:{s:'53514794107146',m:'53514794500362',l:'53514794926346',xl:'53514795319562'},
      wood: {s:'53514794139914',m:'53514794533130',l:'53514794959114',xl:'53514795352330'}
    }
  },
  '3': {
    canvas:{s:'53514794172682',m:'53514794565898',l:'53514794991882',xl:'53514795385098'},
    framed_canvas:{
      black:{s:'53514794205450',m:'53514794598666',l:'53514795024650',xl:'53514795417866'},
      white:{s:'53514794238218',m:'53514794631434',l:'53514795057418',xl:'53514795450634'},
      wood: {s:'53514794270986',m:'53514794664202',l:'53514795090186',xl:'53514795483402'}
    }
  },
  '4': {
    canvas:{s:'53514794303754',m:'53514794696970',l:'53514795122954',xl:'53514795516170'},
    framed_canvas:{
      black:{s:'53514794336522',m:'53514794729738',l:'53514795155722',xl:'53514795548938'},
      white:{s:'53514794369290',m:'53514794762506',l:'53514795188490',xl:'53514795581706'},
      wood: {s:'53514794402058',m:'53514794795274',l:'53514795221258',xl:'53514795614474'}
    }
  }
};

/* Muss zu den Shopify-Festpreisen in PriceList 31732564234 passen.
   PLATZHALTER bis merchOne antwortet — dann BEIDE Seiten zusammen aendern. */
var FAM_PREISE_US = window.FAM_PREISE_US = {
  '2': { canvas:{s:'94.90',m:'144.90',l:'194.90',xl:'244.90',xxl:null},
         framed_canvas:{s:'134.90',m:'224.90',l:'284.90',xl:'344.90',xxl:null} },
  '3': { canvas:{s:'109.90',m:'159.90',l:'209.90',xl:'259.90',xxl:null},
         framed_canvas:{s:'149.90',m:'239.90',l:'299.90',xl:'359.90',xxl:null} },
  '4': { canvas:{s:'124.90',m:'174.90',l:'224.90',xl:'274.90',xxl:null},
         framed_canvas:{s:'164.90',m:'254.90',l:'314.90',xl:'374.90',xxl:null} }
};
/* USA: Groessen in Zoll */
var AP_ZOLL = {
  s:   {hoch:'8 \u00d7 12"',  quer:'12 \u00d7 8"'},
  m:   {hoch:'16 \u00d7 24"', quer:'24 \u00d7 16"'},
  l:   {hoch:'20 \u00d7 30"', quer:'30 \u00d7 20"'},
  xl:  {hoch:'24 \u00d7 36"', quer:'36 \u00d7 24"'},
  xxl: {hoch:'36 \u00d7 48"', quer:'48 \u00d7 36"'}
};
function apIsUS(){
  /* Markt = DOMAIN, nicht Sprache. us.arturell.com ist an den US-Katalog
     gebunden; Sprache und Geolokation sind dafuer kein verlaessliches Signal.
     Im Zweifel DACH — lieber ein Amerikaner mit Euro-Preis, der abbricht,
     als eine DACH-Bestellung, die in Ohio gedruckt wird. */
  try { return /^us\./i.test(location.hostname); } catch(e){ return false; }
}
function apPreisFmt(v){
  if (v === null || v === undefined || v === '') return '';
  return apIsUS() ? ('$' + String(v)) : (String(v).replace('.',',') + ' €');
}
function apFamMotive(){ var n = parseInt((window.st && st.familyMotive) || 2, 10) || 2; return String(n > 4 ? 4 : n); }   /* AP-ZEHN-A-0111: ab 4 Fotos Variante '4 Motive' */
function apPreisTab(){
  var us = apIsUS();
  if (window.st && st.familyMergedUrl) {
    var tabF = us ? FAM_PREISE_US : FAM_PREISE;
    var fp = tabF[apFamMotive()] || tabF['2'];
    return fp[st.material] || fp.canvas;
  }
  var tabA = us ? AP_PREISE_US : AP_PREISE;
  return tabA[st.material] || tabA.canvas;
}

function apVid(sz) {
  var m = st.material || 'canvas';
  var f = st.format  || 'hoch';
  /* Familien-Modus: eigenes Produkt Familien-Kunstwerk */
  if (window.st && st.familyMergedUrl) {
    var FTAB = (typeof apIsUS === 'function' && apIsUS()) ? FAM_VIDS_US : FAM_VIDS;
    var fv = FTAB[apFamMotive()] || FTAB['2'];
    if (m === 'framed_canvas') {
      var fc2 = st.farbe || 'black';
      return (fv.framed_canvas[fc2] && fv.framed_canvas[fc2][sz]) || '0';
    }
    return fv.canvas[sz] || '0';
  }
  if (m === 'framed' || m === 'framed_canvas') {
    var c = st.farbe || 'black';
    // framed_canvas hat jetzt 3 echte Farben: black/white/wood(=Eiche)
    return (AP_VIDS[m][f] && AP_VIDS[m][f][c] && AP_VIDS[m][f][c][sz]) || '0';
  }
  return (AP_VIDS[m] && AP_VIDS[m][f] && AP_VIDS[m][f][sz]) || '0';
}
function apDLVid(){ return (window.st && st.familyMergedUrl) ? '53388104335626' : '53282865250570'; }

/* Material wechseln */
window.apMaterial = function(btn) {
  document.querySelectorAll('#ap .ap-mat-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.material = btn.dataset.mat;
  // Größen-Label je Material
  var sizeLabels=(AP_L==='en'?{canvas:'Canvas size',framed:'Print size',acrylic:'Acrylic size',framed_canvas:'Canvas size'}:{canvas:'Leinwandgröße',framed:'Bildgröße',acrylic:'Acrylglas-Größe',framed_canvas:'Leinwandgröße'});
  var slEl=document.getElementById('apSizeLabel');
  if(slEl)slEl.textContent=sizeLabels[st.material]||(AP_L==='en'?'Size':'Größe');
  // Rahmenfarbe ein/ausblenden
  var fEl = document.getElementById('apFarbe');
  var showFarbe = st.material === 'framed' || st.material === 'framed_canvas';
  if (fEl) fEl.style.display = showFarbe ? '' : 'none';
  // CSS-Klasse für White-Button Sichtbarkeit
  var apEl = document.getElementById('ap');
  if (apEl) {
    apEl.classList.remove('mat-framed-canvas');apEl.classList.remove('mat-framed');
    if (st.material === 'framed_canvas') apEl.classList.add('mat-framed-canvas');
    if (st.material === 'framed') apEl.classList.add('mat-framed');
    if (st.material === 'framed' && (st.farbe==='dark'||!st.farbe)) { st.farbe='black'; document.querySelectorAll('#ap .ap-farbe-btn').forEach(function(b){b.classList.toggle('on', b.dataset.farbe==='black');}); }
    /* framed_canvas: 'dark' existiert nicht mehr -> Schwarz */
    if (st.material === 'framed_canvas' && (st.farbe==='dark'||!st.farbe)) { st.farbe='black'; document.querySelectorAll('#ap .ap-farbe-btn').forEach(function(b){b.classList.toggle('on', b.dataset.farbe==='black');}); }
  }
  // XXL ein/ausblenden
  /* USA: weder 'framed' noch 'acrylic' existieren als US-Produkt -> XXL nie zeigen */
  var hasXXL = (typeof apIsUS==='function' && apIsUS()) ? false
             : (st.material === 'framed' || st.material === 'acrylic');
  var xxlEl = document.getElementById('apSzXXL');
  if (xxlEl) xxlEl.style.display = hasXXL ? '' : 'none';
  if (!hasXXL && st.size === 'xxl') {
    var xlBtn = document.querySelector('#ap .ap-size-btn[data-size="xl"]');
    if (xlBtn) apSize(xlBtn);
  }
  // L ausblenden: merchOne fuehrt 90x60 NICHT als Framed Canvas (bestaetigt 23.07.)
  /* L: merchOne EU fuehrt 90x60 NICHT als Framed Canvas (bestaetigt 23.07.).
     In den USA existiert L gerahmt (20x30") -> dort immer zeigen. */
  var hasL = (typeof apIsUS==='function' && apIsUS()) ? true
           : (st.material !== 'framed_canvas');
  var lEl = document.querySelector('#ap .ap-size-btn[data-size="l"]');
  if (lEl) lEl.style.display = hasL ? '' : 'none';
  if (!hasL && st.size === 'l') {
    var mBtn = document.querySelector('#ap .ap-size-btn[data-size="m"]');
    if (mBtn) apSize(mBtn);
  }
  // Preise direkt inline aktualisieren (robust)
  var p = apPreisTab();
  document.querySelectorAll('#ap .ap-size-btn').forEach(function(sb) {
    var sz = sb.dataset.size;
    if (!sz || !p[sz]) return;
    var prEl = sb.querySelector('.sz-price');
    if (prEl) prEl.textContent = apPreisFmt(p[sz]);
    sb.dataset.price = p[sz].replace(',','.');
  });
  var xxlPr = document.getElementById('apPr_xxl');
  if (xxlPr) xxlPr.textContent = apPreisFmt(p.xxl);
  // apUpdateBenefits
  if (typeof apUpdateBenefits === 'function') apUpdateBenefits();
  // Preis-Anzeige aktualisieren
  if (typeof apUpdateCurrentPrice === 'function') apUpdateCurrentPrice();
  // Material durchklicken -> immer in "An der Wand" springen (flüssig)
  if(st.artImg && typeof apWand==='function') apWand();
};

/* Rahmenfarbe wechseln */
window.apFarbe = function(btn) {
  document.querySelectorAll('#ap .ap-farbe-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.farbe = btn.dataset.farbe;
  if(window.apDrawMockup && st.artImg)apDrawMockup();
};

/* ── "↑ Vorschau"-Hinweis (nur mobile, wenn Vorschau aus dem Bild gescrollt) ── */
var _apHintT=null;
function apShowUpHint(){
  if(window.innerWidth>680||!st.artImg)return;
  var cv=document.getElementById('apWmCanvas');
  var h=document.getElementById('apUpHint');
  if(!cv||!h)return;
  if(cv.getBoundingClientRect().bottom>90)return; /* Vorschau sichtbar → kein Hinweis */
  if(h.parentNode!==document.body)document.body.appendChild(h); /* raus aus Transform-Containern (fixed-Falle) */
  h.style.display='block';
  clearTimeout(_apHintT);
  _apHintT=setTimeout(function(){h.style.display='none';},3000);
}
/* apScrollPreview entfernt (v172) — Pille ist jetzt nativer Anker-Link auf #apResultSection */
(function(){
  var _m=window.apMaterial,_f=window.apFarbe;
  window.apMaterial=function(b){_m(b);apShowUpHint();};
  window.apFarbe=function(b){_f(b);apShowUpHint();};
})();

/* In-Card-Swatch: wählt Material + Farbe über die bestehende Logik */
window.apPickFarbe = function(swEl, matVal, farbe){
  var card=document.querySelector('#ap .ap-mat-btn[data-mat="'+matVal+'"]');
  if(card && typeof apMaterial==='function')apMaterial(card);
  var fb=document.querySelector('#ap .ap-farbe-btn[data-farbe="'+farbe+'"]');
  if(fb && typeof apFarbe==='function')apFarbe(fb);
  if(card){
    card.querySelectorAll('.ap-mat-sw').forEach(function(s){s.classList.remove('on');});
    if(swEl)swEl.classList.add('on');
  }
};

/* Preise der Größen-Buttons aktualisieren */
window.apUpdatePrices = function() {
  var p = apPreisTab();
  // Alle Größen-Buttons aktualisieren
  document.querySelectorAll('#ap .ap-size-btn').forEach(function(btn) {
    var sz = btn.dataset.size;
    if (!sz) return;
    var priceEl = btn.querySelector('.sz-price');
    if (priceEl && p[sz]) priceEl.textContent = apPreisFmt(p[sz]);
    if (p[sz]) btn.dataset.price = p[sz].replace(',','.');
  });
  // XXL separat (hat ID)
  var xxlPr = document.getElementById('apPr_xxl');
  if (xxlPr) xxlPr.textContent = apPreisFmt(p.xxl);
  apUpdateCurrentPrice();
};

/* Benefit-Chips aktualisieren */
window.apUpdateBenefits = function() {
  var el = document.getElementById('apBenefits');
  if (!el) return;
  var chips = AP_BENEFITS[st.material] || AP_BENEFITS.canvas;
  el.innerHTML = chips.map(function(t){
    return '<span class="ap-benefit-chip">'+t+'</span>';
  }).join('');
};

/* Aktuellen Preis aktualisieren */
window.apUpdateCurrentPrice = function() {
  var p = apPreisTab();
  var sz = st.size || 'm';
  var preis = p[sz] || p.m;
  if (!preis) return;
  try { st.price = parseFloat(preis.replace(',','.')); } catch(e) {}
  ['apCurrentPrice','apPriceNow','apBuyP'].forEach(function(_id){
    var el = document.getElementById(_id);
    if (el) el.textContent = apPreisFmt(preis);
  });
};

/* ── INIT ── */
var defM=document.querySelector('#ap .ap-size-btn[data-size="s"]');
if(defM)apSize(defM);
var defFmt=document.querySelector('#ap .ap-fmt-btn[data-fmt="hoch"]');
if(defFmt)apFmt(defFmt);

/* UMBAU: Stil-Slider initial rendern */
apRenderStilSlider();
var APF_STILE_OK={'original':1,'regenbogenbruecke':1,'sternenhimmel':1,'engel':1,'gedenkkerze':1,'sonnenstrahlen':1,'aquarell':1,'aquarell-splash':1,'emerald':1,'chromaflare':1,'oel-hell':1,'oel-golden':1,'impressionismus':1,'van-gogh':1,'klimt':1,'rembrandt':1,'aquarell-hell-rand':1,'aquarell-splash-rand':1,'rustic-rand':1,'gouache':1,'lineart':1}   /* 19.10.: Line Art war ausgeblendet, Kachel f19-lineart vorhanden */;   /* 18.10. neue Stile */
/* 18.10.: Karussell-Bilder je Stil eine andere Familie (hochkant) */
var AP_FAM_KAR={'aquarell':apFamU('https://cdn.arturell.com/galerie/v28/common/kachel-fg-zweikatzen--aquarell.webp'),'aquarell-splash':apFamU('https://cdn.arturell.com/galerie/v28/common/clip-14-zwei-hunde-katze--aquarell-splash.webp'),'aquarell-hell-rand':apFamU('https://cdn.arturell.com/galerie/v28/common/kachel-fg-freunde--aquarell-hell-rand.webp'),'aquarell-splash-rand':apFamU('https://cdn.arturell.com/galerie/v28/{L}/web-kind-hund--aquarell-splash-rand--hund--{L}.webp'),'rustic-rand':apFamU('https://cdn.arturell.com/galerie/v28/common/clip-13-paar-kater--rustic-rand.webp'),'gouache':apFamU('https://cdn.arturell.com/galerie/v28/common/m-mt-zwei-kinder--gouache.webp'),'oel-hell':apFamU('https://cdn.arturell.com/galerie/v28/common/m-mt2-drei-kinder--oel-hell.webp'),'oel-golden':apFamU('https://cdn.arturell.com/galerie/v28/common/clip-inf3-geschwister--oel-golden.webp'),'impressionismus':apFamU('https://cdn.arturell.com/galerie/v28/{L}/t-vogelkatze--impressionismus--familie--{L}.webp'),'emerald':apFamU('https://cdn.arturell.com/galerie/v28/common/mix4--emerald.webp'),'chromaflare':apFamU('https://cdn.arturell.com/galerie/v28/common/pferd2--chromaflare.webp'),'lineart':apFamU('https://cdn.arturell.com/galerie/v28/common/clip-inf3-eltern-baby--lineart.webp'),'van-gogh':apFamU('https://cdn.arturell.com/galerie/v28/common/clip-02-vater-sohn--van-gogh.webp'),'klimt':apFamU('https://cdn.arturell.com/galerie/v28/{L}/t-hasehund--klimt--familie--{L}.webp')}; /* 19.10.: Leiste = dieselben Bilder wie die Kacheln, keine Person doppelt */
function apRenderHeroKar(){
  var t=document.getElementById('apHeroKarTrack');
  if(!t||typeof AP_STILE==='undefined')return;
  var liste=AP_STILE.filter(function(s){ return APF_STILE_OK[s.id]; });
  var lbl=document.querySelector('#ap .ap-hero-kar-label');
  if(lbl)lbl.textContent=liste.length+' '+(AP_L==='en'?'styles for your family portrait':'Stile f\u00fcr euer Familienbild');
  var html=liste.filter(function(s){ return AP_FAM_KAR[s.id]; }).map(function(s){ /* 18.10.: je Stil andere Familie */
    var motiv=AP_FAM_KAR[s.id];
    return '<div class="ap-hero-kar-card"><img src="'+motiv+'" alt="'+apStilName(s)+'" loading="lazy"><div class="kn">'+apStilName(s)+'</div></div>';
  }).join('');
  var wdh=Math.max(2,Math.ceil(16/Math.max(1,liste.length)));var out='';for(var ri=0;ri<wdh;ri++)out+=html;
  t.innerHTML=out;
}
/* FAMILIE: nur freigegebene Kategorien/Stile im Grid + Chips */
try{
  document.querySelectorAll('#ap .ap-stil-cat-head').forEach(function(h){
    var cg=h.getAttribute('data-cg');var g=h.nextElementSibling;
    var keep=(cg==='andenken'||cg==='kunst');
    if(!keep){h.style.display='none';if(g&&g.classList.contains('ap-stile-grid'))g.style.display='none';}
    else if(g){g.querySelectorAll('[data-stil]').forEach(function(b){ if(!APF_STILE_OK[b.getAttribute('data-stil')])b.style.display='none'; });}
  });
  document.querySelectorAll('#ap .ap-cat-chip').forEach(function(c){
    var cat=c.getAttribute('data-cat');
    if(cat&&cat!=='alle'&&cat!=='andenken'&&cat!=='kunst')c.style.display='none';
  });
}catch(e){}
window._apHandoffPending = false; /* 19.07.: Familienseite nimmt keine Einzelfoto-Handoffs an */
apLoadWerke();
/* ── HANDOFF von der Startseite: Foto direkt in den echten Upload-Flow speisen ── */
setTimeout(function(){
  try{
    var HKEY='arturell_handoff_v1';
    var raw=localStorage.getItem(HKEY);
    if(!raw)return;
    localStorage.removeItem(HKEY);
    var d=JSON.parse(raw);
    if(!d||!d.foto||(Date.now()-(d.ts||0)>10*60*1000))return; /* nur frisch (10 Min) */
    var fi=document.getElementById('apFileInput');
    if(!fi||typeof apDataUrlToFile!=='function')return;
    /* Crop-Hintergrund soll Schritt 2 sein: Upload-Kopf SOFORT ausblenden + Schritt 2 zeigen (vor dem Crop). */
    var hero=document.querySelector('#ap .ap-hero');
    var ss=document.getElementById('apStileSection');
    if(hero)hero.style.display='none';
    if(ss){ ss.style.display='block'; if(window.apFilterStep2ByThema)apFilterStep2ByThema(); }
    /* Crop-Abbruch (✕): zurueck zum Upload-Kopf, damit keine Sackgasse entsteht. */
    var btnX=document.getElementById('apCropClose');
    var restore=function(){ if(hero)hero.style.display=''; if(ss)ss.style.display='none'; };
    if(btnX)btnX.addEventListener('click',restore,{once:true});
    var btnOk=document.getElementById('apCropConfirm');
    if(btnOk)btnOk.addEventListener('click',function(){ if(btnX)btnX.removeEventListener('click',restore); setTimeout(function(){ try{ ss.scrollIntoView({behavior:'auto',block:'start'}); }catch(e){} },80); },{once:true});
    var file=apDataUrlToFile(d.foto,'foto.jpg'); if(!file)return;
    var dt=new DataTransfer(); dt.items.add(file); fi.files=dt.files;
    fi.dispatchEvent(new Event('change',{bubbles:true}));
  }catch(e){}
},80);
apRenderHeroKar();
apFilterStep2ByThema();

/* ═══ V180: SCHRITT-AKKORDEON ═══ */
window.apAccOpen=function(n,force){
  var cur=document.getElementById('apAccStep'+n);
  var wasOpen=cur&&cur.classList.contains('open');
  for(var i=1;i<=7;i++){var s=document.getElementById('apAccStep'+i);if(s)s.classList.remove('open');}
  if(cur&&(force||!wasOpen)){
    cur.classList.add('open');cur.classList.remove('is-future');
    if(n===1){var w=document.getElementById('apWerkeWrap');if(w)w.style.display='block';}
    /* Text-Schritt: Felder direkt zeigen (kein "Hinzufuegen"-Button mehr) */
    if(n===5){ st.persOpen=true; var _pf=document.getElementById('apPersFields'); if(_pf)_pf.classList.add('open'); if(typeof apEnsureVorschau==='function')apEnsureVorschau(); }
  }
};
function apAccDone(n,txt,next){
  var s=document.getElementById('apAccStep'+n);if(!s)return;
  var redo=s.classList.contains('done');
  s.classList.add('done');s.classList.remove('is-future');
  var e=document.getElementById('apAccSum'+n);if(e)e.textContent=txt||'';
  /* Umentscheiden: nur zuklappen, nichts aufreißen */
  if(redo){s.classList.remove('open');return;}
  if(next){
    var nx=document.getElementById('apAccStep'+next);
    if(nx&&nx.classList.contains('done')){s.classList.remove('open');return;}
    window.apAccOpen(next,true);}
  else{s.classList.remove('open');}
}
function apAccStep1Done(open2){
  if(st&&st.stilName)apAccDone(1,st.stilName,open2?2:null);
}
function apAccSyncFarbeStep(){
  var f=document.getElementById('apFarbe');
  var show=(f&&f.style.display!=='none');
  var s6=document.getElementById('apAccStep6');
  if(s6)s6.style.display=show?'':'none';
  function num(id,t){var s=document.getElementById(id);if(s){var n=s.querySelector('.ap-acc-num');if(n)n.textContent=t;}}
  /* Format-Schritt ausgeblendet -> Nummern ohne Format durchzaehlen */
  var s7x=document.getElementById('apAccStep7'); if(s7x)s7x.style.display='none';
  num('apAccStep6','3');
  num('apAccStep3',show?'4':'3');
  num('apAccStep5',show?'5':'4');
}
/* ── FORTSCHRITT: zaehlt die tatsaechlich sichtbaren Schritte (4 oder 5) ── */
function apUpdateProgress(){
  var acc=document.getElementById('apAcc'); if(!acc)return;
  var steps=[].slice.call(acc.querySelectorAll('.ap-acc-step')).filter(function(s){return s.style.display!=='none' && !s.querySelector('.ap-acc-opt');});
  var N=steps.length; if(!N)return;
  var done=0; for(var i=0;i<steps.length;i++){if(steps[i].classList.contains('done'))done++;}
  var X=Math.min(done+1,N);
  var lbl=document.getElementById('apAccProgLbl'); var t=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Step '+X+' of '+N:'Schritt '+X+' von '+N;
  if(lbl&&lbl.textContent!==t)lbl.textContent=t;
  var bar=document.getElementById('apAccProgBar'); var w=Math.round(X/N*100)+'%';
  if(bar&&bar.style.width!==w)bar.style.width=w;
  apCelebrateCheck();
}
/* ── ERFOLGS-MOMENT: Banner + Konfetti + Button-Puls, wenn alle Pflichtschritte erledigt (Text optional zaehlt nicht) ── */
var _apDoneCelebrated=false;
function apCelebrateCheck(){
  var acc=document.getElementById('apAcc'); if(!acc)return;
  var steps=[].slice.call(acc.querySelectorAll('.ap-acc-step')).filter(function(s){return s.style.display!=='none';});
  var req=steps.filter(function(s){return !s.querySelector('.ap-acc-opt');});
  if(!req.length)return;
  var allDone=req.every(function(s){return s.classList.contains('done');});
  var banner=document.getElementById('apDoneBanner');
  if(allDone){
    if(banner)banner.classList.add('on');
    if(!_apDoneCelebrated){ _apDoneCelebrated=true;
      var b=document.querySelector('#ap .ap-buy-btn');
      if(b){ b.classList.remove('ap-buy-pulse'); void b.offsetWidth; b.classList.add('ap-buy-pulse'); }
      apConfetti();
    }
  } else { if(banner)banner.classList.remove('on'); }
}
function apConfetti(){
  try{
    var cols=['#D4847A','#7A9B85','#C49A5E','#36C25E','#E8B7B0'];
    var wrap=document.createElement('div'); wrap.className='ap-confetti';
    for(var i=0;i<42;i++){
      var p=document.createElement('i');
      p.style.left=(Math.random()*100)+'%';
      p.style.background=cols[i%cols.length];
      p.style.animationDuration=(1.1+Math.random()*1.1)+'s';
      p.style.animationDelay=(Math.random()*0.25)+'s';
      p.style.transform='rotate('+(Math.random()*360)+'deg)';
      wrap.appendChild(p);
    }
    document.body.appendChild(wrap);
    setTimeout(function(){ if(wrap.parentNode)wrap.parentNode.removeChild(wrap); },2800);
  }catch(e){}
}
(function(){
  var acc=document.getElementById('apAcc'); if(!acc)return;
  var raf=null;
  var obs=new MutationObserver(function(){ if(raf)return; raf=requestAnimationFrame(function(){raf=null;apUpdateProgress();}); });
  obs.observe(acc,{subtree:true,attributes:true,attributeFilter:['class','style']});
  apUpdateProgress();
})();
function apMatName(){var b=document.querySelector('#ap .ap-mat-btn.on .ap-mat-name');return b?b.textContent:'';}
function apFarbName(){var b=document.querySelector('#ap .ap-farbe-btn.on');return b?b.textContent.trim():'';}
window.apV180NeuesFoto=function(){
  /* FLOW v12: Neues Foto -> Stil-Liste oeffnen (kein Datei-Dialog). User waehlt Stil -> apNeuesFotoStil oeffnet Foto -> Cropper -> generiert. */
  st.pendingStil = null;
  if(typeof apOpenStile==='function') apOpenStile();
};
/* apOpenStile: Ziel repariert — Toggle-Button existiert nicht mehr */
window.apOpenStile=function(){
  window.apAccOpen(1,true);
  var a=document.getElementById('apAcc');
  if(a&&a.scrollIntoView)a.scrollIntoView({behavior:'smooth',block:'start'});
};
(function(){
  var _sw=window.apSelectWerk;window.apSelectWerk=function(u,sid,fmt,fm){_sw(u,sid,fmt,fm);apAccStep1Done(true);};
  var _st=window.apStil;window.apStil=function(b){_st(b);apAccStep1Done(false);};
  var _sc=window.apStilSliderClick;window.apStilSliderClick=function(sid){_sc(sid);apAccStep1Done(false);};
  var _nf=window.apNeuesFotoStil;window.apNeuesFotoStil=function(sid){_nf(sid);apAccStep1Done(false);};
  var _m3=window.apMaterial;window.apMaterial=function(b){_m3(b);
    /* Preis-Bar syncen: aktiver Größen-Button hat frische dataset.price vom Materialwechsel */
    var ab=document.querySelector('#ap .ap-size-btn.on');
    if(ab){st.price=parseFloat(ab.dataset.price);aktualisierePreis();
      var cm=ab.querySelector('.sz-cm');var e3=document.getElementById('apAccSum3');
      if(e3&&e3.textContent&&cm)e3.textContent=cm.textContent;}
    apAccSyncFarbeStep();
    var s2=document.getElementById('apAccStep2');var e2=document.getElementById('apAccSum2');
    var farbeAn=(function(){var fl=document.getElementById('apFarbe');return fl&&fl.style.display!=='none';})();
    if(s2){s2.classList.add('done');s2.classList.remove('is-future');s2.classList.remove('open');}
    if(e2)e2.textContent=apMatName();
    var s7=document.getElementById('apAccStep7');
    /* Format wird vom Foto bestimmt -> Schritt ueberspringen: als done markieren, Anzeige aus */
    if(s7){ s7.classList.add('done'); s7.classList.remove('is-future','open'); s7.style.display='none'; }
    if(false){window.apAccOpen(7,true);}
    else if(farbeAn){
      var s6=document.getElementById('apAccStep6');var e6=document.getElementById('apAccSum6');
      if(e6&&apFarbName())e6.textContent=apFarbName();
      if(s6&&!s6.classList.contains('done'))window.apAccOpen(6,true);
      else{var s3a=document.getElementById('apAccStep3');
        if(s3a&&!s3a.classList.contains('done'))window.apAccOpen(3,true);}}
    else{var s3=document.getElementById('apAccStep3');
      if(s3&&!s3.classList.contains('done'))window.apAccOpen(3,true);}};
  var _sz2=window.apSize;window.apSize=function(b){_sz2(b);
    var cm=b&&b.querySelector('.sz-cm');apAccDone(3,cm?cm.textContent:'',null);};
  var _fb2=window.apFarbe;window.apFarbe=function(b){_fb2(b);
    apAccDone(6,apFarbName(),3);};
  var _fm2=window.apFmt;window.apFmt=function(b){_fm2(b);
    var ab=document.querySelector('#ap .ap-size-btn.on');var e3=document.getElementById('apAccSum3');
    if(ab&&e3&&e3.textContent){var cm=ab.querySelector('.sz-cm');if(cm)e3.textContent=cm.textContent;}
    /* Format = Schritt 3: nur weiterspringen, wenn der Schritt gerade offen ist (nicht bei Auto-Erkennung) */
    var s7=document.getElementById('apAccStep7');
    if(s7&&s7.classList.contains('open')){
      var fmtName=(b&&b.dataset&&b.dataset.fmt==='quer')?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Landscape':'Querformat'):((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Portrait':'Hochformat');
      var farbeAn=(function(){var fl=document.getElementById('apFarbe');return fl&&fl.style.display!=='none';})();
      apAccDone(7,fmtName,farbeAn?6:3);
    }};
  var _ut2=window.apUpdateText;window.apUpdateText=function(){_ut2();
    var l1=document.getElementById('apPersLine1'),l2=document.getElementById('apPersLine2');
    var t1=(l1&&l1.value)||'',t2=(l2&&l2.value)||'';
    var t=t1+((t1&&t2)?' · ':'')+t2;
    var s5=document.getElementById('apAccStep5');var e=document.getElementById('apAccSum5');
    if(t){if(s5){s5.classList.add('done');s5.classList.remove('is-future');}
      if(e)e.textContent='\u201E'+(t.length>22?t.slice(0,22)+'\u2026':t)+'\u201C';}
    else{if(s5)s5.classList.remove('done');if(e)e.textContent='';}};
  /* Init */
  apAccSyncFarbeStep();
  if(st&&st.artUrl&&st.stilName){apAccDone(1,st.stilName,null);}
  else{window.apAccOpen(1,true);}
})();

})();
  // Preise initialisieren
  if (typeof apUpdatePrices === 'function') apUpdatePrices();

/* ══════════ CROP-TOOL: Kunde positioniert Foto im Ziel-Format ══════════ */
(function(){
  var modal=document.getElementById('apCropModal');
  var stage=document.getElementById('apCropStage');
  var cv=document.getElementById('apCropCanvas');
  var zoom=document.getElementById('apCropZoom');
  var btnOk=document.getElementById('apCropConfirm');
  var btnX=document.getElementById('apCropClose');
  if(!modal||!cv) return;
  /* Modal an body verschieben -> immer sichtbar, auch wenn Hero-Section display:none ist */
  try { if(modal.parentElement !== document.body) document.body.appendChild(modal); } catch(e){}
  var ctx=cv.getContext('2d');
  var img=new Image();
  var S={imgW:0,imgH:0,cw:0,ch:0,scale:1,minScale:1,ox:0,oy:0,drag:false,lx:0,ly:0,cb:null,ratio:1};

  function fitCanvas(ratio){
    var maxW=stage.clientWidth||480;
    var cw=maxW, ch=Math.round(maxW/ratio);
    var maxH=Math.round((window.innerHeight||700)*0.52);
    if(ch>maxH){ ch=maxH; cw=Math.round(maxH*ratio); }
    var dpr=Math.min(window.devicePixelRatio||1,2);
    cv.width=Math.round(cw*dpr); cv.height=Math.round(ch*dpr);
    cv.style.width=cw+'px'; cv.style.height=ch+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
    S.cw=cw; S.ch=ch; S.ratio=ratio;
  }
  function computeMin(){ S.minScale=Math.max(S.cw/S.imgW, S.ch/S.imgH); }
  function clamp(){
    var w=S.imgW*S.scale, h=S.imgH*S.scale;
    if(S.ox>0)S.ox=0; if(S.oy>0)S.oy=0;
    if(S.ox<S.cw-w)S.ox=S.cw-w; if(S.oy<S.ch-h)S.oy=S.ch-h;
  }
  function draw(){ ctx.clearRect(0,0,S.cw,S.ch); ctx.drawImage(img,S.ox,S.oy,S.imgW*S.scale,S.imgH*S.scale); }
  function open(dataUrl,format,cb){
    S.cb=cb;
    var ratio=(format==='quer')?(3/2):(2/3);
    img.onload=function(){
      S.imgW=img.naturalWidth; S.imgH=img.naturalHeight;
      /* AP-FAM-GANZES-FOTO-3110: 'ganz' = Rahmen im Seitenverhaeltnis des Fotos (ohne Zoom das ganze Foto) */
      if(format==='ganz' && S.imgW && S.imgH) ratio=S.imgW/S.imgH;
      fitCanvas(ratio); computeMin();
      S.scale=S.minScale;
      S.ox=(S.cw-S.imgW*S.scale)/2; S.oy=(S.ch-S.imgH*S.scale)/2;
      clamp(); draw();
      zoom.value=100;
      modal.style.display='flex';
    };
    img.src=dataUrl;
  }
  window.apOpenCrop=open;

  zoom.addEventListener('input',function(){
    var f=parseInt(zoom.value,10)/100;
    var cx=S.cw/2, cy=S.ch/2;
    var wx=(cx-S.ox)/S.scale, wy=(cy-S.oy)/S.scale;
    S.scale=S.minScale*f;
    S.ox=cx-wx*S.scale; S.oy=cy-wy*S.scale;
    clamp(); draw();
  });

  function pt(e){ var r=cv.getBoundingClientRect(); var t=e.touches?e.touches[0]:e; return {x:(t.clientX-r.left)*(S.cw/r.width), y:(t.clientY-r.top)*(S.ch/r.height)}; }
  function down(e){ S.drag=true; var q=pt(e); S.lx=q.x; S.ly=q.y; e.preventDefault(); }
  function move(e){ if(!S.drag)return; var q=pt(e); S.ox+=q.x-S.lx; S.oy+=q.y-S.ly; S.lx=q.x; S.ly=q.y; clamp(); draw(); e.preventDefault(); }
  function up(){ S.drag=false; }
  cv.addEventListener('mousedown',down); window.addEventListener('mousemove',move); window.addEventListener('mouseup',up);
  cv.addEventListener('touchstart',down,{passive:false}); cv.addEventListener('touchmove',move,{passive:false}); cv.addEventListener('touchend',up);

  function finish(dataUrl){ modal.style.display='none'; if(S.cb){ var f=S.cb; S.cb=null; f(dataUrl); } }
  btnOk.addEventListener('click',function(){
    var outW,outH;
    /* 15.10.: native Aufloesung des Ausschnitts behalten (max. 3000 px), statt fix 1400 px */
    var natW=S.cw/S.scale, natH=S.ch/S.scale, natK=Math.min(1, 3000/Math.max(natW,natH));
    outW=Math.round(natW*natK); outH=Math.round(natH*natK);
    var oc=document.createElement('canvas'); oc.width=outW; oc.height=outH;
    var octx=oc.getContext('2d');
    var sc=outW/S.cw;
    octx.drawImage(img, S.ox*sc, S.oy*sc, S.imgW*S.scale*sc, S.imgH*S.scale*sc);
    finish(oc.toDataURL('image/jpeg',0.9));
  });
  btnX.addEventListener('click',function(){
    modal.style.display='none';
    S.cb=null;
    try { var _fi=document.getElementById('apFileInput'); if(_fi) _fi.value=''; } catch(e){}
  });
})();

/* ══════════ FAMILIEN-MULTI-UPLOAD (family-v1) ══════════ */
(function(){
  var MAXF = (window.apAufOk && window.apAufOk()) ? window.AP_ZEHN.max : 4, MINF = 2; /* AP-ZEHN-A-0111: AP_ZEHN.max (Theme-Einstellung) nur mit Aufpreis-Produkt. 18.07. abends: 4 Personen reaktiviert - GPT-Merge haelt Identitaeten (Face-Score-Dreikampf) */
  st.familyFotos = st.familyFotos || [];   // [{dataUrl, file}]

  /* AP-GRUPPE-3110: Personen je Foto (apfMotivCheck, Worker zaehlt bei zaehlen:true). Teilsumme = Untergrenze.
     Ab 6 Personen Querformat, 13 bis 20 Hinweis, ueber 20 gesperrt (Befund 31.10.2026). Ohne Zahl: wie bisher. */
  function apfPersonen(){ var p=0, da=false; (st.familyFotos||[]).forEach(function(f){ if(f && typeof f.personen==='number'){ p+=f.personen; da=true; } }); return da?p:null; }
  function apfFotoSig(){ return (st.familyFotos||[]).map(function(f){ var u=(f&&f.dataUrl)||''; return u.length+':'+u.slice(-24); }).join('|'); }
  function apfGruppe(){
    var n=(st.familyFotos||[]).length, p=apfPersonen();
    if(n<2) return '';
    if(st._apfGruppeServer && st._apfGruppeServer===apfFotoSig()) return 'sperre';
    if(p===null) return '';
    if(p>window.AP_ZEHN.pers) return 'sperre';   /* AP-ZEHN-A-0111: hoechstens 10 Personen (E135/E138), vorher 20 + Hinweis ab 13 */
    return '';
  }
  window.apfGruppe = apfGruppe;
  window.apfPersonen = apfPersonen;
  function fmtEmpfehlung(nn){
    var _gp=apfPersonen();   /* AP-GRUPPE-3110 */
    if(nn>=2 && nn<4 && _gp!==null && _gp>=6) return {fmt:'quer', txt:(((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en')?'Landscape, so everyone fits nicely.':'Querformat, damit alle gut ins Bild passen.')};
    if(nn===2) return {fmt:'hoch', txt:window.T.hochformat2};
    if(nn===3) return {fmt:'hoch', txt:window.T.hochformat3};
    if(nn>=4)  return {fmt:'quer', txt:((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Landscape, so everyone fits nicely.':'Querformat, damit alle gut ins Bild passen.')};
    return {fmt:'hoch', txt:''};
  }

  /* ── MERGE-QUOTA: 2 frei, 3 mit E-Mail (localStorage, Tagesreset) ── */
  var APF_MERGE_LIMIT = 2;
  function apfQuotaState(){
    try{
      var heute = new Date().toISOString().slice(0,10);
      var raw = localStorage.getItem('apfMergeQuota');
      var s = raw ? JSON.parse(raw) : null;
      if(!s || s.date !== heute){ s = {date: heute, used: 0}; }
      return s;
    }catch(e){ return {date:'', used:0}; }
  }
  /* Bonus zeigt nur noch der ECHTE Grant an (Mailgate) — der alte Flag war per
     ?nl=1 faelschbar. Geraete-ID/Grant hier definieren, weil die Familienseite
     arturell-product.js nicht laedt. */
  if(!window.apDevId){ window.apDevId=function(){
    try{
      var d=localStorage.getItem('apDevId');
      if(!d){ d=(window.crypto&&crypto.randomUUID)?crypto.randomUUID():('d'+Date.now()+'-'+Math.random().toString(36).slice(2,10)); localStorage.setItem('apDevId',d); }
      return d;
    }catch(e){ return ''; }
  }; }
  if(!window.apGrant){ window.apGrant=function(){ try{ return localStorage.getItem('apMailGrant')||''; }catch(e){ return ''; } }; }
  function apfHatBonus(){ try{ return !!localStorage.getItem('apMailGrant'); }catch(e){ return false; } }
  function apfLimit(){ return apfHatBonus() ? (APF_MERGE_LIMIT + 3) : APF_MERGE_LIMIT; }  /* 2 frei + 3 nach Mail (21.08., wie Worker FREI_MERGE_*) */
  function apfQuotaLeft(){ return Math.max(0, apfLimit() - apfQuotaState().used); }
  window.apfQuotaUse = function(n){   /* AP-MERGE-DOPPELT-ANZEIGE-0111: n = 2 bei 5 oder mehr Fotos (Worker zaehlt genauso; = Worker-Agent Theme-Patch 08) */
    try{ var s = apfQuotaState(); s.used += (n===2 ? 2 : 1); localStorage.setItem('apfMergeQuota', JSON.stringify(s)); }catch(e){}
    apfQuotaRender();
  };
  function apfToast(msg){
    var t=document.createElement('div');
    t.textContent=msg;
    t.style.cssText='position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#1A1714;color:#fff;padding:20px 30px;border-radius:16px;font-size:15px;font-weight:600;z-index:99999;box-shadow:0 16px 56px rgba(0,0,0,.4);max-width:86vw;text-align:center';
    document.body.appendChild(t);
    setTimeout(function(){ try{t.remove();}catch(e){} }, 3800);
  }
  function apfQuotaRender(){
    var left = apfQuotaLeft();
    var txt = (window.Shopify&&Shopify.locale||'de').slice(0,2)==='en' ? (left>0 ? (left+' left today') : 'back tomorrow') : (left>0 ? ('noch '+left+' heute') : 'morgen wieder');
    var a=document.getElementById('apfQuota1'); if(a)a.textContent=txt;
    var b=document.getElementById('apfQuota2'); if(b)b.textContent='('+txt+')';
    var btns=document.querySelectorAll('[onclick="apfNeueZusammenfuehrung()"]');
    for(var i=0;i<btns.length;i++){ btns[i].style.opacity = left>0 ? '1' : '.45'; }
  }
  window.apfNeueZusammenfuehrung = function(){
    if(apfQuotaLeft() <= 0){
      apfNlOpen(apfHatBonus() ? 'end' : 'form');
      return;
    }
    try{ sessionStorage.setItem('apfNeuMerge','1'); }catch(e){}
    location.reload();
  };
  if(document.readyState!=='loading') apfQuotaRender();
  else document.addEventListener('DOMContentLoaded', apfQuotaRender);

  /* ── E-MAIL-GATE: Modal + Bonus-Freischaltung ── */
  window.apfNlOpen = function(view){
    var ov=document.getElementById('apfNlOverlay'); if(!ov) return;
    var f=document.getElementById('apfNlViewForm'), e=document.getElementById('apfNlViewEnd');
    if(f) f.style.display = (view==='form') ? 'block' : 'none';
    if(e) e.style.display = (view==='end') ? 'block' : 'none';
    ov.classList.add('open');
    if(view==='form'){ try{ apfNlCaptcha(document.getElementById('apfNlForm')); }catch(e){} }   /* AP-FAM-MAILGATE-3110: frueh binden */
  };
  window.apfNlClose = function(){
    var ov=document.getElementById('apfNlOverlay'); if(ov) ov.classList.remove('open');
  };
  /* ── MAILGATE (12.08.): Code-Bestaetigung VOR dem Shopify-Submit ──
     Gleicher Ablauf wie auf der Produktseite: Code anfordern, im Overlay
     eingeben, Grant speichern, DANN regulaer zu Shopify. Bei Worker-Problemen
     Fallback aufs alte Verhalten — das Overlay blockiert nie. */
  var APF_MG_URL='https://arturell-preview.arturell.workers.dev/mailgate';
  /* Anfangszustand des Mailgate-Knopfs (14.08.): der Liquid-t-Key greift nicht
     zuverlaessig, weil Shopify Locale-Schluessel erst indexieren muss. Hier
     direkt setzen — unabhaengig vom Locale-System. */
  try{ document.querySelectorAll('.apnl-cta').forEach(function(b){
    if(b.type==='submit') b.textContent = _fmgEN ? 'Subscribe & unlock' : 'Newsletter abonnieren & freischalten';
  }); }catch(e){}
  var _fmgEN=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
  /* AP-MAILCODE-EN 29.10.2026 */ var _fmgENT={abgelaufen:'The code has expired or there were too many attempts. Please request a new code.',bot:'Security check failed. Please reload the page.',config:'Confirmation is not available right now. Please try again later.',cooldown:'The code was just sent. Please check your inbox (and spam folder).',eingabe:'Please enter your email address and the 6-digit code.',email:'Please enter a valid email address.',limit:'It is very busy right now. Please try again a little later.',server:'Something went wrong. Please try again.',versand:'The code could not be sent. Please try again in a moment.'};function _fmgMsg(d){if(!d)return '';return _fmgEN?(_fmgENT[d.error]||''):(d.message||'');}
  /* AP-FAM-FOTOS-BEHALTEN-3110: kam das Mail-Fenster vom Zusammenfuehrungs-Limit, werden die Fotos vor dem Absenden
     in IndexedDB gesichert (sonst sessionStorage, sonst wie bisher) und nach ?nl=1 wieder in die Kacheln gelegt.
     return_to folgt der aktuellen Seite (auch /en). Am Absenden selbst (form.submit) aendert sich nichts. */
  var APF_FB='apfFotos', APF_FB_TTL=2*3600*1000;
  function apfIdb(art, wert){
    return new Promise(function(ok){
      var fertig=false, t=setTimeout(function(){ aus(null); }, 3000);
      function aus(v){ if(fertig) return; fertig=true; clearTimeout(t); ok(v); }
      try{
        if(!window.indexedDB){ aus(null); return; }
        var r=window.indexedDB.open('arturell-fam', 1);
        r.onupgradeneeded=function(){ try{ r.result.createObjectStore('k'); }catch(e){} };
        r.onerror=function(){ aus(null); }; r.onblocked=function(){ aus(null); };
        r.onsuccess=function(){
          var db=r.result;
          try{
            var tx=db.transaction('k', art==='get'?'readonly':'readwrite'), os=tx.objectStore('k');
            var q=art==='get'?os.get(APF_FB):(art==='del'?os.delete(APF_FB):os.put(wert, APF_FB));
            q.onsuccess=function(){ if(art==='get') aus(q.result||null); };
            tx.oncomplete=function(){ try{ db.close(); }catch(e){} if(art!=='get') aus(true); };
            tx.onerror=tx.onabort=function(){ try{ db.close(); }catch(e){} aus(null); };
          }catch(e){ try{ db.close(); }catch(x){} aus(null); }
        };
      }catch(e){ aus(null); }
    });
  }
  function apfFotosSichern(){
    if(!window.__apfFotosSichern || !st.familyFotos || !st.familyFotos.length) return Promise.resolve(false);
    var z={ t:Date.now(), fotos: st.familyFotos.map(function(f){ return { dataUrl:f.dataUrl, w:f.w||0, h:f.h||0,
      personen:(typeof f.personen==='number'?f.personen:null), tiere:(typeof f.tiere==='number'?f.tiere:null),
      gesicht:(f.gesicht||null), gp:(f.gp?1:0) }; }) };   /* AP-GESICHT-FIX-0111: Gesichts-Ergebnis mit sichern */
    /* Upload-Ansicht nach dem Neuladen behalten (gleicher Merker wie "Neue Zusammenfuehrung"; apLoadWerke verbraucht ihn nur bei vorhandenen Werken) */
    try{ if(st.artHistory && st.artHistory.length) sessionStorage.setItem('apfNeuMerge','1'); }catch(e){}
    return apfIdb('put', z).then(function(ok){
      if(ok) return true;
      try{ sessionStorage.setItem(APF_FB, JSON.stringify(z)); return true; }catch(e){ return false; }
    });
  }
  function apfFotosZurueck(){
    return apfIdb('get').then(function(z){
      if(!z){ try{ z=JSON.parse(sessionStorage.getItem(APF_FB)||'null'); }catch(e){ z=null; } }
      apfIdb('del'); try{ sessionStorage.removeItem(APF_FB); }catch(e){}
      if(!z || !z.fotos || !z.fotos.length || Date.now()-(z.t||0)>APF_FB_TTL || (st.familyFotos && st.familyFotos.length) || st.busy) return false;
      st.familyFotos = z.fotos.slice(0, MAXF).filter(function(f){ return f && f.dataUrl; }).map(function(f){
        var o={ dataUrl:f.dataUrl, file:null, orig:null };
        if(f.w){ o.w=f.w; o.h=f.h; }
        if(typeof f.personen==='number'){ o.personen=f.personen; o.tiere=(typeof f.tiere==='number')?f.tiere:0; }
        if(f.gesicht && typeof f.gesicht.anteil==='number') o.gesicht=f.gesicht; if(f.gp) o.gp=1;   /* AP-GESICHT-FIX-0111 */
        return o;
      });
      if(!st.familyFotos.length) return false;
      try{ apfRenderSlots(); }catch(e){}
      try{ if(window.apGsAn && apGsAn() && typeof window.apfMotivCheck==='function') st.familyFotos.forEach(function(f){ if(!f.gp && !f.gesicht) window.apfMotivCheck(f.dataUrl); }); }catch(e){}   /* AP-GESICHT-FIX-0111: ohne Gesichts-Ergebnis neu pruefen */
      try{ var sl=document.getElementById('apfSlots'); if(sl) sl.scrollIntoView({behavior:'smooth', block:'center'}); }catch(e){}
      setTimeout(function(){ apfToast(((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en')?'Unlocked! Your photos are still here, you can carry on right away.':'Freigeschaltet! Deine Fotos sind noch da, du kannst direkt weitermachen.'); }, 4000);
      return true;
    });
  }
  window.apfFotosZurueck = apfFotosZurueck;
  /* AP-FAM-MAILGATE-3110: Absenden erst NACH /verify (oder wenn der Worker nicht bereit ist), mit Shopify-Captcha und
     requestSubmit (submit-Ereignis -> hCaptcha-Token) statt form.submit(). Mail kommt ins versteckte Feld. */
  function apfMgFallback(form){
    try{ form.dataset.mgDone='1'; }catch(e){}
    try{ var _fm=form.elements['contact[email]']; if(_fm && window.__apfMgMail) _fm.value=window.__apfMgMail; }catch(e){}
    try{ if(form.elements['return_to']) form.elements['return_to'].value=location.pathname+'?nl=1'; }catch(e){}   /* /en bleibt /en */
    apfNlCaptcha(form);
    var los=false; function senden(){ if(los) return; los=true; try{ if(form.requestSubmit) form.requestSubmit(); else form.submit(); }catch(e){ try{ form.submit(); }catch(x){} } }
    var p=null; try{ p=(typeof apfFotosSichern==='function')?apfFotosSichern():null; }catch(e){ p=null; }
    if(p && p.then){ p.then(senden, senden); setTimeout(senden, 5000); } else senden();
  }
  /* AP-FAM-MAILGATE-3110: hCaptcha von Shopify an das VERSTECKTE Formular binden (wie Fast Track nlCaptcha) */
  var apfNlCaptchaGebunden=false;
  function apfNlCaptcha(form){
    if(apfNlCaptchaGebunden || !form) return; apfNlCaptchaGebunden=true;
    try{ if(window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect==='function'){ Shopify.captcha.protect(form); return; } }catch(e){}
    try{ var el=form.elements['contact[email]']; if(el) el.dispatchEvent(new FocusEvent('focusin',{bubbles:true})); }catch(e){}
  }
  function apfMgStart(form){
    /* AP-FAM-MAILGATE-3110: sichtbares Feld/Knopf liegen AUSSERHALB des Shopify-Formulars (#apfNlMail, #apfNlStart) */
    var inp=document.getElementById('apfNlMail')||form.querySelector('input[name="contact[email]"]');
    var mail=inp?String(inp.value||'').trim():'';
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)){ apfToast(_fmgEN?'Please enter a valid email address.':'Bitte gib eine gültige E-Mail-Adresse ein.'); return; }
    window.__apfMgMail=mail;
    var btn=document.getElementById('apfNlStart')||form.querySelector('button[type="submit"]');
    if(btn){ btn.disabled=true; btn.textContent=_fmgEN?'Sending code…':'Code wird gesendet…'; }
    (window.apTsToken?window.apTsToken():Promise.resolve('')).then(function(tk){
      return fetch(APF_MG_URL+'/start',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:mail,tsToken:tk,lang:(_fmgEN?'en':'de')})});
    }).then(function(r){ return r.json(); }).then(function(d){
      if(d&&(d.ok||d.error==='cooldown')){ apfMgZeigeCode(form,mail); }
      else if(d&&(d.error==='email'||d.error==='limit'||d.error==='bot'||d.error==='versand')){
        /* echte Server-Antwort mit Grund -> anzeigen, NICHT zu Shopify durchreichen */
        if(btn){ btn.disabled=false; btn.textContent=_fmgEN?'Subscribe & unlock':'Newsletter abonnieren & freischalten'; }
        apfToast(_fmgMsg(d)||(_fmgEN?'That did not work. Please try again.':'Das hat nicht geklappt. Bitte versuche es erneut.'));
      }
      else { apfMgFallback(form); } /* config/unbekannt -> altes Verhalten */
    }).catch(function(){ apfMgFallback(form); });
  }
  function apfMgZeigeCode(form,mail){
    var box=document.getElementById('apfNlViewForm'); if(!box){ apfMgFallback(form); return; }
    /* Immer NEU bauen — alte Box haelt Adresse+Handler der ersten Mail im Closure */
    var alt=document.getElementById('apfMgCodeBox');
    if(alt){ try{ alt.remove(); }catch(e){ alt.parentNode.removeChild(alt); } }
    form.style.display='none';
    var _ein=document.getElementById('apfNlEingabe'); if(_ein) _ein.style.display='none';   /* AP-FAM-MAILGATE-3110 */
    var w=document.createElement('div'); w.id='apfMgCodeBox';
    w.innerHTML='<p style="margin:0 0 12px;font-size:14px;color:#4A453E">'+(_fmgEN?'We sent a 6-digit code to ':'Wir haben einen 6-stelligen Code an ')+'<b>'+mail.replace(/</g,'&lt;').replace(/>/g,'&gt;')+'</b>'+(_fmgEN?'.':' geschickt.')+'</p>'
      +'<input id="apfMgCode" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="000000" class="apnl-input" style="text-align:center;letter-spacing:8px;font-size:22px">'
      +'<button type="button" id="apfMgOk" class="apnl-cta">'+(_fmgEN?'Confirm':'Bestätigen')+'</button>'
      +'<p id="apfMgErr" style="display:none;margin:10px 0 0;font-size:13px;color:#B4231F"></p>'
      +'<p style="margin:12px 0 0;font-size:12px;color:#8A857E">'+(_fmgEN?'No email? Check spam or ':'Keine E-Mail? Schau im Spam nach oder ')+'<a href="#" id="apfMgNeu" style="color:#8A857E;text-decoration:underline">'+(_fmgEN?'request a new code':'fordere einen neuen Code an')+'</a></p>';
    box.appendChild(w);
    var ci=w.querySelector('#apfMgCode'); if(ci){ ci.focus(); ci.addEventListener('keydown',function(ev){ if(ev.key==='Enter'){ ev.preventDefault(); apfMgVerify(form,mail,w); } }); }
    w.querySelector('#apfMgOk').addEventListener('click',function(){ apfMgVerify(form,mail,w); });
    w.querySelector('#apfMgNeu').addEventListener('click',function(ev){
      ev.preventDefault(); w.style.display='none';
      var _e2=document.getElementById('apfNlEingabe'); if(_e2){ _e2.style.display=''; } else { form.style.display='block'; }   /* AP-FAM-MAILGATE-3110 */
      var b=document.getElementById('apfNlStart')||form.querySelector('button[type="submit"]'); if(b){ b.disabled=false; b.textContent=_fmgEN?'Subscribe & unlock':'Newsletter abonnieren & freischalten'; }
    });
  }
  function apfMgVerify(form,mail,w){
    /* Reentrancy-Guard gegen Doppel-Enter/Klick (Server: 15 Versuche/Tag je Adresse) */
    var ok=w.querySelector('#apfMgOk'); if(ok&&ok.disabled)return;
    var code=String((w.querySelector('#apfMgCode')||{}).value||'').trim();
    var err=w.querySelector('#apfMgErr');
    if(!/^[0-9]{6}$/.test(code)){ if(err){ err.textContent=_fmgEN?'Please enter the 6-digit code.':'Bitte gib den 6-stelligen Code ein.'; err.style.display='block'; } return; }
    if(ok)ok.disabled=true;
    fetch(APF_MG_URL+'/verify',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:mail,code:code})})
      .then(function(r){ return r.json(); }).then(function(d){
        if(d&&d.ok&&d.grant){
          try{ localStorage.setItem('apMailGrant',d.grant); localStorage.setItem('apfEmailBonus','1'); }catch(e){}
          try{ apfQuotaRender(); }catch(e){}
          apfMgFallback(form);
        } else {
          if(ok)ok.disabled=false;
          if(err){ err.textContent=_fmgMsg(d)?_fmgMsg(d):(_fmgEN?'That did not work. Please try again.':'Das hat nicht geklappt. Bitte versuche es erneut.'); err.style.display='block'; }
        }
      }).catch(function(){ if(ok)ok.disabled=false; if(err){ err.textContent=_fmgEN?'Connection error. Please try again.':'Verbindungsfehler. Bitte versuche es erneut.'; err.style.display='block'; } });
  }
  function apfNlInit(){
    var form=document.getElementById('apfNlForm');
    if(form){ form.addEventListener('submit', function(ev){
      /* form.submit() (Fallback) loest dieses Event NICHT erneut aus — keine Schleife. */
      try{
        if(form.dataset.mgDone==='1'){ return; }
        ev.preventDefault();
        apfMgStart(form);
      }catch(e){ try{ form.dataset.mgDone='1'; form.submit(); }catch(_e){} }
    }); }
    /* AP-FAM-MAILGATE-3110: Knopf und Enter starten den Code direkt, ohne submit-Ereignis am Shopify-Formular */
    var _sb=document.getElementById('apfNlStart'), _mi=document.getElementById('apfNlMail');
    if(form && _sb){ _sb.addEventListener('click', function(){ if(_sb.disabled) return; apfMgStart(form); }); }
    if(form && _mi){ _mi.addEventListener('keydown', function(ev){ if(ev.key==='Enter'){ ev.preventDefault(); if(_sb && _sb.disabled) return; apfMgStart(form); } }); }
    var ov=document.getElementById('apfNlOverlay');
    if(ov){ ov.addEventListener('click', function(ev){ if(ev.target===ov) apfNlClose(); }); }
    /* Rueckkehr nach Newsletter-Submit erkennen (nl=1 oder Shopify customer_posted) */
    try{
      var q=location.search;
      if(q.indexOf('nl=1')!==-1 || q.indexOf('customer_posted=true')!==-1){
        apfQuotaRender();
        /* Freischaltung nur behaupten, wenn wirklich ein Grant da ist */
        apfToast(apfHatBonus()
          ? (_fmgEN?'Done! Your bonus is unlocked.':'Geschafft! Dein Bonus ist freigeschaltet.')
          : (_fmgEN?'Thanks for subscribing!':'Danke für deine Anmeldung!'));
        history.replaceState(null,'',location.pathname);
        try{ apfFotosZurueck(); }catch(e){}   /* AP-FAM-FOTOS-BEHALTEN-3110 */
      }
    }catch(e){}
  }
  if(document.readyState!=='loading') apfNlInit();
  else document.addEventListener('DOMContentLoaded', apfNlInit);

  /* ── MOTIV-GATE Familienseite: nur Personen/Tiere zulassen ── */
  var APF_MOTIV_OK = ['person','tier','paar','baby','gruppe'];
  function apfMotivFehler(msg){
    var slots = document.getElementById('apfSlots');
    if(!slots) return;
    var el = document.getElementById('apfMotivErr');
    if(!el){
      el = document.createElement('div');
      el.id = 'apfMotivErr';
      el.style.cssText = 'margin:12px auto 0;max-width:440px;background:#FDECEA;color:#B3261E;border:1px solid #F5C6C0;border-radius:10px;padding:10px 14px;font-size:13px;font-weight:600;text-align:center';
      slots.parentNode.insertBefore(el, slots.nextSibling);
    }
    el.textContent = msg;
    el.style.display = 'block';
    clearTimeout(el._t);
    el._t = setTimeout(function(){ el.style.display='none'; }, 6000);
  }
  window.apfMotivCheck = function(dataUrl){
    var _gsReq = !!(window.apGsAn && apGsAn());   /* AP-GESICHT-FIX-0111 */
    try {
      fetch('https://arturell-preview.arturell.workers.dev/', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({image: dataUrl, stil:'aquarell', format:'hoch', motivOnly:true, zaehlen:true, gesicht:((window.apGsAn && apGsAn()) || undefined)})   /* AP-GRUPPE-3110 + AP-GESICHT-0111 */
      })
      .then(function(r){ return r.json(); })
      .then(function(data){
        var motiv = (data && data.motiv) || 'person';
        if(data && typeof data.personen==='number' && data.personen>=0){   /* AP-GRUPPE-3110: Zahl am Foto merken */
          var _ga=(window.st && st.familyFotos) || [];
          for(var _gi=0;_gi<_ga.length;_gi++){ if(_ga[_gi].dataUrl===dataUrl){ _ga[_gi].personen=data.personen; _ga[_gi].tiere=(typeof data.tiere==='number')?data.tiere:0; } }
          try{ apfUpdateMeta(); }catch(e){}
        }
        if(data && data.ok && _gsReq){ var _gq=(window.st && st.familyFotos) || []; for(var _gj=0;_gj<_gq.length;_gj++){ if(_gq[_gj].dataUrl===dataUrl) _gq[_gj].gp=1; } }   /* AP-GESICHT-FIX-0111: geprueft merken */
        if(data && data.gesicht && typeof data.gesicht.anteil==='number' && window.apGsAn && apGsAn()){   /* AP-GESICHT-0111 */
          var _gf=(window.st && st.familyFotos) || [];
          for(var _gk=0;_gk<_gf.length;_gk++){ if(_gf[_gk].dataUrl===dataUrl) _gf[_gk].gesicht=data.gesicht; }
          try{ apfRenderSlots(); }catch(e){}
        }
        if(APF_MOTIV_OK.indexOf(motiv) !== -1) return;
        var idx = -1;
        var arr = (window.st && st.familyFotos) || [];
        for(var i=0;i<arr.length;i++){ if(arr[i].dataUrl === dataUrl){ idx = i; break; } }
        if(idx !== -1){ st.familyFotos.splice(idx,1); apfRenderSlots(); }
        var labels = (window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?{'fahrzeug':'a vehicle','ort':'a location','gebaeude':'a building'}:{'fahrzeug':'ein Fahrzeug','ort':'einen Ort','gebaeude':'ein Gebäude'};
        apfMotivFehler('Das Foto zeigt '+(labels[motiv]||'kein passendes Motiv')+'. Bitte lade nur Fotos von Personen oder Tieren hoch.');
      })
      .catch(function(){});
    } catch(e){}
  };

  window.apfRenderSlots = function(){
    var wrap = document.getElementById('apfSlots');
    if(!wrap) return;
    var html = '';
    for(var i=0;i<Math.min(MAXF, Math.max(4, st.familyFotos.length+1));i++){   /* AP-ZEHN-A-0111: 4 Felder wie bisher, ab dem 4. Foto je eins mehr bis MAXF */
      var foto = st.familyFotos[i];
      var optional = (i>=MINF);
      if(foto){
        html += '<div class="apf-slot filled" style="position:relative;aspect-ratio:1/1;border-radius:12px;overflow:hidden;background:#ece7df;box-shadow:0 2px 10px rgba(26,23,20,.08)">'
             +    '<img src="'+foto.dataUrl+'" style="width:100%;height:100%;object-fit:contain;display:block">'
             +    apfResBadge(foto)
             +    apfGsBadge(foto, i)   /* AP-GESICHT-0111 */
             +    '<button type="button" onclick="apfRemove('+i+')" aria-label="Entfernen" style="position:absolute;top:6px;right:6px;width:30px;height:30px;border:none;border-radius:8px;background:rgba(20,18,16,.72);color:#fff;font-size:18px;line-height:1;cursor:pointer;z-index:2">&times;</button>'
             +    '<div style="position:absolute;bottom:0;left:0;right:0;padding:5px;background:linear-gradient(transparent,rgba(0,0,0,.55));color:#fff;font-size:11px;font-weight:700;text-align:center">'+window.T.fotoLbl+' '+(i+1)+'</div>'
             +  '</div>';
      } else {
        var istNaechster = (i === st.familyFotos.length);
        var opacity = istNaechster ? '1' : '.55';
        var border = istNaechster ? '2px solid var(--blush)' : '2px dashed #cfc8bf';
        html += '<div class="apf-slot empty" onclick="apfAddClick('+i+')" style="cursor:pointer;aspect-ratio:1/1;border-radius:12px;border:'+border+';background:#faf8f5;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;opacity:'+opacity+';transition:all .15s">'
             +    '<div style="font-size:22px">'+(optional?'➕':'📷')+'</div>'
             +    '<div style="font-size:11px;font-weight:700;color:var(--ink)">'+((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Photo':'Foto')+' '+(i+1)+'</div>'
             +    '<div style="font-size:11px;color:var(--ink-soft)">'+(optional?'optional':((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'People/pets':'Menschen/Tiere'))+'</div>'
             +  '</div>';
      }
    }
    wrap.innerHTML = html;
    apfUpdateMeta();
  };

  window.apfUpdateMeta = function(){
    var cnt = st.familyFotos.length;
    var cEl = document.getElementById('apfCount');
    var fEl = document.getElementById('apfFormat');
    var btn = document.getElementById('apfNextBtn');
    if(cEl){
      if(cnt===0) cEl.innerHTML = T.keinFoto;
      else if(cnt===1) cEl.innerHTML = T.einFoto;
      else {
        var abP = '';
        /* AP-ZEHN-A-0111: ab-Preis = kleinste erlaubte Groesse (Koepfe) + Aufpreis; Markt nach Domain (vorher zeigte /en die USD-Tabelle mit $) */
        try { var _tab = window.apAufUS() ? window.FAM_PREISE_US : window.FAM_PREISE, _c = _tab[String(cnt>4?4:cnt)].canvas, _k = (window.apKoepfeFotos ? apKoepfeFotos() : cnt), _g = ['s','m','l','xl'];
               for (var _i=0;_i<_g.length;_i++){ if (_c[_g[_i]] && _k <= (window.AP_GR_KOEPFE||{})[_g[_i]]) { abP = parseFloat(String(_c[_g[_i]]).replace(',','.')); break; } }
               var _au = window.apAuf ? apAuf(cnt) : null; if (abP && _au) abP += _au.betrag; } catch(e) { abP = ''; }
        cEl.innerHTML = cnt+' '+window.T.fotosHochgeladen
          + (abP ? ' &middot; '+(AP_L==='en'?'from ':'ab ')+window.apAufGeld(abP)+((window.apAuf && apAuf(cnt)) ? ' '+window.apAufTx('ab_inkl') : '') : '');
      }
    }
    var emp = fmtEmpfehlung(cnt);
    st.familyFormat = emp.fmt;
    try{ apfResBoxUpdate(false); }catch(e){}
    if(fEl){
      if(cnt>=MINF){ fEl.innerHTML = emp.txt; fEl.style.display='block'; }
      else fEl.style.display='none';
    }
    if(btn){
      if(cnt>=MINF){
        btn.disabled=false;
        btn.style.background='#36C25E';
        btn.style.cursor='pointer';
        btn.textContent=T.weiterStil;
      } else {
        btn.disabled=true;
        btn.style.background='#ccc';
        btn.style.cursor='not-allowed';
        btn.innerHTML=T.weiterFotos;
        btn.innerHTML=T.weiterFotos;
      }
    }
    try{ if(window.apAufHinweisReihe) apAufHinweisReihe(cnt); }catch(e){}   /* AP-ZEHN-A-0111 */
    /* AP-GRUPPE-3110: Hinweis 13 bis 20 unter dem Format, ueber 20 Knopf gesperrt (eigene Inline-Optik, Theme-CSS gilt nur in #ap) */
    var _g=apfGruppe(), _gen=((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'), gh=document.getElementById('apfGruppe');
    if(!gh && fEl && fEl.parentNode){
      gh=document.createElement('div'); gh.id='apfGruppe'; gh.setAttribute('role','status');
      gh.style.cssText='display:none;margin:10px auto 0;max-width:440px;padding:10px 14px;border-radius:10px;background:#FFF7E8;border:1px solid #F0DDB4;color:#4A453E;font-size:13px;font-weight:600;line-height:1.45;text-align:center';
      fEl.parentNode.insertBefore(gh, fEl.nextSibling);
    }
    if(gh){
      if(_g==='pruefen'){ gh.textContent=_gen?'With this many people, please check the preview carefully to make sure everyone is in it.':'Bei so vielen Personen: bitte die Vorschau genau prüfen, ob alle drauf sind.'; gh.style.display='block'; }
      else gh.style.display='none';
    }
    if(btn && _g==='sperre' && !st.busy){
      btn.disabled=true; btn.style.background='#A39A92'; btn.style.cursor='not-allowed';
      btn.textContent=window.apAufTx('max_pers',{n:AP_ZEHN.pers});
      if(!st._apfGruppeGezaehlt){ st._apfGruppeGezaehlt=true; try{ if(window.apZaehl) window.apZaehl('fehler', {error:'zu_viele_personen'}); }catch(e){} }
    }
  };

  window.apfAddClick = function(idx){
    if(st.familyFotos.length >= MAXF){ return; }
    st._apfTargetIdx = st.familyFotos.length;   // immer ans Ende anfuegen
    var fi = document.getElementById('apFileInput');
    if(fi){ fi.value=''; fi.setAttribute('data-apf','1'); fi.click(); }
  };

  window.apfRemove = function(idx){
    st.familyFotos.splice(idx,1);
    apfRenderSlots();
  };

  // eigener change-Handler NUR fuer Familien-Upload (data-apf gesetzt)
  var fi = document.getElementById('apFileInput');
  if(fi){
    fi.addEventListener('change', function(e){
      if(fi.getAttribute('data-apf')!=='1') return;   // normaler Flow unberuehrt
      fi.removeAttribute('data-apf');
      e.stopImmediatePropagation();   /* 15.10.: Einzel-Handler (Crop in st.fotoDataUrl) darf hier nicht mehr laufen */
      var f = e.target.files && e.target.files[0];
      if(!f) return;
      if(f.size > 20*1024*1024){ alert('Bitte ein Foto unter 20 MB waehlen.'); return; }
      var r = new FileReader();
      r.onload = function(ev){
        var orig = ev.target.result;
        var weiter = function(dataUrl, fileObj){
          if(st.familyFotos.length < MAXF){
            st.familyFotos.push({dataUrl: dataUrl, file: fileObj, orig: orig});
            apfRenderSlots();
            apfMotivCheck(dataUrl);
            apfResCheck(orig);   /* Ampel misst das Original (Quellqualitaet), nicht den Ausschnitt */
          }
        };
        /* 15.10.: Zuschnitt (eine Person, hochkant) landet jetzt in der Kachel */
        if(typeof window.apOpenCrop === 'function'){
          window.apOpenCrop(orig, 'ganz', function(cropped){   /* AP-FAM-GANZES-FOTO-3110: vorher 'hoch' = fest 2:3, Quer-Gruppenfotos verloren Personen */
            var cf = null; try{ cf = apDataUrlToFile(cropped, 'foto.jpg'); }catch(e){}
            weiter(cropped, cf || f);
          });
        } else { weiter(orig, f); }
      };
      window.apHeicFix(f).then(function(f2){ if(!f2) return; f=f2; r.readAsDataURL(f2); });
    }, true);   // capture: laeuft VOR dem alten Handler, stoppt dort per Guard
  }

  // AP-FOTOSPERRE-3010: Sperre <600 px, keine Rueckfrage, Ampel orange ab 600 px
  // Gesamt-Ampel-Box unter den Slots: Rot > Orange > Gruen ueber ALLE Fotos
  function apfResBoxUpdate(scrollBad){
    var el = document.getElementById('apfResWarn');
    if(!el) return;
    var rot=[], orange=0, unbekannt=0;
    for(var k=0;k<st.familyFotos.length;k++){
      var f=st.familyFotos[k];
      if(!f.w){ unbekannt++; continue; }
      var lang=Math.max(f.w,f.h);
      if(lang<600) rot.push(((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Photo':'Foto')+' '+(k+1)+' ('+f.w+'&times;'+f.h+')');
      else if(lang<2000) orange++;
    }
    function zeig(bg,border,farbe,html){ el.style.background=bg; el.style.borderColor=border; el.style.color=farbe; el.innerHTML=html; el.style.display='block'; }
    if(rot.length){
      zeig('#fdecea','#d93025','#9b1c1c','&#9888;&#65039; '+rot.join(', ')+(rot.length>1?' sind':' ist')+' recht klein. F&uuml;r beste &Auml;hnlichkeit bitte das Original direkt aus der Galerie verwenden, keine WhatsApp-Weiterleitungen oder Screenshots.');
      if(scrollBad){ try{ el.scrollIntoView({behavior:'smooth', block:'center'}); }catch(e){} }
    } else if(st.familyFotos.length && !unbekannt && orange===0){
      zeig('#e8f5e9','#1e7e34','#1e5e2e',((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'&#10003; All photos in top resolution. The best basis for your artwork.':'&#10003; Alle Fotos in Top Aufl&ouml;sung. Beste Grundlage f&uuml;r euer Kunstwerk.'));
    } else if(st.familyFotos.length && !unbekannt){
      zeig('#fff3d6','#e0a24b','#7a4308',window.T.auflOkay);
    } else { el.style.display='none'; }
  }
  window.apfResBoxUpdate = apfResBoxUpdate;

  // Ampel-Badge pro Kachel: Rot <1000, Orange 1000-1999, Gruen ab 2000 (lange Seite)
  function apfResBadge(foto){
    if(!foto || !foto.w) return '';
    var lang = Math.max(foto.w, foto.h);
    var bg, txt;
    if(lang >= 2000){ bg='#1e7e34'; txt='&#10003; Top Aufl&ouml;sung'; }
    else if(lang >= 600){ bg='#c77700'; txt=((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en')?'Okay':'Okay'; }
    else { bg='#d93025'; txt=window.T.kleineAufl; }
    return '<div style="position:absolute;top:6px;left:6px;z-index:2;background:'+bg+';color:#fff;font-size:10.5px;font-weight:700;padding:4px 8px;border-radius:8px;max-width:72%;line-height:1.25">'+txt+'</div>';
  }
  window.apfResBadge = apfResBadge;
  /* AP-GESICHT-0111: Gesichts-Hinweis je Foto. Nur Hinweis, nie Sperre. Schalter AP_AUFPREIS.c.gs (Theme-Einstellung ap_gesicht_an),
     DEV-Theme ?gesicht=1. Texte arturell.zehn.gs_* ueber apAufTx. Inline-Optik, weil Theme-CSS nur in #ap gilt. */
  window.apGsAn = function(){ var c = ((window.AP_AUFPREIS || {}).c) || {}; if(c.gs === true) return true;
    try{ if(String(window.Shopify&&Shopify.theme&&Shopify.theme.id)!=='192464027914') return false;   /* AP-GESICHT-FIX-0111: DEV-Schalter gilt fuer die ganze Sitzung */
      var q=/[?&]gesicht=([01])(&|$)/.exec(location.search);
      if(q){ try{ if(q[1]==='1') sessionStorage.setItem('apGsDev','1'); else sessionStorage.removeItem('apGsDev'); }catch(e2){} return q[1]==='1'; }
      return sessionStorage.getItem('apGsDev')==='1'; }catch(e){ return false; } };
  function apfGsTexte(foto, nr){
    var g = foto && foto.gesicht;
    if(!g || typeof g.anteil!=='number' || !window.apGsAn() || !window.apAufTx || !apAufTx('gs_trotzdem')) return null;
    var s=[], kurz='', zoom=false, w={n:nr}, n=g.n||1;
    if(g.augen_verdeckt){ s.push(apAufTx('gs_augen',w)); kurz=kurz||apAufTx('gs_kurz_augen'); }
    if(g.unscharf){ s.push(apAufTx(g.bildschirm?'gs_unscharf_bildschirm':'gs_unscharf',w)); kurz=kurz||apAufTx('gs_kurz_unscharf'); }
    else if(g.bildschirm){ s.push(apAufTx('gs_bildschirm',w)); kurz=kurz||apAufTx('gs_kurz_bildschirm'); }   /* Messung 01.11. 02:52: Bildschirmfoto 3/3 erkannt, unscharf 0/3 */
    if(g.klein){
      zoom = n<=2 && !!foto.orig && typeof g.grenze==='number' && g.anteil*3>=g.grenze && (!foto.h || g.anteil*foto.h>=150);
      s.push(apAufTx(n>2?'gs_klein_gruppe':(zoom?'gs_klein_zoom':'gs_klein_foto'),w)); kurz=kurz||apAufTx(n>2?'gs_kurz_gruppe':'gs_kurz_klein');
    }
    return s.length?{kurz:kurz,saetze:s,zoom:zoom}:null;
  }
  window.apfGsBadge = function(foto, i){
    var h=apfGsTexte(foto, i+1); if(!h) return '';
    return '<button type="button" class="apf-gs-badge" onclick="apfGsKlick()" style="position:absolute;left:6px;right:6px;bottom:28px;z-index:2;border:0;border-radius:8px;background:#B7791F;color:#fff;font-size:10.5px;font-weight:700;padding:4px 6px;line-height:1.25;cursor:pointer;width:auto;min-height:0;margin:0">'+h.kurz+'</button>';
  };
  window.apfGsKlick = function(){ var b=document.getElementById('apfGesicht'); if(b&&b.scrollIntoView) b.scrollIntoView({behavior:'smooth',block:'center'}); };
  window.apfGsCrop = function(i){
    var f=((window.st&&st.familyFotos)||[])[i]; if(!f||!f.orig||typeof window.apOpenCrop!=='function') return;
    window.apOpenCrop(f.orig, 'ganz', function(c){
      f.dataUrl=c; try{ var cf=apDataUrlToFile(c,'foto.jpg'); if(cf) f.file=cf; }catch(e){}
      f.gesicht=null; f.gp=0; apfRenderSlots(); apfMotivCheck(c);   /* AP-GESICHT-FIX-0111: neuer Ausschnitt = neu pruefen */
    });
  };
  window.apfGsBox = function(){
    var fs=(window.st&&st.familyFotos)||[], h='';
    for(var k=0;k<fs.length;k++){ var x=apfGsTexte(fs[k], k+1); if(!x) continue;
      h+='<p style="margin:0 0 6px">'+x.saetze.join(' ')+(x.zoom?' <button type="button" class="apf-gs-zoom" onclick="apfGsCrop('+k+')" style="border:0;background:none;color:#8A5A12;font-weight:700;text-decoration:underline;cursor:pointer;padding:0;margin:0;font-size:13px;min-height:0;width:auto">'+apAufTx('gs_knopf')+'</button>':'')+'</p>'; }
    var el=document.getElementById('apfGesicht'), an=document.getElementById('apfResWarn')||document.getElementById('apfSlots');
    if(!el && h && an && an.parentNode){ el=document.createElement('div'); el.id='apfGesicht'; el.setAttribute('role','status');
      el.style.cssText='margin:10px auto 0;max-width:440px;padding:10px 14px;border-radius:10px;background:#FFF8E8;border:1px solid #EFD9A6;color:#4A453E;font-size:13px;font-weight:500;line-height:1.45;text-align:left;box-sizing:border-box';
      an.parentNode.insertBefore(el, an.nextSibling); }
    if(el){ el.style.display=h?'block':'none'; el.innerHTML=h?h+'<p style="margin:0;color:#7A746B">'+apAufTx('gs_trotzdem')+'</p>':''; }
  };
  (function(){ var alt=window.apfRenderSlots; if(typeof alt!=='function'||alt.__gs) return;
    var neu=function(){ var r=alt.apply(this, arguments); try{ window.apfGsBox(); }catch(e){} return r; }; neu.__gs=1; window.apfRenderSlots=neu; })();

  // Aufloesungs-Check (18.07.): kleine/komprimierte Fotos = Hauptursache schlechter Aehnlichkeit
  function apfResCheck(dataUrl){
    try{
      var im = new Image();
      im.onload = function(){
        var lang = Math.max(im.naturalWidth, im.naturalHeight);
        for(var k=0;k<st.familyFotos.length;k++){ if(st.familyFotos[k].dataUrl === dataUrl || st.familyFotos[k].orig === dataUrl){ st.familyFotos[k].w = im.naturalWidth; st.familyFotos[k].h = im.naturalHeight; } }
        apfRenderSlots();
        apfResBoxUpdate(lang < 2000);
      };
      im.src = dataUrl;
    }catch(e){}
  }
  window.apfResCheck = apfResCheck;

  // Vollbild-Ladescreen fuer den Merge (18.07.)
  function apfMergeOv(show){
    var el = document.getElementById('apfMergeOv');
    if(show){
      if(!el){
        el = document.createElement('div');
        el.id = 'apfMergeOv';
        el.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(250,248,245,.9);backdrop-filter:blur(9px);-webkit-backdrop-filter:blur(9px);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:18px;text-align:center;padding:24px';
        el.innerHTML = '<div style="width:52px;height:52px;border:4px solid #E8DFD3;border-top-color:#D4847A;border-radius:50%;animation:apfSpin 1s linear infinite"></div>'
          + '<div id="apfMergeTxt" style="font-family:Georgia,serif;font-size:26px;color:#1A1714;max-width:520px">'+window.T_mergeTitle+'</div>'
          + '<div id="apfMergeSub" style="font-size:14px;color:#6b625a;max-width:380px">'+((st.familyFotos||[]).length>4?(AP_L==='en'?'This takes about two to three minutes. Please keep the page open.':'Das dauert etwa zwei bis drei Minuten. Bitte lass die Seite ge\u00f6ffnet.'):window.T_mergeSub)+'</div>';   /* AP-ZEHN-A-0111: gemessen 145 bis 160 s bei 9 bis 10 Personen */
        var TXT=window.T_mergeTxt;
        var ti=0; el._apfTxtIv=setInterval(function(){ var t=document.getElementById('apfMergeTxt'); if(!t){clearInterval(el._apfTxtIv);return;} ti=(ti+1)%TXT.length; t.textContent=TXT[ti]; },25000);
        var sty = document.createElement('style'); sty.textContent = '@keyframes apfSpin{to{transform:rotate(360deg)}}'; el.appendChild(sty);
        document.body.appendChild(el);
      }
      el.style.display = 'flex';
    } else if(el){ el.style.display = 'none'; if(el._apfTxtIv){clearInterval(el._apfTxtIv);el._apfTxtIv=null;} el.remove(); }
  }
  window.apfMergeOv = apfMergeOv;

  // Platzhalter bis Merge-Schritt gebaut ist
  window.APF_MERGE_PROMPTS = {
    '2_hoch':'Combine ALL people and ALL animals from the reference images into one unified family portrait photograph. Several reference images may show more than one person or animal - every single one of them belongs in the final image. Before composing, count every person and every animal across all reference images; the final image must contain exactly that many - never drop, add, duplicate, merge or swap anyone. Preserve EACH person\'s and each animal\'s exact facial identity, features and proportions. Place everyone close together, waist-up, as a loving pair or small group, heads at slightly different heights, nobody hidden behind another or cut off at the image edges; children and animals in front. Unify lighting across everyone: soft, warm, even, same direction. Vertical portrait composition, natural perspective, consistent skin tones, photorealistic. Neutral softly-lit studio background.',
    '3_hoch':'Combine ALL people and ALL animals from the reference images into one unified family portrait photograph. Several reference images may show more than one person or animal - every single one of them belongs in the final image. Before composing, count every person and every animal across all reference images; the final image must contain exactly that many - never drop, add, duplicate, merge or swap anyone. Preserve EACH person\'s and each animal\'s exact facial identity, features and proportions. Arrange everyone in a natural triangle composition (heads at different heights, not stacked), waist-up, standing close together as a family, nobody hidden behind another or cut off at the image edges; children and animals in front. Unify lighting across everyone: soft, warm, even, same direction. Vertical portrait composition, consistent perspective and skin tones, photorealistic. Neutral softly-lit background.',
    '4_quer':'Combine ALL people and ALL animals from the reference images into one unified family portrait photograph. Several reference images may show more than one person or animal - every single one of them belongs in the final image. Before composing, count every person and every animal across all reference images; the final image must contain exactly that many - never drop, add, duplicate, merge or swap anyone. Preserve EACH person\'s and each animal\'s exact facial identity, features and proportions. Arrange everyone side by side as one family group in overlapping triangles (varied head heights, nobody stacked directly above another), chest-up, close together, nobody hidden behind another or cut off at the image edges; children and animals in front. Unify lighting across everyone: soft, warm, even, same direction. Horizontal landscape composition, consistent perspective and skin tones, photorealistic. Neutral softly-lit background.'
  };

  window.apfNext = function(){
    if(st.familyFotos.length < MINF){ return; }
    if(st.busy) return;
    if(apfGruppe()==='sperre'){ apfToast(window.apAufTx('max_pers',{n:AP_ZEHN.pers})); return; }
    if(window.apAufOk && apAufOk() && st.familyFotos.length>=AP_ZEHN.ab && !(window.apGrant && apGrant()) && window.apfNlOpen){ window.__apAufMail=true; window.__apfFotosSichern=true; /* AP-GESICHT-FIX-0111: Fotos ueberleben die Freischaltung auch ab 5 Fotos */ window.apfNlOpen('form'); try{ if(window.apZaehl) window.apZaehl('mailgate_5'); }catch(e){} return; }   /* AP-ZEHN-A-0111: ab 5 Fotos erst die E-Mail-Bestaetigung */   /* AP-GRUPPE-3110 */
    var btn = document.getElementById('apfNextBtn');
    // Aufloesungs-Gate vor dem teuren Merge (18.07.): <1200 Block, 1200-1999 Bestaetigung
    var _blk=[], _wrn=[];
    for(var _k=0;_k<st.familyFotos.length;_k++){
      var _f=st.familyFotos[_k]; if(!_f.w) continue;
      var _lang=Math.max(_f.w,_f.h);
      if(_lang<600) _blk.push(((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Photo ':'Foto ')+(_k+1)+' ('+_f.w+'\u00d7'+_f.h+')');
      else if(false && _lang<2000) _wrn.push((((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en')?'Photo ':'Foto ')+(_k+1));
    }
    if(_blk.length){
      try{ apfResBoxUpdate(true); }catch(e){}
      var _msg = ((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en') ? (_blk.join(', ')+(_blk.length>1?' are':' is')+' too small to work with. Please use the original photo from your gallery.') : (_blk.join(', ')+(_blk.length>1?' sind':' ist')+' leider zu klein. Nimm bitte das Original aus deiner Galerie, dann klappt es.');
      try{ apfToast(_msg); }catch(e){ alert(_msg); }
      return;
    }
    var _isEn=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
    var _wrnMsg=_isEn
      ? (_wrn.join(', ')+(_wrn.length>1?' have':' has')+' a low resolution, so the likeness of the faces may visibly suffer. Continue anyway?')
      : (_wrn.join(', ')+(_wrn.length>1?' haben':' hat')+' eine kleine Aufl\u00f6sung, die \u00c4hnlichkeit der Gesichter kann darunter sichtbar leiden. Trotzdem fortfahren?');
    if(_wrn.length && !confirm(_wrnMsg)){
      return;
    }
    /* Groessen-Wache VOR dem Upload (Fund 21.08.): die Originale gehen
       unkomprimiert als base64 raus; Cloudflares Kante kappt bei 100 MB mit
       einer HTML-413 — auf Stadion-LTE hiesse das minutenlang hochladen und
       dann kryptisch sterben. Empirisch: 95 MB parst der Worker problemlos,
       ein echter 28-MB-Merge laeuft in ~74s durch — 90 MB ist die ehrliche
       Grenze knapp unter der Kante. */
    var _gesamt=0; st.familyFotos.forEach(function(f){ _gesamt+=((f&&f.dataUrl)||'').length; });
    if(_gesamt > 90*1024*1024){
      var _msgG=_isEn
        ? 'Your photos together are too large to merge. Please use slightly smaller photos (or fewer).'
        : 'Deine Fotos sind zusammen zu groß für die Zusammenführung. Bitte verwende etwas kleinere Fotos (oder weniger).';
      try{ apfToast(_msgG); }catch(e){ alert(_msgG); }
      return;
    }
    st.busy = true;
    if(btn){ btn.disabled=true; btn.innerHTML=T.merge; btn.classList.add('apf-merging'); btn.style.cursor='wait'; }
    apfMergeOv(true);
    var fmt = st.familyFormat || 'hoch';
    var key = st.familyFotos.length + '_' + fmt;
    var prompt = window.APF_MERGE_PROMPTS[key] || window.APF_MERGE_PROMPTS[st.familyFotos.length + '_hoch'] || (st.familyFotos.length > 4 ? window.APF_MERGE_PROMPTS['4_quer'] : null) || window.APF_MERGE_PROMPTS['3_hoch'];   /* AP-ZEHN-A-0111: ab 5 Fotos Aufbau wie 4 (wie Fast Track) */
    if(!window.APF_MERGE_PROMPTS[key]){   /* AP-GRUPPE-3110: quer bei 2/3 Fotos (viele Personen) -> Bildaufbau-Satz passend tauschen */
      prompt = fmt==='quer' ? prompt.replace('Vertical portrait composition','Horizontal landscape composition') : prompt.replace('Horizontal landscape composition','Vertical portrait composition');
    }
    prompt += ' Remove or replace any readable text, logos, brand names or prints on clothing with plain fabric in a matching color. No visible letters or words anywhere in the image. CRITICAL AGE LOCK: preserve each person\'s exact apparent age from their photo - keep all wrinkles, skin texture, age lines and age markers faithfully. Never de-age, rejuvenate, beautify or smooth anyone\'s face - and never make anyone look older either: do not deepen or add wrinkles beyond what each photo shows. CRITICAL EYE COLOUR LOCK: every person in this artwork keeps the EXACT eye colour from their own source photo. These colours differ from person to person. Look at each face separately and reproduce each individual eye colour precisely. NEVER unify, match, average or transfer eye colour between people, and never default anyone to brown or to blue.';
    var images = st.familyFotos.map(function(f){ return f.dataUrl; });
    /* APP-WECHSEL-FIX 25.10.: Zusammenfuehrung als Hintergrund-Job (Ergebnis wird abgeholt) */
    window.apJobSenden({ familyMerge:true, images:images, format:fmt, mergePrompt:prompt,
        /* 21.08.: Merge-Kontingent 2+3/Tag wird SERVERSEITIG durchgesetzt — dev/grant mitschicken */
        dev:(window.apDevId?window.apDevId():''), grant:(window.apGrant?window.apGrant():'') },
      'merge', function(d){ if(d===null){ _apfMergeNetz(); return; } _apfMergeFertig(d, fmt); }, {format:fmt, seite:'f', motive:st.familyFotos.length});
  };

  function _apfMergeFertig(d, fmt){
      var btn = document.getElementById('apfNextBtn');
      st.busy = false;
      if(d && d.ok && d.safeUrl){
        /* VORSCHAU-SCHUTZ (12.08.): der Browser kennt NUR den geschuetzten
           previewsafe_-Namen. Fuer die Stilisierung schicken wir genau diesen
           zurueck — der Worker loest ihn serverseitig auf die saubere Datei auf
           (customMetadata.orig). d.falUrl ist nur noch der veraltete Alias. */
        st.familyMotive = st.familyFotos.length || window.__apfMotive || 0; st.familyMergedUrl = d.safeUrl; st.familyMergedSafe = d.safeUrl; try{ window.apUpdatePrices && window.apUpdatePrices(); }catch(e){}
        if(typeof apfQuotaUse==='function')apfQuotaUse((st.familyMotive||0)>=5?2:1);   /* AP-MERGE-DOPPELT-ANZEIGE-0111 */
        st.format = fmt;
        st.foto = true;
        st.fotoDataUrl = d.safeUrl;
        st.fotoSmall = d.safeUrl;
        apfMergeOv(false);
        var hero = document.querySelector('#ap .ap-hero'); if(hero) hero.style.display='none';
        var ss = document.getElementById('apStileSection');
        if(ss){ ss.style.display='block'; if(window.apFilterStep2ByThema) try{apFilterStep2ByThema();}catch(e){} ss.scrollIntoView({behavior:'smooth',block:'start'}); }
      } else {
        apfMergeOv(false); if(btn){ btn.disabled=false; btn.classList.remove('apf-merging'); btn.innerHTML=T.retry; btn.style.background='#36C25E'; btn.style.cursor='pointer'; }
        if(window.apZaehl) window.apZaehl('fehler', (typeof d!=='undefined')?d:null);
        /* 21.08.: Geraete-Topf leer -> Mail-Fenster oeffnen statt Sackgassen-Alert
           (wie im Generieren-Flow); toter lokaler Grant wird verworfen. */
        if(d && d.error==='zu_viele_personen'){   /* AP-GRUPPE-3110: Worker hat vor der Erzeugung gesperrt, nichts angerechnet */
          st._apfGruppeServer=apfFotoSig(); try{ apfUpdateMeta(); }catch(e){}
          apfToast(window.apAufTx('max_pers',{n:AP_ZEHN.pers})); return;
        }
        if(d && d.error==='limit' && d.grund==='mailgate'){
          try{ localStorage.removeItem('apMailGrant'); }catch(e){}
          window.__apfFotosSichern=true;   /* AP-FAM-FOTOS-BEHALTEN-3110: Fotos ueberleben die Freischaltung */
          if(d.message) apfToast(d.message);
          if(window.apfNlOpen){ window.apfNlOpen('form'); return; }
        }
        if(d && d.error==='limit'){
          alert(d.message || 'Tageslimit erreicht. Morgen geht es weiter.');
          return;
        }
        alert(((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'The merge didn\'t work':'Die Zusammenführung hat nicht geklappt') + ((d && (d.message || d.error)) ? ':\n' + (d.message || d.error) : '.') + ((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'\n\nUsually helps: photos straight from your gallery (no screenshots), each face clearly visible. Give it another try, it\'s free.':'\n\nMeist hilft: Fotos direkt aus der Galerie (keine Screenshots), jedes Gesicht gut sichtbar. Versuch es gleich noch einmal, es kostet nichts.'));
      }
  }
  window.apfMergeFertig = _apfMergeFertig;
  function _apfMergeNetz(e){
      var btn = document.getElementById('apfNextBtn');
      if(window.apZaehl) window.apZaehl('fehler', (typeof d!=='undefined')?d:null);
      st.busy = false;
      console.warn('[apfNext merge]', e);
      apfMergeOv(false); if(btn){ btn.disabled=false; btn.classList.remove('apf-merging'); btn.innerHTML=T.retry; btn.style.background='#36C25E'; btn.style.cursor='pointer'; }
      alert((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Connection error. Please try again.':'Verbindungsfehler. Bitte erneut versuchen.');
  }

  // initial rendern sobald DOM da
  if(document.readyState!=='loading') apfRenderSlots();
  else document.addEventListener('DOMContentLoaded', apfRenderSlots);
})();

/* Original-Kachel: Platzhalter bis Patch B (Direkt-Werk-Logik) */
window.apOriginalWaehlen=function(){
  if(window.st && st.familyMergedUrl){ st.stil='original'; st.stilName=(AP_L==='en'?'Original \u00b7 Photo Portrait':'Original \u00b7 Fotoportr\u00e4t'); window.zeigResult(st.familyMergedSafe || st.familyMergedUrl); return; }
  var m='Das Original-Fotoportr\u00e4t entsteht bei der Zusammenf\u00fchrung deiner Fotos. Starte oben mit euren Familienfotos.';
  if(typeof apfToast==='function'){apfToast(m);}else{alert(m);}
};
/* build 1784632539 */
/* build 1784632575 */
/* build 1784633179 */
/* build 1784634192 */
/* build 1784634620 */
/* build 1784635744 */
/* build 1784712404 */
/* build 1784712508 */
/* build 1784712585 */
/* build 1784712713 */
/* build 1784712816 */
/* build 1784712939 */
/* build 1784713005 */
/* build 1784713095 */
/* build-1785177570 */
/* build-1785178013 */
/* build-1785178331 */

/* == AP-KAUFKASTEN-3110 (31.10.2026): Kaufkasten direkt unter der Vorschau ==
   Baut keinen neuen Kaufweg. Spiegelt Material, Groesse, Rahmenfarbe und Preis aus den
   vorhandenen Knoepfen (#ap .ap-mat-btn, .ap-size-btn, .ap-farbe-btn, #apPriceNow; Preise
   kommen dort aus AP_PREISE / FAM_PREISE) und loest beim Klick dieselben Wege aus:
   window.apMaterial, window.apSize, window.apFarbe, window.apBuy (wie "Jetzt bestellen":
   in den Warenkorb, dann /cart). Aktion (AP-AKTION-33-3010, AP-TIEFST-3010) und Lieferdatum
   (AP-LIEFERDATUM-3010) werden nur gespiegelt; die Datums-Freischaltung bleibt im Original.
   Steht bewusst NACH allen Wrappern und ausserhalb der Haupt-Closure: nutzt nur window.* */
(function(){
  if (window.__apKk) return; window.__apKk = true;
  function init(){
    var kk = document.getElementById('apKk'); if (!kk) return;
    var apEl = document.getElementById('ap');
    function q(s, r){ return (r || document).querySelector(s); }
    function qa(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }
    function an(el){ return !!el && el.style.display !== 'none'; }
    function zaehl(e){ try { if (window.apZaehl) window.apZaehl(e); } catch(_){} }
    var t = 0, sig = '';
    function bald(){ if (t) return; t = setTimeout(function(){ t = 0; try { sync(); } catch(e){ try { console.warn('[Kaufkasten]', e); } catch(_){} } }, 40); }
    var sel = q('#apKkSize', kk), dots = q('#apKkDots', kk);
    var LKW = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    /* Rahmenfarben einmal aus den vorhandenen Knoepfen bauen (Name + Punktfarbe) */
    if (dots) qa('#apFarbe .ap-farbe-btn').forEach(function(o){
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ap-kk-farbe';
      b.setAttribute('data-farbe', o.getAttribute('data-farbe') || '');
      var nm = (o.textContent || '').trim(); b.setAttribute('aria-label', nm); b.title = nm;
      var d = o.querySelector('.ap-farbe-dot'); if (d) b.style.background = d.style.background;
      dots.appendChild(b);
    });
    function sync(){
      var st = window.st || {};
      var ri = q('#apResultImg');
      var zeigen = !!st.artUrl || !!(ri && /^https?:/.test(ri.getAttribute('src') || ''));
      kk.classList.toggle('on', zeigen);
      if (apEl) apEl.classList.toggle('ap-kk-an', zeigen);
      /* Material */
      var mo = q('#ap .ap-mat-btn.on'), m = mo ? mo.getAttribute('data-mat') : 'canvas';
      qa('.ap-kk-mat', kk).forEach(function(b){ var on = b.getAttribute('data-mat') === m; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      /* Rahmenfarbe nur, wenn die vorhandene Farbwahl sichtbar ist (gerahmt) */
      var fz = q('#apKkFarben', kk); if (fz) fz.style.display = an(q('#apFarbe')) ? '' : 'none';
      var fon = q('#apFarbe .ap-farbe-btn.on'), fn = q('#apKkFname', kk);
      qa('.ap-kk-farbe', kk).forEach(function(b){ b.classList.toggle('on', !!fon && b.getAttribute('data-farbe') === fon.getAttribute('data-farbe')); });
      if (fn) fn.textContent = fon ? (fon.textContent || '').trim() : '';
      /* Groessen: nur sichtbare Knoepfe mit Preis (L gerahmt EU und XXL sind ausgeblendet) */
      var opts = [], cur = '';
      qa('#ap .ap-size-grid .ap-size-btn').forEach(function(b){
        if (!an(b) || b.disabled) return;   /* AP-ZEHN-A-0111: gesperrte Groesse nicht im Kaufkasten */
        var pr = q('.sz-price', b), lb = q('.sz-label', b), cm = q('.sz-cm', b);
        var p = pr ? pr.textContent.trim() : ''; if (!p) return;
        var sz = b.getAttribute('data-size') || '';
        opts.push([sz, [lb ? lb.textContent.trim() : sz.toUpperCase(), cm ? cm.textContent.trim() : '', p].filter(Boolean).join(' · ')]);
        if (b.classList.contains('on')) cur = sz;
      });
      var s2 = JSON.stringify(opts);
      if (sel && s2 !== sig){
        sig = s2; while (sel.firstChild) sel.removeChild(sel.firstChild);
        opts.forEach(function(o){ var op = document.createElement('option'); op.value = o[0]; op.textContent = o[1]; sel.appendChild(op); });
      }
      if (sel && cur) sel.value = cur;
      /* Preis: derselbe Wert wie im Preisblock und auf "Jetzt bestellen" */
      var pn = q('#apPriceNow'), kp = q('#apKkPreis', kk);
      if (pn && kp) kp.textContent = (pn.textContent || '').trim();
      /* Aktion spiegeln, nur wenn das Original freigeschaltet ist */
      var ab = q('#apAktionBox'), ka = q('#apKkAktion', kk);
      if (ka){
        var akt = !!ab && ab.style.display === 'block';
        if (akt && !ka.firstChild){ var c = ab.cloneNode(true); c.removeAttribute('id'); c.style.display = 'block'; ka.appendChild(c); }
        ka.style.display = akt ? '' : 'none';
      }
      var tz = q('#apTiefst'), kt = q('#apKkTiefst', kk);
      if (kt){ var tan = !!tz && tz.style.display === 'block' && !!tz.innerHTML; kt.innerHTML = tan ? tz.innerHTML : ''; kt.style.display = tan ? 'block' : 'none'; }
      /* Lieferdatum spiegeln */
      var ld = q('#apLieferDatum'), kl = q('#apKkLiefer', kk);
      if (kl){
        var lan = !!ld && ld.style.display === 'block' && !!(ld.textContent || '').trim();
        kl.innerHTML = ''; if (lan){ kl.innerHTML = LKW; var sp = document.createElement('span'); sp.textContent = ld.textContent.trim(); kl.appendChild(sp); }
        kl.style.display = lan ? '' : 'none';
      }
    }
    kk.addEventListener('click', function(ev){
      var x = ev.target; if (!x || !x.closest) return;
      var mb = x.closest('.ap-kk-mat');
      if (mb){
        var o = q('#ap .ap-mat-btns .ap-mat-btn[data-mat="' + mb.getAttribute('data-mat') + '"]');
        if (o && !o.classList.contains('on') && typeof window.apMaterial === 'function'){ window.apMaterial(o); zaehl('material'); }
        bald(); return;
      }
      var fb = x.closest('.ap-kk-farbe');
      if (fb){
        var of = q('#apFarbe .ap-farbe-btn[data-farbe="' + fb.getAttribute('data-farbe') + '"]');
        if (of && typeof window.apFarbe === 'function') window.apFarbe(of);
        bald(); return;
      }
      if (x.closest('#apKkBuy')){ if (typeof window.apBuy === 'function') window.apBuy(); return; }
      if (x.closest('#apKkMehr')){
        if (typeof window.apAccOpen === 'function') window.apAccOpen(5, true);
        var s5 = q('#apAccStep5') || q('#apAcc'); if (s5 && s5.scrollIntoView) s5.scrollIntoView({behavior: 'smooth', block: 'start'});
        return;
      }
    });
    if (sel) sel.addEventListener('change', function(){
      var o = q('#ap .ap-size-grid .ap-size-btn[data-size="' + sel.value + '"]');
      if (o && typeof window.apSize === 'function'){ window.apSize(o); zaehl('groesse'); }
      bald();
    });
    if (window.MutationObserver){
      var mob = new MutationObserver(bald), A = {attributes: true, subtree: true, childList: true, characterData: true};
      [['#apPriceNow', A], ['#ap .ap-mat-btns', A], ['#ap .ap-size-grid', A], ['#apFarbe', A], ['#apTiefst', A],
       ['#apAktionBox', {attributes: true}], ['#apLieferDatum', A], ['#apResultImg', {attributes: true}], ['#apResultSection', {attributes: true}]
      ].forEach(function(z){ var el = q(z[0]); if (el) mob.observe(el, z[1]); });
    }
    var img = q('#apResultImg'); if (img) img.addEventListener('load', bald);
    window.apKkSync = function(){ try { sync(); } catch(e){} };
    sync();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  /* Zurueck aus dem Warenkorb (bfcache): Kauf-Sperre loesen, sonst bleibt jeder Kaufknopf stumm */
  window.addEventListener('pageshow', function(e){
    try { if (e && e.persisted && window.st) window.st.kaufLaeuft = false; } catch(_){}
    if (window.apKkSync) window.apKkSync();
  });
})();

/* ── ZAEHLSTELLEN 23.10.2026: anonyme Tageszaehler Kaufweg (kein Cookie, kein Speicher, keine Kennung) ── */
(function(){
  if (window.__apZaehler) return; window.__apZaehler = true;
  var SEITE = 'f';
  var ZIEL = 'https://arturell-preview.arturell.workers.dev/z';
  var markt = (function(){
    try {
      if (navigator.webdriver || (window.Shopify && Shopify.theme && String(Shopify.theme.id) === '192464027914')) return 'dev';
      if (location.hostname.indexOf('us.') === 0) return 'us';
      if (location.pathname === '/en' || location.pathname.indexOf('/en/') === 0) return 'en';
    } catch(e) {}
    return 'de';
  })();
  var schon = {};
  function apFehlerKat(d){ if(!d) return 'netz'; var e=String(d.error||''); if(e==='limit') return d.grund==='mailgate'?'mailgate':'limit'; if(e==='watermark') return 'server'; if(e==='zu_viele_personen') return 'gruppe'; if(['bot','safety','quality','server','zeit'].indexOf(e)>=0) return e; return 'sonst'; }
  function z(e, d){
    if (e === 'fehler') { try { var _k = 'f_' + apFehlerKat(d); if (_k !== e) z(_k); } catch(_) {} }
    if (schon[e]) return; schon[e] = true;
    var u = ZIEL + '?e=' + e + '&s=' + SEITE + '&m=' + markt;
    try { if (navigator.sendBeacon && navigator.sendBeacon(u)) return; } catch(_) {}
    try { fetch(u, { method: 'POST', mode: 'no-cors', keepalive: true }); } catch(_) {}
  }
  window.apZaehl = z;
  window.apZaehlStand = function(){ return { seite: SEITE, markt: markt, gezaehlt: Object.keys(schon) }; };
  document.addEventListener('click', function(ev){
    var t = ev.target; if (!t || !t.closest) return;
    if (t.closest('.ap-size-btn')) z('groesse');
    else if (t.closest('.ap-mat-btn')) z('material');
    else if (t.closest('.ap-buy-btn')) z('kaufen');
    else if (t.closest('.ap-cart-btn')) z('warenkorb');
    else if (t.closest('.ap-dl-btn')) z('download');
    else if (t.closest('.ap-bundle-btn')) z('popup_kauf');
    else if (t.closest('.ap-bundle-close') || t.closest('.ap-bundle-skip')) z('popup_zu');
  }, true);
  function beobachte(){
    var img = document.getElementById('apResultImg');
    if (img) img.addEventListener('load', function(){ if (img.src && img.src.indexOf('http') === 0) z('vorschau'); });
    var pop = document.getElementById('apBundlePopup');
    if (pop && window.MutationObserver) new MutationObserver(function(){ if (pop.classList.contains('on')) z('popup'); }).observe(pop, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState !== 'loading') beobachte(); else document.addEventListener('DOMContentLoaded', beobachte);
})();

/* ── DEV-TESTKNOPF 24.10.2026: nur DEV-Theme 192464027914 (Rolle nicht main), nie LIVE. Galerie bleibt unveraendert. ── */
(function(){
  try {
    if (!(window.Shopify && Shopify.theme && String(Shopify.theme.id) === '192464027914' && Shopify.theme.role !== 'main')) return;
  } catch(e) { return; }
  var KEY = 'arturell_familie_v1';
  var BILD = 'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-aquarell.jpg';
  window.apDevTest = function(){
    var zr = (typeof zeigResult === 'function') ? zeigResult : window.zeigResult;
    var _st = (typeof st === 'object' && st) ? st : window.st;   /* 25.10.: Shopify kapselt die Datei, window.st fehlt */
    if (!_st || !zr) { console.log('[DEV-Test] st oder zeigResult fehlt'); return; }
    if (!window.st) window.st = _st;
    /* AP-DEVKNOPF-LEEREN-2910 */ try { localStorage.removeItem(KEY); } catch(e) {} if (st.artHistory) st.artHistory = [];
    var g = st.genCount;
    try {
      var cv = document.createElement('canvas'); cv.width = 800; cv.height = 1000;
      var cx = cv.getContext('2d'); cx.fillStyle = '#9AAE8C'; cx.fillRect(0, 0, 800, 1000);
      cx.fillStyle = '#3E4A38'; cx.font = 'bold 64px sans-serif'; cx.textAlign = 'center'; cx.fillText('TEST-FOTO', 400, 520);
      st.fotoDataUrl = cv.toDataURL('image/jpeg', 0.85); st.fotoSmall = st.fotoDataUrl; st.fotoRatio = 0.8;
      cv.toBlob(function(b){ if (b) st.foto = new File([b], 'test.jpg', {type: 'image/jpeg'}); }, 'image/jpeg', 0.85);
    } catch(e) { console.warn('[DEV-Test] Test-Foto fehlgeschlagen', e); }
    zr(BILD);
    st.genCount = g;
    try { if (typeof apRenderDeineWerke === 'function') apRenderDeineWerke(); } catch(e) {}
    console.log('[DEV-Test] Galerie ' + KEY + ' geleert, Bearbeitungsmodus offen');
  };
  function knopf(){
    if (document.getElementById('apDevTestBtn')) return;
    var b = document.createElement('button');
    b.id = 'apDevTestBtn'; b.type = 'button';
    b.textContent = '\uD83E\uDDEA Bearbeiten testen (DEV)';
    b.setAttribute('style', 'position:fixed;bottom:90px;right:16px;z-index:99999;background:#E8662A;color:#fff;border:none;border-radius:24px;padding:12px 18px;font:700 13px/1.2 sans-serif;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,.25)');
    b.onclick = function(){ window.apDevTest(); };
    document.body.appendChild(b);
  }
  if (document.readyState !== 'loading') knopf(); else document.addEventListener('DOMContentLoaded', knopf);
})();

/* APP-WECHSEL-FIX 25.10.: lief beim Neuladen noch eine Zusammenfuehrung oder Generierung? -> abholen */
(function(){
  function weiter(){
    try{
      var j=window.apJobGemerkt&&window.apJobGemerkt(); if(!j||j.seite!=='f'||!window.st||st.busy) return;
      if(j.art==='merge' && window.apfMergeFertig){
        st.busy=true; window.__apfMotive=j.motive||0; if(window.apfMergeOv) window.apfMergeOv(true); if(window.apLadeHinweis2) window.apLadeHinweis2();
        window.apJobWarten(j.job, function(d){
          if(d===null){ st.busy=false; if(window.apfMergeOv) window.apfMergeOv(false); return; }
          window.apfMergeFertig(d, j.format||'hoch');
        }, {ersteMs:400, maxUnbekannt:3, rueckkehr:true});
      } else if(j.art==='gen'){
        st.busy=true; window.__apOhneStart=true; apLadeStart(); window.__apOhneStart=false;
        if(window.apLadeHinweis2) window.apLadeHinweis2();
        window.apJobWarten(j.job, function(d){
          st.busy=false; apLadeStop();
          try{ document.getElementById('apSpin').style.display='none'; var b=document.getElementById('apGenBtn'); if(b) b.disabled=false; apSyncGenBtn(); }catch(e){}
          if(d&&d.ok&&d.preview){ st.stil=j.stil||st.stil; st.stilName=j.stilName||st.stilName; if(j.format) st.format=j.format; zeigResult(d.preview); }
          else if(d){ if(window.apZaehl) window.apZaehl('fehler', (typeof d!=='undefined')?d:null); }
        }, {ersteMs:400, maxUnbekannt:3, rueckkehr:true});
      }
    }catch(e){ console.warn('[Job-Wiederaufnahme]', e); }
  }
  if(document.readyState!=='loading') setTimeout(weiter, 1200);
  else document.addEventListener('DOMContentLoaded', function(){ setTimeout(weiter, 1200); });
})();

/* == AP-ZEHN-A-0111 (01.11.2026): Groessensperre nach Koepfen, Preiszeile mit Aufpreis, Mail-Text ab 5 Fotos ==
   Steht nach allen Wrappern und nach dem Kaufkasten, nutzt nur window.* (fmt/apIsUS/apPreisTab liegen in einer Closure).
   Sperre: Koepfe (Personen + Tiere, mind. 1 je Foto) > Grenze der Groesse (S 4, M 7, L/XL 10) -> Knopf grau, "bis N Personen",
   Auswahl springt auf die kleinste erlaubte Groesse, Kauf mit gesperrter Groesse wird nicht ausgeloest. */
(function(){
  if (window.__apZehnA) return; window.__apZehnA = true;
  function en(){ return window.apAufEN(); }
  function geld(v){ return window.apAufGeld(v); }
  function pfmt(v){ return window.apAufUS() ? ('$' + String(v)) : (String(v).replace('.', ',') + ' \u20ac'); }
  window.apKoepfeFotos = function(){ var k = 0; ((window.st && st.familyFotos) || []).forEach(function(f){ var p = (typeof f.personen === 'number' ? f.personen : 0) + (typeof f.tiere === 'number' ? f.tiere : 0); k += Math.max(1, p); }); return k; };
  window.apKoepfe = function(){
    var s = window.st || {}; if (!s.familyMergedUrl) return 0;
    var n = parseInt(s.familyMotive, 10) || 0, f = s.familyFotos || [];
    return (f.length && f.length === n) ? Math.max(n, window.apKoepfeFotos()) : n;
  };
  function erlaubt(gr, k){ var g = (window.AP_GR_KOEPFE || {})[gr]; return !k || !g || k <= g; }
  function tx(k, w){ return window.apAufTx(k, w); }
  function warum(){
    return '<details style="margin-top:4px"><summary style="cursor:pointer;text-decoration:underline;text-underline-offset:3px">' + tx('warum_titel') + '</summary><span style="display:block;margin-top:6px;font-size:12.5px;line-height:1.45;color:#6B625C">' + tx('warum') + '</span></details>';
  }
  function zeile(p, au){ return tx('zeile', { s:geld(p + au.betrag), k:geld(p), z:geld(au.betrag), st:window.apAufStufeText(au.st) }); }
  function el(id, nach, stil){
    var e = document.getElementById(id); if (e) return e;
    if (!nach || !nach.parentNode) return null;
    e = document.createElement('div'); e.id = id; e.setAttribute('role', 'status'); e.style.cssText = stil; nach.parentNode.insertBefore(e, nach.nextSibling); return e;
  }
  /* Fotoreihe: Hinweis ab dem 5. Foto (aufgerufen aus apfUpdateMeta) */
  window.apAufHinweisReihe = function(cnt){
    var c = document.getElementById('apfCount'); if (!c) return;
    var h = el('apfAufHinweis', c, 'display:none;margin:10px auto 0;max-width:440px;padding:10px 14px;border-radius:10px;background:#F2F7F3;border:1px solid #C9DCCE;color:#4A453E;font-size:13px;font-weight:500;line-height:1.45;text-align:left');
    if (!h) return;
    var an = !!(window.apAufOk && apAufOk()) && cnt >= window.AP_ZEHN.ab;
    if (!an) { h.style.display = 'none'; return; }
    var t = tx('reihe', { a:geld(apAufBetrag('5-7')), b:geld(apAufBetrag('8-10')) });
    h.innerHTML = '<span>' + t + '</span>' + warum(); h.style.display = 'block';
  };
  var laeuft = false;
  function pruefen(){
    if (laeuft) return; laeuft = true;
    try {
      var s = window.st || {}, fam = !!s.familyMergedUrl, k = fam ? window.apKoepfe() : 0, tab = null;
      try { tab = fam ? window.apAufTab() : null; } catch(e){}
      var erst = null, curOk = false, gesp = [];
      [].slice.call(document.querySelectorAll('#ap .ap-size-grid .ap-size-btn')).forEach(function(b){
        var gr = b.getAttribute('data-size'), sichtbar = b.style.display !== 'none', pr = b.querySelector('.sz-price');
        var ok = erlaubt(gr, fam ? k : 0) && !!(tab && tab[gr]);
        if (!ok && fam && tab && tab[gr]) {
          gesp.push(gr); b.disabled = true; b.setAttribute('aria-disabled', 'true'); b.classList.add('apz-aus'); b.style.opacity = '.45'; b.style.cursor = 'not-allowed';
          if (pr) pr.textContent = tx('gr_gesperrt', { n:window.AP_GR_KOEPFE[gr] });
        } else if (b.classList.contains('apz-aus')) {
          b.disabled = false; b.removeAttribute('aria-disabled'); b.classList.remove('apz-aus'); b.style.opacity = ''; b.style.cursor = '';
          if (pr && tab && tab[gr]) { pr.textContent = pfmt(tab[gr]); b.dataset.price = String(tab[gr]).replace(',', '.'); }
        }
        if (!b.disabled && sichtbar && tab && tab[gr]) { if (!erst) erst = b; if (b.classList.contains('on')) curOk = true; }
      });
      if (fam && !curOk && erst && typeof window.apSize === 'function') window.apSize(erst);
      /* Hinweis unter den Groessen */
      var grid = document.querySelector('#ap .ap-size-grid');
      var gh = el('apZehnGr', grid, 'display:none;margin:10px 0 0;font-size:12.5px;line-height:1.45;color:#4A453E');
      if (gh) {
        if (gesp.length) {
          var ab0 = erst ? (erst.getAttribute('data-size') || '').toUpperCase() : '';
          gh.textContent = tx('gr_hinweis', { n:k, g:ab0 });
          gh.style.display = 'block';
        } else gh.style.display = 'none';
      }
      /* Preiszeile mit Aufpreis: unter dem Preisblock und im Kaufkasten (vor dem Warenkorb) */
      var au = fam && window.apAuf ? apAuf(s.familyMotive) : null, p = parseFloat(s.price) || 0;
      var html = (au && p) ? '<span>' + zeile(p, au) + '</span>' + warum() : '';
      [['apAufZeile', document.getElementById('apTiefst') || (document.getElementById('apPriceNow') || {}).parentNode],
       ['apKkAuf', document.getElementById('apKkTiefst')]].forEach(function(z){
        var e = el(z[0], z[1], 'display:none;margin:8px 0 0;font-size:13px;line-height:1.45;color:#3D3530;text-align:left');
        if (!e) return;
        if (html) { if (e.getAttribute('data-h') !== html) { e.innerHTML = html; e.setAttribute('data-h', html); } e.style.display = 'block'; } else e.style.display = 'none';
      });
    } catch(e){ try { console.warn('[AP-ZEHN-A-0111]', e); } catch(_){} }
    finally { laeuft = false; }
  }
  window.apZehnPruefen = pruefen;
  var _up = window.apUpdatePrices, _mat = window.apMaterial, _sz = window.apSize, _buy = window.apBuy, _nl = window.apfNlOpen, _uc = window.apUpdateCurrentPrice;
  if (typeof _up === 'function') window.apUpdatePrices = function(){ var r = _up.apply(this, arguments); pruefen(); return r; };
  if (typeof _uc === 'function') window.apUpdateCurrentPrice = function(){ var r = _uc.apply(this, arguments); pruefen(); return r; };
  if (typeof _mat === 'function') window.apMaterial = function(){ var r = _mat.apply(this, arguments); pruefen(); return r; };
  if (typeof _sz === 'function') window.apSize = function(b){ if (b && b.disabled) return; var r = _sz.apply(this, arguments); if (!laeuft) pruefen(); return r; };
  if (typeof _buy === 'function') window.apBuy = function(){
    var s = window.st || {};
    if (s.familyMergedUrl && !erlaubt(s.size, window.apKoepfe())) { pruefen(); return; }
    return _buy.apply(this, arguments);
  };
  /* Mail-Fenster ab 5 Fotos: eigener kurzer Text, sonst der bisherige */
  if (typeof _nl === 'function') window.apfNlOpen = function(view){
    var f = document.getElementById('apfNlViewForm'), sub = f && f.querySelector('.apf-nl-sub');
    if (sub) {
      if (!sub.hasAttribute('data-orig')) sub.setAttribute('data-orig', sub.innerHTML);
      if (window.__apAufMail) sub.textContent = tx('mail');
      else sub.innerHTML = sub.getAttribute('data-orig');
    }
    window.__apAufMail = false;
    return _nl.apply(this, arguments);
  };
  if (document.readyState !== 'loading') pruefen(); else document.addEventListener('DOMContentLoaded', pruefen);
})();
